var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 634,
    viewBox: "0 0 1920 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6001_44765)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 634,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1920.5,
    height: 1080,
    fill: "url(#paint0_linear_6001_44765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.564 910.13V879.393C228.564 719.414 354.528 588.046 513.763 580.858L527.406 566.907C354.918 566.907 214.927 706.718 214.927 879.387V910.124H228.57L228.564 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6097 910.13V879.393C31.6097 719.414 157.574 588.046 316.809 580.858L330.452 566.907C157.964 566.907 17.9727 706.718 17.9727 879.387V910.124H31.6156L31.6097 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.553 910.13V879.393C401.553 719.42 527.512 588.046 686.753 580.858L700.396 566.907C527.907 566.907 387.916 706.718 387.916 879.387V910.124H401.559L401.553 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.542 910.13V879.393C574.542 719.425 700.495 588.046 859.742 580.858L873.385 566.907C700.896 566.907 560.905 706.718 560.905 879.387V910.124H574.548L574.542 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.533 910.13V879.393C747.533 719.431 873.48 588.046 1032.73 580.858L1046.38 566.907C873.886 566.907 733.896 706.718 733.896 879.387V910.124H747.538L747.533 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.518 910.13V879.393C920.518 719.437 1046.46 588.046 1205.72 580.858L1219.36 566.907C1046.87 566.907 906.881 706.718 906.881 879.387V910.124H920.524L920.518 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.52 910.13V879.393C1093.52 719.443 1219.46 588.046 1378.72 580.858L1392.36 566.907C1219.87 566.907 1079.88 706.718 1079.88 879.387V910.124H1093.53L1093.52 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.51 910.13V879.393C1266.51 719.449 1392.44 588.046 1551.71 580.858L1565.35 566.907C1392.86 566.907 1252.87 706.718 1252.87 879.387V910.124H1266.51L1266.51 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.5 910.13V879.393C1439.5 719.454 1565.42 588.046 1724.7 580.858L1738.34 566.907C1565.85 566.907 1425.86 706.718 1425.86 879.387V910.124H1439.5L1439.5 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.41 910.13V879.393C1619.41 719.454 1745.33 588.046 1904.61 580.858L1918.25 566.907C1745.76 566.907 1605.77 706.718 1605.77 879.387V910.124H1619.41L1619.41 910.13Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.75 910.131V877.988C1797.75 777.345 1847.62 687.998 1924.28 633.793V617.279C1839.83 673.205 1784.12 769.06 1784.12 877.988V910.131H1797.76H1797.75Z",
    fill: "#BEAEAE",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.79 605.742H-5.7207V623.603H1923.79V605.742Z",
    fill: "#BEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6164 632.488V701.365C67.6164 703.248 66.0882 704.776 64.2056 704.776C62.3231 704.776 60.7949 703.248 60.7949 701.365V632.488H67.6164Z",
    fill: "#ECC0BC",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.629 632.488V703.823C131.629 705.706 130.101 707.234 128.218 707.234C126.336 707.234 124.808 705.706 124.808 703.823V632.488H131.629Z",
    fill: "#ECC0BC",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.676 632.364V701.241C500.676 703.124 499.148 704.652 497.265 704.652C495.383 704.652 493.854 703.124 493.854 701.241V632.364H500.676Z",
    fill: "#CBB4B2",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.933 632.364V701.241C612.933 703.124 611.405 704.652 609.522 704.652C607.639 704.652 606.111 703.124 606.111 701.241V632.364H612.933Z",
    fill: "#CBB4B2",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.51 632.364V701.241C1544.51 703.124 1542.98 704.652 1541.1 704.652C1539.21 704.652 1537.69 703.124 1537.69 701.241V632.364H1544.51Z",
    fill: "#CBB4B2",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.77 632.364V701.241C1656.77 703.124 1655.24 704.652 1653.36 704.652C1651.47 704.652 1649.95 703.124 1649.95 701.241V632.364H1656.77Z",
    fill: "#CBB4B2",
    stroke: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-0.347656 1098.45V618.643L1919.65 617.916V1098.45H-0.347656Z",
    fill: "url(#paint1_linear_6001_44765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.51 634.194V612.326L-3.66809 612.326V634.194L1925.51 634.194Z",
    fill: "url(#paint2_linear_6001_44765)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.044 321.269H295.012V321.31H295.044V321.269Z",
    fill: "url(#paint3_linear_6001_44765)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1655.99 197.734L1657.56 109.124L1660.19 197.986C1660.78 197.986 1661.26 198.467 1661.26 199.054V209.704H1662.33C1662.92 209.704 1663.4 210.185 1663.4 210.772V215.066C1664.18 215.775 1664.7 216.761 1664.8 217.878L1665.02 220.648C1665.37 224.706 1665.36 228.789 1664.98 232.847L1664.82 234.591C1664.64 236.546 1663.15 238.095 1661.26 238.404V248.044H1662.33C1662.92 248.044 1663.4 248.525 1663.4 249.112V250.179C1663.4 250.766 1662.92 251.247 1662.33 251.247H1661.26V256.568H1662.33C1662.92 256.568 1663.4 257.049 1663.4 257.635V259.762C1663.4 260.349 1662.92 260.83 1662.33 260.83H1661.26V269.345H1662.33C1662.92 269.345 1663.4 269.826 1663.4 270.413V272.539C1663.4 273.126 1662.92 273.607 1662.33 273.607H1661.26V274.674H1662.33C1662.92 274.674 1663.4 275.155 1663.4 275.742V277.869C1663.4 278.455 1662.92 278.936 1662.33 278.936H1661.26V281.063H1663.4C1663.98 281.063 1664.47 281.544 1664.47 282.13V289.587C1664.47 290.173 1663.98 290.654 1663.4 290.654H1662.32V313.014C1662.91 313.014 1663.4 313.495 1663.4 314.082V316.209C1663.4 316.795 1662.91 317.276 1662.32 317.276V319.403C1662.91 319.403 1663.4 319.884 1663.4 320.47V322.597C1663.4 323.184 1662.91 323.665 1662.32 323.665V348.152H1664.46C1665.05 348.152 1665.53 348.632 1665.53 349.219V360.334H1673.61C1674.78 360.334 1675.75 361.287 1675.75 362.461V364.115H1697.63V357.441C1697.63 356.806 1697.12 356.292 1696.49 356.292C1695.85 356.292 1695.33 355.779 1695.33 355.143V351.093C1695.33 350.164 1694.57 349.407 1693.63 349.407C1692.46 349.407 1691.63 348.225 1692.05 347.125L1702.19 320.495C1702.5 319.664 1703.28 319.118 1704.18 319.118H1830.47C1831.23 319.118 1831.93 319.509 1832.31 320.161L1848.32 347.141C1848.91 348.143 1848.2 349.407 1847.02 349.407C1846.2 349.407 1845.51 350.075 1845.51 350.906V354.157C1845.51 355.331 1844.56 356.284 1843.38 356.284H1843.05C1841.88 356.284 1840.92 357.237 1840.92 358.411V364.099H1854.96V312.721C1854.96 312.191 1855.39 311.759 1855.93 311.759C1856.46 311.759 1856.9 311.327 1856.9 310.798V291.705C1856.9 290.532 1857.85 289.578 1859.03 289.578H1894.28V287.452C1894.28 286.278 1895.23 285.325 1896.41 285.325H1906.06C1907 285.325 1907.83 284.714 1908.1 283.817L1913.06 267.666C1913.33 266.77 1914.16 266.159 1915.1 266.159H2035.9C2037.07 266.159 2038.04 267.112 2038.04 268.286V364.107V476.611H1505.73H666.714H146.826V343.743V338.072C146.826 336.898 147.783 335.945 148.961 335.945H150.115C151.293 335.945 152.25 334.991 152.25 333.818V323.518C152.25 322.345 153.207 321.391 154.385 321.391H193.118C194.296 321.391 195.253 322.345 195.253 323.518V333.818C195.253 334.991 196.21 335.945 197.388 335.945H201.511C202.665 335.945 203.597 336.874 203.597 338.023C203.597 339.172 204.53 340.101 205.683 340.101H217.34C218.133 340.101 218.87 340.541 219.23 341.241L227.156 356.276C227.32 356.577 227.402 356.92 227.402 357.262V365.028H236.58V350.058C236.58 348.787 238.429 348.592 238.699 349.838L239.189 352.12L242.093 352.112L242.396 350.075C242.568 348.885 244.278 348.844 244.498 350.026L244.891 352.063V352.12L250.642 352.112L250.944 350.075C251.116 348.885 252.826 348.844 253.047 350.026L253.439 352.063V352.12L254.912 352.112L255.215 350.075C255.386 348.885 257.096 348.844 257.317 350.026L257.701 352.063C257.71 352.071 257.71 352.096 257.71 352.096V352.12L258.119 352.112L258.421 350.075C258.593 348.885 260.303 348.844 260.524 350.026L260.916 352.063V352.096V352.12H261.521L262.012 349.838C262.282 348.584 264.131 348.779 264.131 350.058V365.028H287.134V306.495H287.306L287.518 304.613C287.666 303.382 289.449 303.342 289.645 304.572L289.932 306.495H290.774L290.987 304.613C291.142 303.382 292.925 303.342 293.105 304.572L293.433 306.715H301.597L301.834 304.613C301.981 303.382 303.764 303.342 303.961 304.572L304.28 306.715H305.073L305.31 304.613C305.466 303.382 307.249 303.342 307.429 304.572L307.756 306.715H308.173V321.179H313.605V289.204H313.941V289.163V289.098L314.35 285.211C314.481 283.915 316.378 283.939 316.476 285.235L316.779 289.122V289.204H321.761V289.098L322.17 285.211C322.301 283.915 324.199 283.939 324.297 285.235L324.599 289.122V289.204H325.777V260.235H326.743L327.013 259.127C327.291 258.01 328.894 258.059 329.107 259.184L329.303 260.227H329.99L334.031 248.549L335.602 225.635H335.545C333.753 225.635 332.297 224.185 332.297 222.392C332.297 220.599 333.737 219.149 335.545 219.149C337.352 219.149 338.809 220.599 338.809 222.392C338.809 224.046 337.557 225.415 335.954 225.611L337.721 248.549L341.344 260.227H341.835L342.629 257.839C342.964 256.829 344.428 256.877 344.682 257.921L345.246 260.235H345.32V260.585C345.328 260.659 345.328 260.732 345.32 260.797V289.204H348.257V289.163V289.098L348.666 285.211C348.797 283.915 350.694 283.939 350.793 285.235L351.095 289.122V289.204L351.3 289.195V289.147C351.3 289.13 351.308 289.098 351.308 289.098L351.701 285.211C351.831 283.915 353.729 283.939 353.828 285.235L354.13 289.122C354.13 289.147 354.138 289.204 354.138 289.204H354.441V321.179H356.175V306.715H356.592L356.92 304.572C357.116 303.35 358.899 303.382 359.038 304.613L359.284 306.715H360.061L360.388 304.572C360.584 303.35 362.368 303.382 362.507 304.613L362.752 306.715H370.908L371.235 304.572C371.431 303.35 373.215 303.382 373.354 304.613L373.575 306.495H374.409L374.712 304.572C374.908 303.35 376.691 303.382 376.83 304.613L377.051 306.495H377.436V365.028H391.244L391.113 348.608C391.097 347.345 392.913 347.117 393.215 348.347L394.083 351.892H394.925L395.236 349.007C395.375 347.761 397.183 347.728 397.363 348.966L397.78 351.884H398.132L398.443 348.999C398.582 347.752 400.389 347.72 400.569 348.958L400.987 351.876H401.338L401.649 348.991C401.788 347.744 403.596 347.712 403.776 348.95L404.193 351.867H405.617L405.928 348.983C406.067 347.736 407.874 347.703 408.054 348.942L408.472 351.859H408.823L409.134 348.975C409.273 347.728 411.081 347.695 411.261 348.934L411.711 352.071H413.077L413.412 348.975C413.552 347.728 415.359 347.695 415.539 348.934L415.989 352.071H416.505L417.225 349.154C417.535 347.932 419.335 348.152 419.327 349.415L419.261 364.987H431.172V329.776C431.172 329.067 430.812 328.399 430.223 328.008L429.945 327.829C429.348 327.429 428.996 326.761 428.996 326.052V324.74C428.996 323.567 429.953 322.613 431.131 322.613H431.311C432.113 322.613 432.857 322.165 433.217 321.456L442.199 304.002C442.567 303.293 443.303 302.845 444.105 302.845H505.817C506.651 302.845 507.412 303.325 507.764 304.075L516.189 322.19C516.32 322.467 516.394 322.776 516.394 323.086V329.85C516.394 330.379 516.827 330.811 517.359 330.811C517.891 330.811 518.332 331.243 518.332 331.773V364.987H580.601L611.178 338.878C611.571 338.552 612.054 338.373 612.569 338.373H623.8C624.316 338.373 624.815 338.561 625.199 338.895L629.878 342.953L637.96 251.067H641.699L656.98 364.987H666.714V325.734C666.714 325.294 666.853 324.863 667.107 324.504L687.925 295.079C688.138 294.777 688.416 294.549 688.719 294.402V293.645H751.797C752.738 293.645 753.572 294.256 753.842 295.152L758.799 311.303C759.069 312.199 759.904 312.811 760.844 312.811H770.489C771.659 312.811 772.624 313.764 772.624 314.937V371.367H791.863V325.677C791.863 325.27 791.986 324.871 792.207 324.528L810.244 296.562C811.234 295.014 813.59 295.364 814.089 297.132L835.145 371.367H858.688V357.246C858.688 356.61 858.181 356.097 857.543 356.097C856.905 356.097 856.389 355.583 856.389 354.948V350.898C856.389 349.969 855.628 349.211 854.688 349.211C853.518 349.211 852.692 348.029 853.109 346.929L863.244 320.299C863.555 319.468 864.341 318.922 865.24 318.922H921.34C921.856 318.922 922.273 318.515 922.273 318.001C922.273 317.488 921.856 317.08 921.34 317.08H920.882C920.121 317.08 919.5 316.461 919.5 315.703V315.475C919.5 314.587 920.228 313.87 921.111 313.87H947.37C948.507 313.87 949.44 314.791 949.44 315.931V316.616C949.44 317.374 948.818 317.993 948.049 317.993H947.133C946.879 317.993 946.675 318.197 946.675 318.449C946.675 318.702 946.879 318.906 947.133 318.906H991.519C992.28 318.906 992.975 319.297 993.359 319.949L1009.37 346.929C1009.96 347.932 1009.25 349.195 1008.07 349.195C1007.25 349.195 1006.56 349.863 1006.56 350.694V353.945C1006.56 355.119 1005.61 356.072 1004.43 356.072H1004.09C1002.92 356.072 1001.96 357.026 1001.96 358.199V363.887H1016V311.442C1016 310.912 1016.44 310.48 1016.97 310.48C1017.5 310.48 1017.94 310.048 1017.94 309.518V290.426C1017.94 289.252 1018.89 288.299 1020.08 288.299H1104.14C1105.31 288.299 1106.28 289.252 1106.28 290.426V309.518C1106.28 310.048 1106.71 310.48 1107.24 310.48C1107.78 310.48 1108.22 310.912 1108.22 311.442V318.066H1129.18L1133.94 302.576C1134.21 301.679 1135.04 301.068 1135.98 301.068H1196.93C1198.09 301.068 1199.06 302.022 1199.06 303.195V318.066H1272.31L1281.2 300.759C1281.57 300.05 1282.3 299.601 1283.1 299.601H1344.82C1345.65 299.601 1346.41 300.082 1346.76 300.832L1355.19 318.947C1355.32 319.224 1355.39 319.533 1355.39 319.843V326.606C1355.39 327.136 1355.83 327.568 1356.36 327.568C1356.89 327.568 1357.33 328 1357.33 328.529V363.879H1417.11L1450.78 335.13H1463.61L1496.74 363.879H1505.73V322.499C1505.73 322.059 1505.87 321.627 1506.12 321.269L1526.94 291.844C1527.15 291.542 1527.43 291.314 1527.73 291.167V290.41H1590.81C1591.75 290.41 1592.59 291.021 1592.86 291.917L1597.81 308.068C1598.08 308.964 1598.92 309.575 1599.86 309.575H1609.5C1610.67 309.575 1611.64 310.529 1611.64 311.702V363.871H1630.88V362.216C1630.88 361.043 1631.84 360.09 1633.01 360.09H1650.65V348.975C1650.65 348.388 1651.13 347.907 1651.72 347.907H1653.86V323.42C1653.27 323.42 1652.79 322.939 1652.79 322.353V320.226C1652.79 319.639 1653.27 319.158 1653.86 319.158V317.032C1653.27 317.032 1652.79 316.551 1652.79 315.964V313.837C1652.79 313.251 1653.27 312.77 1653.86 312.77V290.41H1652.79C1652.2 290.41 1651.71 289.929 1651.71 289.342V281.886C1651.71 281.299 1652.2 280.819 1652.79 280.819H1654.92V278.692H1653.85C1653.26 278.692 1652.78 278.211 1652.78 277.624V275.497C1652.78 274.911 1653.26 274.43 1653.85 274.43H1654.92V273.362H1653.85C1653.26 273.362 1652.78 272.882 1652.78 272.295V270.168C1652.78 269.581 1653.26 269.101 1653.85 269.101H1654.92V260.585H1653.85C1653.26 260.585 1652.78 260.104 1652.78 259.518V257.391C1652.78 256.804 1653.26 256.323 1653.85 256.323H1654.92V251.002H1653.85C1653.26 251.002 1652.78 250.521 1652.78 249.935V248.867C1652.78 248.281 1653.26 247.8 1653.85 247.8H1654.92V238.209C1653.06 238.103 1651.51 236.701 1651.26 234.835C1650.5 229.294 1650.46 223.688 1651.16 218.147L1651.24 217.429C1651.39 216.305 1651.95 215.335 1652.78 214.667V210.519C1652.78 209.933 1653.26 209.452 1653.85 209.452H1654.92V198.801C1654.92 198.215 1655.4 197.734 1655.99 197.734ZM295.044 321.269H295.012V321.31H295.044V321.269Z",
    fill: "url(#paint4_linear_6001_44765)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.17 130.698H1795.62C1794.2 130.698 1793.05 131.848 1793.05 133.265C1793.05 134.682 1794.2 135.832 1795.62 135.832H1803.54C1804.32 135.832 1804.96 136.466 1804.96 137.247C1804.96 138.028 1804.32 138.664 1803.54 138.664H1799.4C1798.17 138.664 1797.18 139.656 1797.18 140.878C1797.18 142.1 1798.17 143.091 1799.4 143.091H1842.96C1844.18 143.091 1845.18 142.1 1845.18 140.878C1845.18 139.656 1844.18 138.664 1842.96 138.664H1831.28C1830.5 138.664 1829.87 138.03 1829.87 137.247C1829.87 136.464 1830.5 135.832 1831.28 135.832H1836.17C1837.59 135.832 1838.74 134.682 1838.74 133.265C1838.74 131.848 1837.59 130.698 1836.17 130.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 420.104H50.7793V450.624H2041.1V420.104Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2041 432.412L2030.02 432.257",
    stroke: "white",
    strokeWidth: 0.861121,
    strokeDasharray: "4.31 4.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.787 348.952H61.335V384.767H120.787V348.952Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.885 376.266H61.4004V384.763H120.885V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1995 356.14H64.21V360.805H65.1995V356.14Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 366.25H60.79V373.836H121.492V366.25Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6513 376.266H61.4004V384.763H65.6513V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.885 376.266H61.4004V384.763H120.885V376.266Z",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5394 376.266H68.6846V384.763H73.5394V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8236 376.266H75.9688V384.763H80.8236V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1068 376.266H83.252V384.763H88.1068V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3881 376.266H90.5332V384.763H95.3881V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.673 376.266H97.8184V384.763H102.673V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.957 376.266H105.103V384.763H109.957V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.243 376.266H112.388V384.763H117.243V376.266Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 355.326H60.79V363.823H121.492V355.326Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 355.326H60.79V356.539H121.492V355.326Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 366.25H60.79V367.462H121.492V366.25Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 376.266H60.79V377.478H121.492V376.266Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 348.952H60.79V352.896H121.492V348.952Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.492 348.952H60.79V350.165H121.492V348.952Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.795 351.377H60.4893V353.198H121.795V351.377Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2552 355.326H61.4004V360.79H66.2552V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7172 355.326H66.8623V360.79H71.7172V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.181 355.326H72.3262V360.79H77.181V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6449 355.326H77.79V360.79H82.6449V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1068 355.326H83.252V360.79H88.1068V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5668 355.326H88.7119V360.79H93.5668V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0287 355.326H94.1738V360.79H99.0287V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.495 355.326H99.6396V360.79H104.495V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.957 355.326H105.103V360.79H109.957V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 355.326H110.565V360.79H115.42V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.884 355.326H116.029V360.79H120.884V355.326Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2552 366.25H61.4004V371.104H66.2552V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7172 366.25H66.8623V371.104H71.7172V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.181 366.25H72.3262V371.104H77.181V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6449 366.25H77.79V371.104H82.6449V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1068 366.25H83.252V371.104H88.1068V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5668 366.25H88.7119V371.104H93.5668V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0287 366.25H94.1738V371.104H99.0287V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.495 366.25H99.6396V371.104H104.495V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.957 366.25H105.103V371.104H109.957V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 366.25H110.565V371.104H115.42V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.884 366.25H116.029V371.104H120.884V366.25Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.44 399.637H1826.26C1829.51 399.637 1832.6 398.267 1834.79 395.865L1839.07 391.159C1839.8 390.36 1840.31 389.398 1840.57 388.353L1841.28 385.547C1842.75 379.698 1835.42 375.763 1831.36 380.218V375.377C1831.36 369.054 1823.2 366.508 1819.61 371.712C1821.39 363.265 1811.35 357.449 1804.92 363.205L1804.34 361.114C1802.78 355.391 1796.54 352.362 1791.08 354.685C1786.37 356.682 1784.01 361.96 1785.64 366.801L1787.28 371.716C1779.3 371.716 1774.55 380.622 1778.99 387.252L1783.86 394.522C1786 397.719 1789.59 399.637 1793.44 399.637H1793.44Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794.94 399.028H1824.51C1827.71 399.028 1830.76 397.699 1832.95 395.358L1836.63 391.413C1837.3 390.684 1837.79 389.797 1838.03 388.835L1838.62 386.545C1840.01 381.174 1833.31 377.499 1829.52 381.55V377.346C1829.52 371.525 1822.04 369.146 1818.68 373.894C1820.35 366.229 1811.28 360.872 1805.37 366.029L1805.13 366.238L1804.62 364.403C1803.17 359.199 1797.49 356.44 1792.5 358.512C1788.11 360.333 1785.89 365.258 1787.44 369.755L1788.86 373.899C1781.56 373.899 1777.24 382.094 1781.37 388.12L1785.43 394.02C1787.58 397.156 1791.13 399.028 1794.94 399.028Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.667 410.625L558.582 409.036C563.488 408.724 567.66 405.333 568.965 400.594L569.546 398.48C569.811 397.519 569.829 396.511 569.606 395.54L569.067 393.24C567.808 387.837 560.175 387.679 558.693 393.026L556.747 389.296C554.052 384.134 546.322 385.491 545.536 391.256C543.464 383.693 532.946 383.14 530.094 390.448L529.978 390.741L528.672 389.351C524.979 385.412 518.67 385.593 515.204 389.737C512.157 393.384 512.468 398.773 515.92 402.044L519.102 405.054C515.72 406.82 517.202 411.953 521.007 411.647L533.662 410.62L533.667 410.625Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.635 410.625L694.55 409.036C699.461 408.724 703.623 405.333 704.938 400.594L705.519 398.48C705.779 397.519 705.802 396.511 705.574 395.54L705.04 393.24C703.776 387.837 696.148 387.679 694.661 393.026L692.719 389.296C690.025 384.134 682.29 385.491 681.509 391.256C679.437 383.693 668.919 383.14 666.067 390.448L665.95 390.741L664.645 389.351C660.956 385.412 654.643 385.593 651.177 389.737C648.129 393.384 648.44 398.773 651.892 402.044L655.075 405.054C651.692 406.82 653.174 411.953 656.979 411.647L669.635 410.62V410.625Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.832 410.625L485.747 409.036C490.653 408.724 494.825 405.333 496.13 400.594L496.711 398.48C496.976 397.519 496.994 396.511 496.771 395.54L496.232 393.24C494.973 387.837 487.34 387.679 485.858 393.026L483.912 389.296C481.217 384.134 473.487 385.491 472.702 391.256C470.63 383.693 460.111 383.14 457.259 390.448L457.143 390.741L455.837 389.351C452.144 385.412 445.835 385.593 442.369 389.737C439.322 393.384 439.633 398.773 443.085 402.044L446.267 405.054C442.885 406.82 444.367 411.953 448.172 411.647L460.827 410.62L460.832 410.625Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.114 405.966L625.068 398.927C629.783 397.543 633.105 393.315 633.337 388.405L633.44 386.217C633.486 385.222 633.282 384.233 632.849 383.336L631.818 381.208C629.398 376.219 621.918 377.743 621.648 383.285L618.926 380.075C615.163 375.633 607.92 378.658 608.427 384.456C604.738 377.534 594.354 379.313 593.184 387.071L593.137 387.383L591.558 386.314C587.084 383.285 580.97 384.851 578.508 389.659C576.338 393.887 577.829 399.076 581.918 401.506L585.685 403.745C582.777 406.212 585.351 410.895 588.993 409.757L601.114 405.97V405.966Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.686 400.721L767.532 394.319C763.588 392.243 761.196 388.085 761.377 383.634L761.553 379.471C761.595 378.393 761.906 377.348 762.459 376.419L763.927 373.929C766.998 368.735 774.97 371.086 774.724 377.116L778.129 373.673C782.58 369.176 790.167 373.102 789.066 379.332C793.725 372.066 804.964 374.993 805.493 383.611L807.37 382.524C812.504 379.55 819.078 381.79 821.331 387.276C823.268 392.001 821.238 397.423 816.68 399.718L812.053 402.054H785.061C783.184 402.054 781.34 401.599 779.681 400.726L779.686 400.721Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.201 398.534L767.275 395.375C764.459 393.112 762.866 389.661 762.973 386.051L763.112 381.377C763.135 380.383 763.414 379.412 763.921 378.553L765.11 376.513C767.902 371.723 775.242 373.814 775.089 379.356L778.044 376.364C782.137 372.225 789.129 375.788 788.181 381.535C792.385 374.915 802.601 377.479 803.182 385.303L803.205 385.619L806.806 383.208C810.267 380.894 814.801 380.973 818.174 383.407L819.401 384.29C822.49 386.52 823.605 390.608 822.077 394.102C821.319 395.849 819.958 397.266 818.253 398.111L809.389 402.502H788.181L776.896 400.987C774.815 400.708 772.841 399.863 771.201 398.543V398.534Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.35 348.343H1896.9V384.157H1956.35V348.343Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.45 375.661H1896.96V384.158H1956.45V375.661Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.76 355.532H1899.77V360.196H1900.76V355.532Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 365.646H1896.36V373.232H1957.06V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.22 375.661H1896.96V384.158H1901.22V375.661Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.45 375.661H1896.96V384.158H1956.45V375.661Z",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.1 375.661H1904.25V384.158H1909.1V375.661Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.38 375.661H1911.53V384.158H1916.38V375.661Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.67 375.661H1918.81V384.158H1923.67V375.661Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 354.719H1896.36V363.216H1957.06V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 354.719H1896.36V355.932H1957.06V354.719Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 365.646H1896.36V366.858H1957.06V365.646Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 375.661H1896.36V376.873H1957.06V375.661Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 348.343H1896.36V352.287H1957.06V348.343Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.06 348.343H1896.36V349.555H1957.06V348.343Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.36 350.773H1896.05V352.595H1957.36V350.773Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.82 354.719H1896.96V360.183H1901.82V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.28 354.719H1902.43V360.183H1907.28V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.74 354.719H1907.88V360.183H1912.74V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.2 354.719H1913.35V360.183H1918.2V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.67 354.719H1918.81V360.183H1923.67V354.719Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.82 365.646H1896.96V370.5H1901.82V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.28 365.646H1902.43V370.5H1907.28V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.74 365.646H1907.88V370.5H1912.74V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.2 365.646H1913.35V370.5H1918.2V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.67 365.646H1918.81V370.5H1923.67V365.646Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.86 378.143H636.493V394.477H656.86V378.143Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.961 377.503H636.39V377.907H656.961V377.503Z",
    stroke: "#615E66",
    strokeWidth: 0.306622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.244 374.881L636.734 377.339H656.623L655.113 374.881C654.946 374.612 654.653 374.449 654.337 374.449H639.02C638.704 374.449 638.412 374.612 638.244 374.881Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.86 388.896H636.493V394.476H656.86V388.896Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.921 390.514H638.379V392.595H639.921V390.514Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.416 390.514H641.874V392.595H643.416V390.514Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.945 390.514H649.402V392.595H650.945V390.514Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.708 390.514H653.166V392.595H654.708V390.514Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.444 383.522H653.436V387.485H654.444V383.522Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.444 379.214H653.436V381.026H654.444V379.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.681 383.522H649.942V387.485H650.681V383.522Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.681 379.214H649.942V381.026H650.681V379.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.914 383.522H646.175V387.485H646.914V383.522Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.914 379.214H646.175V381.026H646.914V379.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.151 383.522H642.412V387.485H643.151V383.522Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.151 379.214H642.412V381.026H643.151V379.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.652 383.522H638.913V387.485H639.652V383.522Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.652 379.214H638.913V381.026H639.652V379.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.447 390.514H645.904V394.477H647.447V390.514Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.918 370.804H836.466V394.479H895.918V370.804Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.918 387.414H836.466V394.476H895.918V387.414Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.336 375.597H839.347V378.505H840.336V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.825 372.419H834.567V373.376H897.825V372.419Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.336 382.306H839.347V385.214H840.336V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.657 389.012H837.749V394.476H840.657V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.327 389.012H843.82V394.476H848.327V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.357 389.012H850.851V394.476H855.357V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.384 389.012H857.878V394.476H862.384V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.263 389.99C864.263 388.921 865.131 388.057 866.2 388.057C867.269 388.057 868.128 388.921 868.128 389.99V394.478H864.263V389.99Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.525 389.012H870.019V394.476H874.525V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.555 389.012H877.049V394.476H881.555V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.899 389.012H884.393V394.476H888.899V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.328 389.012H891.74V394.476H894.328V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.768 375.597H844.778V378.505H845.768V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.768 382.306H844.778V385.214H845.768V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.284 375.597H848.294V378.505H849.284V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.284 382.306H848.294V385.214H849.284V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.796 375.597H851.807V378.505H852.796V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.796 382.306H851.807V385.214H852.796V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.987 375.597H854.997V378.505H855.987V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.987 382.306H854.997V385.214H855.987V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.825 375.597H858.836V378.505H859.825V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.825 382.306H858.836V385.214H859.825V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.017 375.597H862.027V378.505H863.017V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.017 382.306H862.027V385.214H863.017V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.855 375.597H865.865V378.505H866.855V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.855 382.306H865.865V385.214H866.855V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.688 375.597H869.698V378.505H870.688V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.688 382.306H869.698V385.214H870.688V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.2 375.597H873.21V378.505H874.2V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.2 382.306H873.21V385.214H874.2V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.392 375.597H876.402V378.505H877.392V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.392 382.306H876.402V385.214H877.392V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.229 375.597H880.239V378.505H881.229V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.229 382.306H880.239V385.214H881.229V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.747 375.597H883.758V378.505H884.747V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.747 382.306H883.758V385.214H884.747V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.937 375.597H886.947V378.505H887.937V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.937 382.306H886.947V385.214H887.937V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.048 375.597H892.059V378.505H893.048V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.048 382.306H892.059V385.214H893.048V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.885 370.804H835.514V372.434H896.885V370.804Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.386 370.804H685.934V394.479H745.386V370.804Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.484 389.012H685.999V394.476H745.484V389.012Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.799 375.597H688.81V378.505H689.799V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.29 372.419H684.033V373.376H747.29V372.419Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.484 382.336H685.999V387.191H745.484V382.336Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.25 389.012H685.999V394.476H690.25V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.484 389.012H685.999V394.476H745.484V389.012Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.79 389.012H693.283V394.476H697.79V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.031 389.012H701.176V394.476H706.031V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.847 389.012H707.341V394.476H711.847V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.729 389.99C713.729 388.921 714.598 388.057 715.667 388.057C716.735 388.057 717.595 388.921 717.595 389.99V394.478H713.729V389.99Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.988 389.012H719.481V394.476H723.988V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.016 389.012H726.51V394.476H731.016V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.361 389.012H733.854V394.476H738.361V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.487 389.012H741.236V394.476H745.487V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 375.052H685.999V380.515H746.701V375.052Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 375.052H685.999V375.66H746.701V375.052Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 382.336H685.999V382.945H746.701V382.336Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 389.012H685.999V389.621H746.701V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.509 382.306H741.52V385.214H742.509V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.35 370.804H684.979V373.038H746.35V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 370.804H685.999V371.412H746.701V370.804Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.37 370.804H1360.92V394.479H1420.37V370.804Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.47 389.012H1360.98V394.476H1420.47V389.012Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.78 375.597H1363.79V378.505H1364.78V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.27 372.419H1359.02V373.376H1422.27V372.419Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.47 382.336H1360.98V387.191H1420.47V382.336Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.23 389.012H1360.98V394.476H1365.23V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.47 389.012H1360.98V394.476H1420.47V389.012Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.77 389.012H1368.27V394.476H1372.77V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.01 389.012H1376.15V394.476H1381.01V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.83 389.012H1382.33V394.476H1386.83V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.71 389.99C1388.71 388.921 1389.58 388.057 1390.65 388.057C1391.71 388.057 1392.57 388.921 1392.57 389.99V394.478H1388.71V389.99Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.97 389.012H1394.46V394.476H1398.97V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 389.012H1401.49V394.476H1406V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.34 389.012H1408.84V394.476H1413.34V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.47 389.012H1416.22V394.476H1420.47V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.68 375.052H1360.98V380.515H1421.68V375.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.68 375.052H1360.98V375.66H1421.68V375.052Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.68 382.336H1360.98V382.945H1421.68V382.336Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.68 389.012H1360.98V389.621H1421.68V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.49 382.306H1416.5V385.214H1417.49V382.306Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.34 370.804H1359.97V373.038H1421.34V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.68 370.804H1360.98V371.412H1421.68V370.804Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.81 370.804H1919.36V394.479H1978.81V370.804Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.91 389.012H1919.42V394.476H1978.91V389.012Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.51 382.336H1920.03V387.191H1979.51V382.336Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.67 389.012H1919.42V394.476H1923.67V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.91 389.012H1919.42V394.476H1978.91V389.012Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.52 375.052H1918.81V380.515H1979.52V375.052Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.52 375.052H1918.81V375.66H1979.52V375.052Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.52 382.336H1918.81V382.945H1979.52V382.336Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.52 389.012H1918.81V389.621H1979.52V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.77 370.804H1918.4V373.038H1979.77V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.52 370.804H1918.81V371.412H1979.52V370.804Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.95 372.419H1916.69V373.376H1979.95V372.419Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.44 358.663H1556.98V394.477H1616.44V358.663Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.53 385.98H1557.04V394.477H1616.53V385.98Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.84 365.854H1559.85V370.518H1560.84V365.854Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.13 375.963H1556.43V383.55H1617.13V375.963Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.29 385.98H1557.04V394.477H1561.29V385.98Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.53 385.98H1557.04V394.477H1616.53V385.98Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.18 385.98H1564.33V394.477H1569.18V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576.46 385.98H1571.61V394.477H1576.46V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.75 385.98H1578.89V394.477H1583.75V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.03 385.98H1586.18V394.477H1591.03V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.32 385.98H1593.46V394.477H1598.32V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.6 385.98H1600.75V394.477H1605.6V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.89 385.98H1608.03V394.477H1612.89V385.98Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 365.036H1556.43V373.533H1617.14V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 365.036H1556.43V366.248H1617.14V365.036Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 375.963H1556.43V377.176H1617.14V375.963Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 385.98H1556.43V387.193H1617.14V385.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 358.663H1556.43V362.607H1617.14V358.663Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.14 358.663H1556.43V359.875H1617.14V358.663Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.44 361.093H1556.13V362.914H1617.44V361.093Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.9 365.036H1557.04V370.499H1561.9V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.36 365.036H1562.51V370.499H1567.36V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.82 365.036H1567.97V370.499H1572.82V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.28 365.036H1573.43V370.499H1578.28V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.75 365.036H1578.89V370.499H1583.75V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.21 365.036H1584.36V370.499H1589.21V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.68 365.036H1589.82V370.499H1594.68V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.14 365.036H1595.28V370.499H1600.14V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.6 365.036H1600.75V370.499H1605.6V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.07 365.036H1606.21V370.499H1611.07V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.53 365.036H1611.67V370.499H1616.53V365.036Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.9 375.963H1557.04V380.818H1561.9V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.36 375.963H1562.51V380.818H1567.36V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.82 375.963H1567.97V380.818H1572.82V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.28 375.963H1573.43V380.818H1578.28V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.75 375.963H1578.89V380.818H1583.75V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.21 375.963H1584.36V380.818H1589.21V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.68 375.963H1589.82V380.818H1594.68V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.14 375.963H1595.28V380.818H1600.14V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.6 375.963H1600.75V380.818H1605.6V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.07 375.963H1606.21V380.818H1611.07V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.53 375.963H1611.67V380.818H1616.53V375.963Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.46 370.803H1265.01V394.478H1324.46V370.803Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.46 387.414H1265.01V394.475H1324.46V387.414Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.87 375.597H1267.88V378.505H1268.87V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.36 372.419H1263.11V373.376H1326.36V372.419Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.87 382.305H1267.88V385.213H1268.87V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.2 389.012H1266.29V394.476H1269.2V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.86 389.012H1272.36V394.476H1276.86V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.89 389.012H1279.39V394.476H1283.89V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.92 389.012H1286.41V394.476H1290.92V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.8 389.99C1292.8 388.921 1293.67 388.057 1294.74 388.057C1295.81 388.057 1296.67 388.921 1296.67 389.99V394.478H1292.8V389.99Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.06 389.012H1298.56V394.476H1303.06V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.09 389.012H1305.58V394.476H1310.09V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.44 389.012H1312.93V394.476H1317.44V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.87 389.012H1320.29V394.476H1322.87V389.012Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.31 375.597H1273.32V378.505H1274.31V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.31 382.305H1273.32V385.213H1274.31V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.82 375.597H1276.83V378.505H1277.82V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.82 382.305H1276.83V385.213H1277.82V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.34 375.597H1280.35V378.505H1281.34V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.34 382.305H1280.35V385.213H1281.34V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.53 375.597H1283.54V378.505H1284.53V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.53 382.305H1283.54V385.213H1284.53V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.37 375.597H1287.38V378.505H1288.37V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.37 382.305H1287.38V385.213H1288.37V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.56 375.597H1290.57V378.505H1291.56V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.56 382.305H1290.57V385.213H1291.56V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.4 375.597H1294.41V378.505H1295.4V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.4 382.305H1294.41V385.213H1295.4V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.22 375.597H1298.23V378.505H1299.22V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.22 382.305H1298.23V385.213H1299.22V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.74 375.597H1301.75V378.505H1302.74V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.74 382.305H1301.75V385.213H1302.74V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.93 375.597H1304.94V378.505H1305.93V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.93 382.305H1304.94V385.213H1305.93V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.77 375.597H1308.78V378.505H1309.77V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.77 382.305H1308.78V385.213H1309.77V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.28 375.597H1312.29V378.505H1313.28V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.28 382.305H1312.29V385.213H1313.28V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.47 375.597H1315.49V378.505H1316.47V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.47 382.305H1315.49V385.213H1316.47V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.59 375.597H1320.6V378.505H1321.59V375.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.59 382.305H1320.6V385.213H1321.59V382.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.43 370.803H1264.05V372.434H1325.43V370.803Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.063 358.421H433.611V394.477H445.063V358.421Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.335 360.361H445.29V394.475H450.335V360.361Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.048 358.421H436.626V394.477H442.048V358.421Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.02 358.421H450.568V394.477H462.02V358.421Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.005 358.421H453.583V394.477H459.005V358.421Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.001 358.421H456.595V394.477H459.001V358.421Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.043 358.421H439.637V394.477H442.043V358.421Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.489 352.387H438.299V358.268H438.489V352.387Z",
    stroke: "#615E66",
    strokeWidth: 0.14402
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.751 356.27H440.561V358.267H440.751V356.27Z",
    stroke: "#615E66",
    strokeWidth: 0.14402
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.51 360.361H1345.46V394.475H1350.51V360.361Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.58 351.377H1350.05V394.476H1361.58V351.377Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.55 351.377H1353.09V394.476H1358.55V351.377Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.55 351.377H1356.12V394.476H1358.55V351.377Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0269 356.84H54.8711V394.475H77.0269V356.84Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7882 355.627H54.1133V356.236H77.7882V355.627Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0269 356.84H54.8711V359.27H77.0269V356.84Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0269 386.583H54.8711V389.013H77.0269V386.583Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4009 356.84H57.1465V382.94H66.4009V356.84Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8864 390.835H57.1465V394.478H64.8864V390.835Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3335 390.835H57.1465V392.657H60.3335V390.835Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8862 390.835H61.6992V392.657H64.8862V390.835Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7536 390.835H67.0137V394.478H74.7536V390.835Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2007 390.835H67.0137V392.657H70.2007V390.835Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7485 390.835H71.5615V392.657H74.7485V390.835Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4009 360.483H57.1465V366.555H66.4009V360.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4009 368.981H57.1465V375.053H66.4009V368.981Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4009 376.874H57.1465V382.946H66.4009V376.874Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2518 360.483H64.4307V366.555H66.2518V360.483Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2518 368.981H64.4307V375.053H66.2518V368.981Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2518 376.874H64.4307V382.946H66.2518V376.874Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0269 384.16H54.8711V384.768H77.0269V384.16Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.748 360.483H70.8037V366.555H74.748V360.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.748 368.981H70.8037V375.053H74.748V368.981Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.748 376.874H70.8037V382.946H74.748V376.874Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7506 360.483H73.5381V366.555H74.7506V360.483Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7506 368.981H73.5381V375.053H74.7506V368.981Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7506 376.874H73.5381V382.946H74.7506V376.874Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3681 360.483H59.4238V366.555H63.3681V360.483Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3681 368.981H59.4238V375.053H63.3681V368.981Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3681 376.874H59.4238V382.946H63.3681V376.874Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.57 342.276H1112.11V394.476H1134.57V342.276Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.18 341.059H1111.51V341.667H1135.18V341.059Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.42 342.276H1112.26V344.706H1134.42V342.276Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.42 372.019H1112.26V374.448H1134.42V372.019Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.79 342.276H1114.54V368.376H1123.79V342.276Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.43 389.621H1114.54V394.476H1122.43V389.621Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.43 389.621H1118.18V394.476H1122.43V389.621Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.84 389.621H1123.95V394.476H1131.84V389.621Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 389.621H1127.89V394.476H1132.14V389.621Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.73 376.266H1114.54V378.087H1117.73V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.28 376.266H1119.09V378.087H1122.28V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 376.266H1124.4V379.908H1132.14V376.266Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.59 376.266H1124.4V378.087H1127.59V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 376.266H1128.96V378.087H1132.14V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.79 345.919H1114.54V351.991H1123.79V345.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.79 354.417H1114.54V360.489H1123.79V354.417Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.79 362.303H1114.54V368.375H1123.79V362.303Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.65 345.919H1121.82V351.991H1123.65V345.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.65 354.417H1121.82V360.489H1123.65V354.417Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.65 362.303H1121.82V368.375H1123.65V362.303Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.42 369.59H1112.26V370.199H1134.42V369.59Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 345.919H1128.2V351.991H1132.14V345.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 354.417H1128.2V360.489H1132.14V354.417Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 362.303H1128.2V368.375H1132.14V362.303Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 345.919H1130.93V351.991H1132.14V345.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 354.417H1130.93V360.489H1132.14V354.417Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.14 362.303H1130.93V368.375H1132.14V362.303Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.76 345.919H1116.82V351.991H1120.76V345.919Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.76 354.417H1116.82V360.489H1120.76V354.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.76 362.303H1116.82V368.375H1120.76V362.303Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.69 342.277H1816.23V394.477H1838.69V342.277Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.3 341.059H1815.62V341.668H1839.3V341.059Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.54 342.277H1816.38V344.707H1838.54V342.277Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.54 372.019H1816.38V374.449H1838.54V372.019Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.91 342.277H1818.66V368.377H1827.91V342.277Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.55 386.583H1818.66V394.476H1826.55V386.583Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.27 386.583H1828.37V394.476H1836.27V386.583Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.27 389.622H1832.02V394.476H1836.27V389.622Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.85 376.266H1818.66V378.087H1821.85V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.4 376.266H1823.21V378.087H1826.4V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.27 376.266H1828.37V382.942H1836.27V376.266Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.23 376.266H1828.37V382.942H1833.23V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 376.266H1833.23V382.942H1836.26V376.266Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.91 345.919H1818.66V351.991H1827.91V345.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.91 354.417H1818.66V360.489H1827.91V354.417Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.91 362.304H1818.66V368.376H1827.91V362.304Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.77 345.919H1825.94V351.991H1827.77V345.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.77 354.417H1825.94V360.489H1827.77V354.417Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.77 362.304H1825.94V368.376H1827.77V362.304Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.54 369.591H1816.38V370.199H1838.54V369.591Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 345.919H1832.32V351.991H1836.26V345.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 354.417H1832.32V360.489H1836.26V354.417Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 362.304H1832.32V368.376H1836.26V362.304Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 345.919H1835.05V351.991H1836.26V345.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 354.417H1835.05V360.489H1836.26V354.417Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.26 362.304H1835.05V368.376H1836.26V362.304Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.88 345.919H1820.93V351.991H1824.88V345.919Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.88 354.417H1820.93V360.489H1824.88V354.417Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.88 362.304H1820.93V368.376H1824.88V362.304Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1727 394.777H102.649C105.576 394.777 108.391 393.667 110.528 391.669L112.577 389.755C113.13 389.235 113.539 388.58 113.753 387.85L113.92 387.279C115.1 383.283 110.25 380.287 107.207 383.125V380.965C107.207 376.57 101.687 374.61 98.9138 378.02C100.238 372.696 94.124 368.672 89.7616 371.994L88.5491 372.914L88.2099 371.855C87.0392 368.203 83.0717 366.252 79.4665 367.557C75.88 368.854 74.0774 372.858 75.4758 376.403L76.1123 378.02C70.765 378.02 67.7731 384.185 71.0809 388.384L73.5943 391.581C75.1831 393.597 77.6082 394.777 80.1774 394.777H80.1727Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7755 396.258L103.21 398.501C106.518 398.831 109.807 397.721 112.237 395.449L113.789 394C114.341 393.479 114.75 392.824 114.964 392.095L115.131 391.524C116.311 387.528 111.461 384.532 108.418 387.37V385.21C108.418 380.815 102.899 378.854 100.125 382.264C101.449 376.94 95.3354 372.917 90.973 376.239L89.7605 377.159L87.6281 374.696C85.9324 372.741 83.1542 372.123 80.7941 373.182C78.6849 374.13 77.3284 376.225 77.3284 378.539V382.264C72.8405 382.264 70.4851 387.589 73.4956 390.91L76.283 393.986C77.4491 395.273 79.0519 396.076 80.7755 396.253V396.258Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1969 394.475L81.7334 374.442",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4439 377.783L85.9805 389.314",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5713 386.889L85.677 389.621",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.302 394.777H772.778C775.695 394.777 778.515 393.667 780.653 391.669L782.706 389.755C783.259 389.235 783.663 388.58 783.877 387.85L784.049 387.279C785.224 383.283 780.378 380.287 777.335 383.125V380.965C777.335 376.57 771.812 374.61 769.043 378.02C770.367 372.696 764.253 368.672 759.89 371.994L758.678 372.914L758.339 371.855C757.168 368.203 753.205 366.252 749.591 367.557C746.009 368.854 744.202 372.858 745.605 376.403L746.241 378.02C740.894 378.02 737.907 384.185 741.21 388.384L743.728 391.581C745.312 393.597 747.742 394.777 750.306 394.777H750.302Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.822 394.775H771.551C774.33 394.775 777.015 393.767 779.11 391.941L780.75 390.51C781.266 390.06 781.647 389.474 781.856 388.819C782.989 385.233 778.706 382.38 775.863 384.852V383.333C775.863 379.347 770.915 377.498 768.299 380.503C769.53 375.89 764.313 372.271 760.42 375.035L758.85 376.155L758.557 375.309C757.465 372.127 754.009 370.427 750.822 371.504C747.454 372.643 745.767 376.401 747.152 379.672L747.505 380.508C742.747 380.508 740.16 386.069 743.231 389.707L745.368 392.243C746.72 393.851 748.717 394.78 750.826 394.78L750.822 394.775Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.78 393.304C701.78 390.712 702.314 388.152 703.346 385.778L704.382 383.399C706.389 378.782 712.949 378.782 714.956 383.399L715.992 385.778C717.023 388.152 717.557 390.712 717.557 393.304C717.557 393.95 717.037 394.475 716.386 394.475H702.946C702.296 394.475 701.775 393.95 701.775 393.304H701.78Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.907 393.007C703.907 390.894 704.349 388.803 705.208 386.87L705.7 385.765C707.582 381.528 713.594 381.528 715.475 385.765L715.968 386.87C716.823 388.803 717.269 390.894 717.269 393.007C717.269 393.649 716.748 394.174 716.102 394.174H705.078C704.432 394.174 703.912 393.653 703.912 393.007H703.907Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.671 389.921V394.776",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.615 388.709L709.671 392.352",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.639 390.529L709.672 393.87",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.304 394.776H728.961C730.522 394.776 732.018 394.186 733.161 393.122L733.979 392.356C734.253 392.105 734.448 391.789 734.55 391.436L734.629 391.175C735.2 389.247 732.864 387.793 731.386 389.164V388.132C731.386 386.009 728.715 385.057 727.372 386.706C728.013 384.142 725.073 382.195 722.959 383.793L722.359 384.249L722.201 383.742C721.63 381.981 719.721 381.038 717.978 381.666C716.241 382.293 715.367 384.23 716.05 385.944L716.352 386.706C713.774 386.706 712.329 389.684 713.932 391.71L715.14 393.243C715.906 394.209 717.068 394.776 718.304 394.776Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.813 394.475L718.171 388.709",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.6 392.045L722.723 387.492",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.974 394.776L730.007 390.832",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.667 389.921L728.79 392.045",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.846 394.474L718.774 384.458",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 394.779H1353.67C1356.59 394.779 1359.41 393.669 1361.55 391.671L1363.6 389.757C1364.16 389.237 1364.56 388.582 1364.77 387.852L1364.95 387.281C1366.12 383.285 1361.27 380.289 1358.23 383.127V380.967C1358.23 376.572 1352.71 374.612 1349.94 378.022C1351.26 372.698 1345.15 368.674 1340.79 371.996L1339.57 372.916L1339.24 371.857C1338.06 368.205 1334.1 366.254 1330.49 367.559C1326.91 368.856 1325.1 372.86 1326.5 376.405L1327.14 378.022C1321.79 378.022 1318.8 384.187 1322.11 388.386L1324.62 391.583C1326.21 393.599 1328.64 394.779 1331.2 394.779H1331.2Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.72 394.778H1352.45C1355.23 394.778 1357.91 393.77 1360.01 391.944L1361.65 390.513C1362.16 390.063 1362.54 389.477 1362.75 388.822C1363.88 385.236 1359.6 382.383 1356.76 384.855V383.336C1356.76 379.349 1351.81 377.5 1349.19 380.506C1350.43 375.893 1345.21 372.274 1341.32 375.038L1339.75 376.158L1339.45 375.312C1338.36 372.13 1334.9 370.43 1331.72 371.507C1328.35 372.646 1326.66 376.404 1328.05 379.675L1328.4 380.511C1323.64 380.511 1321.06 386.072 1324.13 389.71L1326.26 392.246C1327.62 393.854 1329.61 394.783 1331.72 394.783L1331.72 394.778Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.38 394.174L1351.27 382.945",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.02 389.314L1357.95 388.102",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.11 380.213L1349.15 385.979",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.81 390.833L1342.78 386.583",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.07 394.779H1897.6C1894.68 394.779 1891.86 393.669 1889.72 391.671L1887.67 389.757C1887.11 389.237 1886.71 388.582 1886.5 387.852L1886.32 387.281C1885.15 383.285 1889.99 380.289 1893.04 383.127V380.967C1893.04 376.572 1898.56 374.612 1901.33 378.022C1900.01 372.698 1906.12 368.674 1910.48 371.996L1911.7 372.916L1912.03 371.857C1913.21 368.205 1917.17 366.254 1920.78 367.559C1924.36 368.856 1926.17 372.86 1924.77 376.405L1924.13 378.022C1929.48 378.022 1932.47 384.187 1929.16 388.386L1926.65 391.583C1925.06 393.599 1922.63 394.779 1920.07 394.779H1920.07Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.55 394.778H1898.82C1896.04 394.778 1893.35 393.77 1891.26 391.944L1889.62 390.513C1889.1 390.062 1888.72 389.477 1888.51 388.822C1887.38 385.235 1891.66 382.383 1894.51 384.854V383.335C1894.51 379.349 1899.45 377.5 1902.07 380.506C1900.84 375.893 1906.05 372.273 1909.95 375.038L1911.52 376.157L1911.81 375.312C1912.9 372.129 1916.36 370.429 1919.55 371.507C1922.91 372.645 1924.6 376.404 1923.22 379.674L1922.86 380.51C1927.62 380.51 1930.21 386.071 1927.14 389.709L1925 392.246C1923.65 393.853 1921.65 394.782 1919.54 394.782L1919.55 394.778Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.42 375.66L1913.66 393.872",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.19 385.673L1914.26 391.136",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 413.598H50.7793V419.67H2041.1V413.598Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.645 379.305H503.294V394.478H533.645V379.305Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.645 388.405H503.294V394.477H533.645V388.405Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.962 390.919H507.537V394.478H509.962V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.887 390.919H512.462V394.478H514.887V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.567 390.919H518.142V394.478H520.567V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.493 390.919H523.067V394.478H525.493V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.797 390.919H528.372V394.478H530.797V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.962 381.068H507.537V386.523H509.962V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.887 381.068H512.462V386.523H514.887V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.567 381.068H518.142V386.523H520.567V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.493 381.068H523.067V386.523H525.493V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.797 381.068H528.372V386.523H530.797V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.593 371.564L504.195 379.299H532.758L518.593 371.564Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.685 380.215L501.166 379.179L518.783 369.896L535.828 379.179L534.551 380.521L518.467 371.718L502.685 380.215Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.5 379.305H1132.14V394.478H1162.5V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.5 388.405H1132.14V394.477H1162.5V388.405Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.81 390.919H1136.39V394.478H1138.81V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.73 390.919H1141.31V394.478H1143.73V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.41 390.919H1146.99V394.478H1149.41V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.34 390.919H1151.91V394.478H1154.34V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.64 390.919H1157.22V394.478H1159.64V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.81 381.068H1136.39V386.522H1138.81V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.73 381.068H1141.31V386.522H1143.73V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.41 381.068H1146.99V386.522H1149.41V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.34 381.068H1151.91V386.522H1154.34V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.64 381.068H1157.22V386.522H1159.64V381.068Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.45 371.564L1133.05 379.299H1161.61L1147.45 371.564Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.54 380.215L1130.02 379.179L1147.63 369.896L1164.68 379.179L1163.4 380.521L1147.32 371.718L1131.54 380.215Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.42 379.306H1594.07V394.479H1624.42V379.306Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.42 388.406H1594.07V394.478H1624.42V388.406Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.74 390.919H1598.31V394.478H1600.74V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.66 390.919H1603.24V394.478H1605.66V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.34 390.919H1608.91V394.478H1611.34V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.26 390.919H1613.84V394.478H1616.26V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.57 390.919H1619.14V394.478H1621.57V390.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.74 381.069H1598.31V386.523H1600.74V381.069Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.66 381.069H1603.24V386.523H1605.66V381.069Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.34 381.069H1608.91V386.523H1611.34V381.069Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.26 381.069H1613.84V386.523H1616.26V381.069Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.57 381.069H1619.14V386.523H1621.57V381.069Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.37 371.564L1594.97 379.299H1623.53L1609.37 371.564Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.46 380.215L1591.94 379.179L1609.56 369.897L1626.61 379.179L1625.33 380.522L1609.24 371.718L1593.46 380.215Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.672 382.638C602.352 382.638 628.034 356.956 628.034 325.277C628.034 293.597 602.352 267.915 570.672 267.915C538.993 267.915 513.311 293.597 513.311 325.277C513.311 356.956 538.993 382.638 570.672 382.638ZM570.672 377.783C599.671 377.783 623.179 354.276 623.179 325.277C623.179 296.278 599.671 272.77 570.672 272.77C541.673 272.77 518.165 296.278 518.165 325.277C518.165 354.276 541.673 377.783 570.672 377.783Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.673 355.931C587.602 355.931 601.325 342.342 601.325 325.58C601.325 308.818 587.602 295.229 570.673 295.229C553.743 295.229 540.02 308.818 540.02 325.58C540.02 342.342 553.743 355.931 570.673 355.931ZM570.673 351.685C585.256 351.685 597.079 340.001 597.079 325.585C597.079 311.169 585.256 299.485 570.673 299.485C556.089 299.485 544.266 311.169 544.266 325.585C544.266 340.001 556.089 351.685 570.673 351.685Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.672 382.638C602.352 382.638 628.034 356.957 628.034 325.277C628.034 293.597 602.352 267.915 570.672 267.915C538.992 267.915 513.311 293.597 513.311 325.277C513.311 356.957 538.992 382.638 570.672 382.638Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.278 377.783V382.638",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.655 376.875L559.744 381.428",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.673 377.785C599.671 377.785 623.179 354.276 623.179 325.278C623.179 296.279 599.671 272.771 570.673 272.771C541.674 272.771 518.166 296.279 518.166 325.278C518.166 354.276 541.674 377.785 570.673 377.785Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.674 371.717C596.319 371.717 617.109 351.062 617.109 325.584C617.109 300.105 596.319 279.451 570.674 279.451C545.029 279.451 524.239 300.105 524.239 325.584C524.239 351.062 545.029 371.717 570.674 371.717Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.673 365.645C592.631 365.645 610.431 347.709 610.431 325.584C610.431 303.459 592.631 285.523 570.673 285.523C548.715 285.523 530.914 303.459 530.914 325.584C530.914 347.709 548.715 365.645 570.673 365.645Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.672 360.792C589.949 360.792 605.576 345.029 605.576 325.586C605.576 306.142 589.949 290.38 570.672 290.38C551.396 290.38 535.769 306.142 535.769 325.586C535.769 345.029 551.396 360.792 570.672 360.792Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.673 355.937C587.602 355.937 601.325 342.349 601.325 325.586C601.325 308.824 587.602 295.235 570.673 295.235C553.743 295.235 540.02 308.824 540.02 325.586C540.02 342.349 553.743 355.937 570.673 355.937Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.674 351.685C585.258 351.685 597.081 340 597.081 325.585C597.081 311.17 585.258 299.485 570.674 299.485C556.09 299.485 544.268 311.17 544.268 325.585C544.268 340 556.09 351.685 570.674 351.685Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.672 341.975C579.891 341.975 587.364 334.636 587.364 325.584C587.364 316.532 579.891 309.194 570.672 309.194C561.453 309.194 553.979 316.532 553.979 325.584C553.979 334.636 561.453 341.975 570.672 341.975Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.181 386.583H603.147C602.418 385.37 602.845 383.851 603.147 383.243H606.181C606.91 384.701 606.483 386.077 606.181 386.583Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.22 390.227H589.186C588.457 389.014 588.884 387.495 589.186 386.886H592.22C592.949 388.345 592.522 389.72 592.22 390.227Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.471 392.656H576.437C575.708 391.443 576.135 389.924 576.437 389.315H579.471C580.2 390.774 579.773 392.149 579.471 392.656Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.12 392.656H563.087C562.357 391.443 562.785 389.924 563.087 389.315H566.12C566.85 390.774 566.422 392.149 566.12 392.656Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.981 390.834H550.947C550.218 389.622 550.645 388.103 550.947 387.494H553.981C554.71 388.953 554.283 390.328 553.981 390.834Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.109 378.695H614.075C613.346 377.483 613.773 375.964 614.075 375.355H617.109C617.838 376.814 617.411 378.189 617.109 378.695Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.817 367.768H623.783C623.054 366.556 623.481 365.036 623.783 364.428H626.817C627.546 365.887 627.119 367.262 626.817 367.768Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.498 355.629H630.465C629.735 354.416 630.163 352.897 630.465 352.289H633.498C634.228 353.747 633.8 355.123 633.498 355.629Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.351 342.277H635.317C634.588 341.064 635.015 339.545 635.317 338.937H638.351C639.08 340.395 638.653 341.77 638.351 342.277Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.564 328.315H636.53C635.801 327.103 636.228 325.584 636.53 324.975H639.564C640.293 326.434 639.866 327.809 639.564 328.315Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.745 314.352H634.712C633.982 313.139 634.41 311.62 634.712 311.011H637.745C638.475 312.47 638.047 313.845 637.745 314.352Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.889 300.999H629.855C629.126 299.786 629.553 298.267 629.855 297.658H632.889C633.618 299.117 633.191 300.492 632.889 300.999Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.213 288.252H623.18C622.45 287.039 622.878 285.52 623.18 284.912H626.213C626.943 286.37 626.515 287.746 626.213 288.252Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.497 278.541H613.464C612.734 277.329 613.162 275.81 613.464 275.201H616.497C617.227 276.66 616.799 278.035 616.497 278.541Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.968 270.044H601.934C601.205 268.832 601.632 267.313 601.934 266.704H604.968C605.697 268.163 605.27 269.538 604.968 270.044Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.22 265.184H589.186C588.457 263.972 588.884 262.452 589.186 261.844H592.22C592.949 263.303 592.522 264.678 592.22 265.184Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.259 262.15H575.225C574.496 260.938 574.923 259.419 575.225 258.81H578.259C578.989 260.269 578.561 261.644 578.259 262.15Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.299 262.759H561.265C560.536 261.547 560.963 260.028 561.265 259.419H564.299C565.028 260.878 564.601 262.253 564.299 262.759Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.338 265.793H547.305C546.575 264.581 547.003 263.062 547.305 262.453H550.338C551.068 263.912 550.64 265.287 550.338 265.793Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.2 271.255H535.166C534.436 270.043 534.864 268.524 535.166 267.915H538.2C538.929 269.374 538.502 270.749 538.2 271.255Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.663 279.754H523.63C522.9 278.541 523.328 277.022 523.63 276.414H526.663C527.393 277.872 526.965 279.248 526.663 279.754Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.557 290.072H514.523C513.794 288.86 514.221 287.341 514.523 286.732H517.557C518.286 288.191 517.859 289.566 517.557 290.072Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.277 302.82H507.243C506.514 301.608 506.941 300.089 507.243 299.48H510.277C511.006 300.939 510.579 302.314 510.277 302.82Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.635 315.568H503.601C502.872 314.356 503.299 312.837 503.601 312.228H506.635C507.364 313.687 506.937 315.062 506.635 315.568Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.417 329.53H502.384C501.654 328.318 502.082 326.799 502.384 326.19H505.417C506.147 327.649 505.719 329.024 505.417 329.53Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.635 343.49H503.601C502.872 342.277 503.299 340.758 503.601 340.149H506.635C507.364 341.608 506.937 342.983 506.635 343.49Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.881 356.84H507.847C507.118 355.628 507.545 354.109 507.847 353.5H510.881C511.611 354.959 511.183 356.334 510.881 356.84Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.166 368.981H515.133C514.403 367.768 514.831 366.249 515.133 365.641H518.166C518.896 367.099 518.468 368.475 518.166 368.981Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.881 379.304H524.847C524.118 378.091 524.545 376.572 524.847 375.963H527.881C528.611 377.422 528.183 378.797 527.881 379.304Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.41 387.193H536.377C535.647 385.981 536.075 384.462 536.377 383.853H539.41C540.14 385.312 539.712 386.687 539.41 387.193Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.864 288.559L570.064 325.284",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.271 278.54L570.064 325.277",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.198 270.954L570.064 324.975",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.338 265.793L570.371 324.976",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.387 262.759L570.369 324.976",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.437 262.149L570.672 324.064",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.487 265.184L570.672 324.975",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.933 270.043L570.672 325.281",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.162 277.324L570.672 325.278",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.872 286.736L570.672 325.282",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.551 298.267L571.278 325.278",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.71 311.015L570.975 325.278",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.744 324.975L570.366 325.584",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.531 338.936L571.281 325.584",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.978 351.986L570.672 325.58",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.303 364.431L570.371 325.281",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.895 375.355L570.979 325.58",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.661 383.248L570.366 325.278",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.008 386.584L570.371 325.278",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.579 299.786L570.37 325.584",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.938 312.836L570.065 325.584",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.725 326.493L570.673 325.281",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.634 340.149L570.369 325.58",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.668 353.504L571.28 325.281",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.647 365.645L570.065 325.584",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.361 375.963L570.975 324.975",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.892 383.851L570.668 324.971",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.549 387.494L570.671 324.669",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.601 389.315L570.673 324.975",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.259 389.013L570.366 324.975",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.111 283.395L536.379 279.451",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.914 290.68L527.271 287.948",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.844 299.786L520.899 297.356",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.289 309.804L515.736 308.592",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.166 321.03L513.915 320.421",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.468 331.953L513.915 332.562",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.898 342.578L516.647 344.399",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.753 352.289L521.809 354.718",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.126 361.093L528.786 364.434",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.623 368.376L537.892 372.32",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.818 277.325L546.695 273.381",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.137 273.987L557.925 269.435",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.062 267.915V272.77",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.205 269.134L581.294 273.687",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.738 272.776L591.615 277.027",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.058 278.844L601.326 282.486",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.857 286.43L609.215 289.77",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.141 296.445L616.196 298.568",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.996 307.071L620.745 308.59",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.727 318.904L622.872 319.512",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.727 331.043L623.174 330.435",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.605 342.278L621.052 341.065",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.446 353.199L616.502 350.769",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.464 362.911L610.124 360.18",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.661 371.109L601.93 367.467",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.041 377.174L592.22 373.23",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.114 376.572L584.327 380.823",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.501 268.524L550.942 271.256",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.444 275.2L547.606 265.49",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.641 262.759L562.478 268.525",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.979 270.346L560.962 261.849",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.907 260.632L574.013 267.916",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.818 268.222L574.924 260.635",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.149 270.045L578.864 261.241",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.957 268.221L588.884 262.149",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.521 264.582L597.683 274.598",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.489 270.955L601.327 268.223",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.661 270.043L607.393 281.272",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.415 275.81L613.465 275.201",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.124 283.698L623.174 284.911",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.588 289.467V278.54",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.019 292.804L631.069 297.357",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.265 300.088L623.784 288.251",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.481 302.519L636.23 311.016",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.515 311.625L630.766 301.004",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.818 313.747L637.439 324.976",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.71 314.049L628.034 323.457",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.034 326.797L636.531 338.634",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.123 335.595L636.229 327.4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.818 338.327L631.98 351.986",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.783 346.829L635.012 339.846",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.872 349.558L625.302 364.127",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.319 357.449L630.157 353.504",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.498 359.879L616.196 375.052",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.783 364.734L610.124 366.857",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.303 368.677L605.27 383.246",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.022 373.84L614.072 375.359",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.146 383.248L588.884 380.214",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.594 375.052L592.521 387.191",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.98 380.214L539.411 383.856",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.75 375.661L550.945 387.192",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.54 359.575L511.188 354.413",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.076 350.466L516.345 365.337",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.468 349.254L507.239 341.667",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.133 339.545L509.972 353.506",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.31 324.976L506.634 315.568",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.221 315.568L504.205 326.189",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.521 312.837L510.271 302.519",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.954 304.34L506.938 312.233",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.469 301.302L516.647 290.073",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.019 293.413L510.271 299.485",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.542 290.983V279.754",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.305 284.308L517.255 286.431",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.019 276.72H526.969",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.036 281.878L535.159 271.257",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.524 337.115L505.72 328.618",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.31 327.708L505.115 340.149",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.45 361.093V375.662",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.825 367.467L518.166 365.646",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.533 374.753L527.874 375.966",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.949 369.288L537.893 383.857",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.803 394.779L569.456 324.669L570.669 328.614L543.96 394.774H538.799L538.803 394.779Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.717 395.997L571.584 323.462L570.371 327.406L596.471 395.997H600.722H600.717Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.366 331.048C573.383 331.048 575.829 328.601 575.829 325.584C575.829 322.567 573.383 320.121 570.366 320.121C567.348 320.121 564.902 322.567 564.902 325.584C564.902 328.601 567.348 331.048 570.366 331.048Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.193 380.517L563.087 389.014",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.69 382.336L554.282 387.8",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.639 382.639L576.136 389.315",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.137 382.639L566.121 389.621",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.17 382.036L588.88 387.197",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.756 380.517L579.773 389.32",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.35 405.098L1257.13 408.188C1262.04 408.731 1266.74 406.102 1268.84 401.637L1270.21 398.729C1270.67 397.753 1270.88 396.68 1270.82 395.607L1270.67 392.717C1270.36 386.692 1262.2 385.084 1259.62 390.539L1258.2 385.907C1256.34 379.863 1247.8 379.825 1245.89 385.856C1245.12 377.256 1233.81 374.645 1229.35 382.037L1228.19 380.202C1225.02 375.189 1218.15 374.13 1213.61 377.948C1209.71 381.238 1208.99 386.98 1211.97 391.129L1214.99 395.342C1210.8 396.629 1211.31 402.711 1215.65 403.282L1229.35 405.094L1229.35 405.098Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.45 405.097L1255.24 408.075C1260.12 408.66 1264.84 406.086 1266.99 401.664L1267.94 399.689C1268.38 398.792 1268.59 397.803 1268.54 396.809L1268.43 394.449C1268.17 388.906 1260.69 387.364 1258.27 392.349L1257.03 388.325C1255.32 382.76 1247.47 382.681 1245.65 388.209C1244.99 380.395 1234.75 377.937 1230.61 384.6L1230.45 384.869L1229.42 383.266C1226.5 378.718 1220.27 377.747 1216.1 381.19C1212.44 384.219 1211.77 389.58 1214.56 393.422L1217.14 396.962C1213.49 398.082 1214.02 403.401 1217.81 403.791L1230.44 405.092L1230.45 405.097Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.19 405.577L1176.04 399.175C1172.1 397.098 1169.7 392.94 1169.89 388.489L1170.06 384.327C1170.1 383.249 1170.42 382.204 1170.97 381.274L1172.44 378.784C1175.51 373.59 1183.48 375.941 1183.23 381.971L1186.64 378.529C1191.09 374.032 1198.68 377.957 1197.57 384.187C1202.23 376.921 1213.47 379.848 1214 388.466L1215.88 387.379C1221.01 384.406 1227.59 386.645 1229.84 392.132C1231.78 396.856 1229.75 402.278 1225.19 404.573L1220.56 406.91H1193.57C1191.69 406.91 1189.85 406.455 1188.19 405.581L1188.19 405.577Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.71 403.389L1175.78 400.23C1172.97 397.967 1171.38 394.516 1171.48 390.906L1171.62 386.232C1171.65 385.238 1171.92 384.267 1172.43 383.408L1173.62 381.368C1176.41 376.578 1183.75 378.669 1183.6 384.211L1186.55 381.219C1190.65 377.08 1197.64 380.643 1196.69 386.39C1200.9 379.77 1211.11 382.334 1211.69 390.158L1211.72 390.474L1213.37 389.531C1218.06 386.85 1224.04 388.88 1226.13 393.861C1227.97 398.242 1226.09 403.301 1221.83 405.415L1217.9 407.357H1196.7L1185.41 405.842C1183.33 405.563 1181.35 404.718 1179.71 403.398L1179.71 403.389Z",
    fill: "#7CC69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.14 386.263C1135.21 384.079 1135.63 380.799 1134.15 378.17L1125.8 363.215C1124.99 361.761 1122.9 361.761 1122.08 363.215L1113.49 378.611C1112.15 381.009 1112.44 383.991 1114.22 386.086C1115.47 387.559 1117.3 388.405 1119.24 388.405H1128.15C1130.03 388.405 1131.84 387.629 1133.14 386.263Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.64 386.571C1134.64 384.703 1135.03 381.674 1133.58 379.356L1126.61 368.304C1125.66 366.794 1123.46 366.794 1122.51 368.304L1114.55 380.931C1113.66 382.353 1113.84 384.202 1115.01 385.419C1116.65 387.138 1118.93 388.109 1121.31 388.109H1128.75C1130.2 388.109 1131.59 387.561 1132.65 386.576L1132.64 386.571Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.95 372.931V395.388",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.4 374.753L1123.65 379.004",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.5 379.604L1124.25 383.854",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.89 374.753L1123.64 379.004",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.94 395.045C1149.77 392.504 1149.36 387.97 1146.14 385.963L1140.79 382.636C1139.97 382.125 1138.92 382.144 1138.12 382.692L1133.37 385.93C1130.3 388.03 1129.89 392.402 1132.52 395.031C1132.56 395.064 1132.6 395.083 1132.65 395.083H1146.84C1146.88 395.083 1146.91 395.069 1146.94 395.041V395.045Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.94 395.041C1146.91 395.069 1146.88 395.083 1146.84 395.083H1132.65C1132.6 395.083 1132.56 395.064 1132.52 395.031C1129.89 392.402 1130.3 388.03 1133.37 385.93L1138.12 382.692C1138.92 382.144 1139.97 382.125 1140.79 382.636L1146.14 385.963C1149.36 387.97 1149.77 392.504 1146.94 395.045V395.041ZM1146.94 395.041L1147.15 395.268",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.73 394.654C1149.57 392.438 1148.98 389.093 1146.49 387.644L1140.5 384.174C1139.84 383.793 1139.02 383.802 1138.37 384.197L1134.27 386.701C1131.35 388.48 1131.14 392.638 1133.87 394.701C1133.93 394.752 1134.01 394.775 1134.09 394.775H1147.45C1147.56 394.775 1147.66 394.729 1147.73 394.645V394.654Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.34 389.924V394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.39 388.712L1140.34 392.354",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.37 390.533L1140.34 393.873",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.27 326.496H1320.92V337.423H1334.27V326.496Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.88 329.366V337.418H1320.91V326.834L1317.88 329.362V329.366Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.13 341.06H1152.78V344.702H1339.13V341.06Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.04 350.164L1149.96 346.522H1343.09L1340.49 350.164H1152.04Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.21 350.165H1152.17V394.476H1172.21V350.165Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.21 350.165H1152.17V354.415H1172.21V350.165Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.34 350.165H1320.31V354.415H1340.34V350.165Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.95 378.697H1156.42V394.479H1167.95V378.697Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.78 375.052H1155.21V376.264H1169.78V375.052Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.32 378.695L1155.35 376.266H1169.55L1168.09 378.695H1156.32Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.92 381.125H1160.06V394.477H1164.92V381.125Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.13 367.159H1158.85V369.588H1166.13V367.159Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.71 382.337H1161.28V388.409H1163.71V382.337Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.34 350.165H1320.31V394.476H1340.34V350.165Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.31 350.165H1172.2V353.807H1320.31V350.165Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.31 353.807H1172.2V358.661H1320.31V353.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.49 358.663H1172.2V394.477H1179.49V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.52 358.663H1192.24V394.477H1199.52V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.37 358.663H1214.08V394.477H1221.37V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.01 358.663H1234.72V394.477H1242.01V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.61 358.663H1252.33V394.477H1259.61V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.85 358.663H1272.36V394.477H1280.85V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.1 358.663H1291.78V394.477H1302.1V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.31 358.663H1309.99V394.477H1320.31V358.663Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.45 353.807H1172.2V355.628H1176.45V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.84 355.627H1172.2V394.475H1175.84V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.31 353.807H1316.06V355.628H1320.31V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.31 355.627H1316.67V394.475H1320.31V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.48 353.807H1191.63V355.628H1196.48V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.88 355.627H1192.24V394.475H1195.88V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.34 353.807H1213.48V355.628H1218.34V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.73 355.627H1214.08V394.475H1217.73V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.97 353.807H1234.12V355.628H1238.97V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.37 355.627H1234.72V394.475H1238.37V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.22 353.807H1255.36V355.628H1260.22V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.61 355.627H1255.97V394.475H1259.61V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.46 353.807H1276.61V355.628H1281.46V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.86 355.627H1277.22V394.475H1280.86V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.71 353.807H1297.85V355.628H1302.71V353.807Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.1 355.627H1298.46V394.475H1302.1V355.627Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.63 339.238L1151.26 337.417H1341.86L1340.5 339.238H1152.63Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.63 341.06L1151.26 339.239H1341.86L1340.5 341.06H1152.63Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.65 346.522L1148.24 344.701H1344.88L1343.47 346.522H1149.65Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.49 365.953C1164.84 365.953 1166.74 364.05 1166.74 361.702C1166.74 359.354 1164.84 357.451 1162.49 357.451C1160.14 357.451 1158.24 359.354 1158.24 361.702C1158.24 364.05 1160.14 365.953 1162.49 365.953Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.49 364.734C1164.17 364.734 1165.53 363.376 1165.53 361.7C1165.53 360.025 1164.17 358.667 1162.49 358.667C1160.82 358.667 1159.46 360.025 1159.46 361.7C1159.46 363.376 1160.82 364.734 1162.49 364.734Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.79 327.708L1244.13 330.138L1248.68 337.422C1247.57 337.422 1244.98 337.362 1243.52 337.12C1240.61 335.42 1240.89 331.355 1241.4 329.534L1240.79 327.713V327.708Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.37 328.919L1241.71 331.042L1246.26 337.416C1245.15 337.416 1242.56 337.365 1241.1 337.151C1238.19 335.665 1238.47 332.106 1238.98 330.512L1238.37 328.919Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.94 329.528L1239.28 331.503L1243.83 337.422C1242.72 337.422 1240.13 337.37 1238.67 337.175C1235.76 335.795 1236.04 332.488 1236.55 331.01L1235.94 329.528Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.9 330.741L1236.24 332.409L1240.8 337.417C1239.69 337.417 1237.09 337.375 1235.64 337.208C1232.72 336.037 1233.01 333.245 1233.51 331.991L1232.9 330.741Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.08 333.174L1234.42 334.238L1238.98 337.425C1237.87 337.425 1235.27 337.397 1233.81 337.29C1230.9 336.547 1231.19 334.767 1231.69 333.968L1231.08 333.174Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.75 327.708L1251.41 330.138L1246.86 337.422C1247.97 337.422 1250.56 337.362 1252.02 337.12C1254.93 335.42 1254.65 331.355 1254.15 329.534L1254.75 327.713V327.708Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.18 328.919L1253.84 331.042L1249.29 337.416C1250.4 337.416 1252.99 337.365 1254.45 337.151C1257.36 335.665 1257.08 332.106 1256.57 330.512L1257.18 328.919Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.61 329.528L1256.27 331.503L1251.72 337.422C1252.83 337.422 1255.42 337.37 1256.88 337.175C1259.79 335.795 1259.51 332.488 1259 331.01L1259.61 329.528Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.65 330.741L1259.31 332.409L1254.75 337.417C1255.86 337.417 1258.46 337.375 1259.92 337.208C1262.83 336.037 1262.54 333.245 1262.04 331.991L1262.65 330.741Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.47 333.174L1261.13 334.238L1256.57 337.425C1257.68 337.425 1260.28 337.397 1261.73 337.29C1264.65 336.547 1264.36 334.767 1263.86 333.968L1264.47 333.174Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.77 336.205C1249.95 336.205 1251.72 334.439 1251.72 332.261C1251.72 330.082 1249.95 328.316 1247.77 328.316C1245.6 328.316 1243.83 330.082 1243.83 332.261C1243.83 334.439 1245.6 336.205 1247.77 336.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.77 334.992C1249.28 334.992 1250.51 333.769 1250.51 332.26C1250.51 330.751 1249.28 329.528 1247.77 329.528C1246.27 329.528 1245.04 330.751 1245.04 332.26C1245.04 333.769 1246.27 334.992 1247.77 334.992Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.67 359.071L1156.34 357.919C1156.23 357.534 1156.52 357.143 1156.93 357.143H1158.43C1158.51 357.143 1158.59 357.129 1158.65 357.102L1162.24 355.722C1162.4 355.661 1162.58 355.671 1162.73 355.745L1166.5 357.627C1166.65 357.706 1166.83 357.71 1166.99 357.645L1167.63 357.39C1167.97 357.255 1168.34 357.441 1168.44 357.784L1168.81 359.062C1168.85 359.192 1168.84 359.332 1168.79 359.452L1168.38 360.479C1168.3 360.665 1168.32 360.874 1168.43 361.041L1168.7 361.441C1168.8 361.599 1168.83 361.794 1168.77 361.97L1168.35 363.229C1168.3 363.406 1168.32 363.601 1168.43 363.759L1168.68 364.131C1168.8 364.312 1168.81 364.544 1168.71 364.739L1168.4 365.366C1168.31 365.538 1168.31 365.738 1168.4 365.91L1168.75 366.607C1168.83 366.76 1168.83 366.941 1168.77 367.104L1168.39 368.07C1168.31 368.256 1168.33 368.465 1168.44 368.632L1168.65 368.939C1168.78 369.143 1168.78 369.408 1168.65 369.613L1168.46 369.891C1168.34 370.073 1168.32 370.305 1168.42 370.5L1168.74 371.127C1168.82 371.299 1168.82 371.499 1168.74 371.671L1168.38 372.382C1168.3 372.526 1168.32 372.697 1168.41 372.828C1168.61 373.125 1168.39 373.524 1168.04 373.524H1157.06C1156.86 373.524 1156.67 373.422 1156.55 373.255L1156.32 372.907C1156.2 372.725 1156.18 372.493 1156.28 372.298L1156.6 371.671C1156.68 371.499 1156.68 371.299 1156.6 371.127L1156.28 370.5C1156.18 370.305 1156.2 370.073 1156.32 369.891L1156.51 369.613C1156.64 369.408 1156.64 369.143 1156.51 368.939L1156.3 368.632C1156.19 368.465 1156.17 368.256 1156.25 368.07L1156.63 367.104C1156.69 366.941 1156.69 366.76 1156.61 366.607L1156.26 365.91C1156.17 365.738 1156.17 365.538 1156.26 365.366L1156.6 364.693C1156.68 364.521 1156.68 364.321 1156.6 364.149L1156.24 363.452C1156.17 363.299 1156.16 363.118 1156.23 362.955L1156.61 361.989C1156.69 361.803 1156.66 361.594 1156.55 361.427L1156.3 361.046C1156.18 360.879 1156.16 360.67 1156.24 360.484L1156.65 359.457C1156.7 359.332 1156.71 359.192 1156.67 359.067V359.071Z",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.09 378.697H1324.56V394.479H1336.09V378.697Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.91 375.052H1323.34V376.264H1337.91V375.052Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.46 378.695L1323.49 376.266H1337.68L1336.23 378.695H1324.46Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.06 381.125H1328.2V394.477H1333.06V381.125Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.27 367.159H1326.99V369.588H1334.27V367.159Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.85 382.337H1329.42V388.409H1331.85V382.337Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.63 365.953C1332.98 365.953 1334.88 364.05 1334.88 361.702C1334.88 359.354 1332.98 357.451 1330.63 357.451C1328.28 357.451 1326.38 359.354 1326.38 361.702C1326.38 364.05 1328.28 365.953 1330.63 365.953Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.63 364.734C1332.3 364.734 1333.66 363.376 1333.66 361.7C1333.66 360.025 1332.3 358.667 1330.63 358.667C1328.95 358.667 1327.59 360.025 1327.59 361.7C1327.59 363.376 1328.95 364.734 1330.63 364.734Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.81 359.071L1324.47 357.919C1324.36 357.534 1324.65 357.143 1325.06 357.143H1326.57C1326.65 357.143 1326.72 357.129 1326.79 357.102L1330.38 355.722C1330.54 355.661 1330.72 355.671 1330.87 355.745L1334.63 357.627C1334.79 357.706 1334.97 357.71 1335.13 357.645L1335.77 357.39C1336.1 357.255 1336.48 357.441 1336.58 357.784L1336.95 359.062C1336.98 359.192 1336.98 359.332 1336.92 359.452L1336.51 360.479C1336.44 360.665 1336.46 360.874 1336.57 361.041L1336.84 361.441C1336.94 361.599 1336.96 361.794 1336.91 361.97L1336.49 363.229C1336.43 363.406 1336.45 363.601 1336.56 363.759L1336.81 364.131C1336.93 364.312 1336.95 364.544 1336.85 364.739L1336.53 365.366C1336.45 365.538 1336.45 365.738 1336.53 365.91L1336.89 366.607C1336.97 366.76 1336.97 366.941 1336.91 367.104L1336.52 368.07C1336.45 368.256 1336.47 368.465 1336.58 368.632L1336.78 368.939C1336.92 369.143 1336.92 369.408 1336.78 369.613L1336.6 369.891C1336.48 370.073 1336.46 370.305 1336.56 370.5L1336.88 371.127C1336.96 371.299 1336.96 371.499 1336.88 371.671L1336.52 372.382C1336.45 372.526 1336.46 372.697 1336.55 372.828C1336.75 373.125 1336.53 373.524 1336.18 373.524H1325.2C1325 373.524 1324.81 373.422 1324.69 373.255L1324.46 372.907C1324.34 372.725 1324.32 372.493 1324.42 372.298L1324.74 371.671C1324.82 371.499 1324.82 371.299 1324.74 371.127L1324.42 370.5C1324.32 370.305 1324.34 370.073 1324.46 369.891L1324.64 369.613C1324.78 369.408 1324.78 369.143 1324.64 368.939L1324.44 368.632C1324.33 368.465 1324.31 368.256 1324.38 368.07L1324.77 367.104C1324.83 366.941 1324.83 366.76 1324.75 366.607L1324.39 365.91C1324.31 365.738 1324.31 365.538 1324.39 365.366L1324.73 364.693C1324.82 364.521 1324.82 364.321 1324.73 364.149L1324.38 363.452C1324.3 363.299 1324.3 363.118 1324.36 362.955L1324.74 361.989C1324.82 361.803 1324.8 361.594 1324.69 361.427L1324.43 361.046C1324.32 360.879 1324.3 360.67 1324.38 360.484L1324.78 359.457C1324.84 359.332 1324.84 359.192 1324.81 359.067V359.071Z",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.59 326.496H1158.24V337.423H1171.59V326.496Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.63 329.366V337.418H1171.6V326.834L1174.63 329.362V329.366Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.47 330.889L1156.63 336.928C1156.68 337.216 1156.94 337.421 1157.23 337.421H1222.59C1222.92 337.421 1223.19 337.147 1223.19 336.812V335.205C1223.19 335.065 1223.15 334.931 1223.06 334.824L1222.09 333.611C1222.01 333.518 1221.97 333.407 1221.96 333.291L1221.68 330.517C1221.68 330.461 1221.67 330.41 1221.65 330.359L1220.85 328.296C1220.67 327.813 1219.96 327.892 1219.89 328.408C1219.81 328.947 1219.05 328.998 1218.9 328.473L1218.88 328.375C1218.72 327.86 1217.99 327.874 1217.87 328.394L1217.69 329.095C1217.55 329.634 1216.78 329.616 1216.67 329.072L1216.58 328.635C1216.49 328.194 1215.87 328.18 1215.76 328.617L1215.72 328.77C1215.62 329.17 1215.05 329.156 1214.97 328.752C1214.89 328.371 1214.35 328.329 1214.22 328.696L1213.94 329.476C1213.8 329.867 1213.23 329.843 1213.13 329.444C1213 328.993 1212.35 329.04 1212.29 329.5L1212.28 329.574C1212.22 330.062 1211.52 330.094 1211.41 329.616L1211.12 328.366C1211 327.92 1210.38 327.887 1210.24 328.329L1210.13 328.649C1209.99 329.049 1209.41 328.979 1209.37 328.561C1209.34 328.148 1208.76 328.069 1208.62 328.459L1208.47 328.882C1208.31 329.309 1207.71 329.309 1207.56 328.882L1207.32 328.227C1207.16 327.795 1206.54 327.827 1206.43 328.273L1206.36 328.538C1206.26 328.965 1205.64 328.942 1205.57 328.505C1205.49 328.083 1204.9 328.041 1204.77 328.454L1204.51 329.332C1204.39 329.718 1203.84 329.695 1203.75 329.304L1203.71 329.133C1203.64 328.803 1203.18 328.77 1203.06 329.086C1202.94 329.421 1202.45 329.356 1202.41 329.002V328.947C1202.37 328.575 1201.85 328.51 1201.72 328.863L1201.61 329.179C1201.45 329.597 1200.85 329.537 1200.78 329.095L1200.72 328.752C1200.66 328.338 1200.08 328.32 1199.98 328.724L1199.97 328.775C1199.88 329.174 1199.3 329.146 1199.25 328.742L1199.22 328.51C1199.16 328.129 1198.61 328.12 1198.56 328.505C1198.5 328.868 1197.99 328.891 1197.9 328.538L1197.82 328.199C1197.72 327.785 1197.12 327.795 1197.03 328.213L1196.95 328.547C1196.84 329.058 1196.12 329.058 1196.01 328.547L1195.99 328.468C1195.88 327.957 1195.16 327.934 1195.02 328.436L1194.91 328.812C1194.74 329.383 1193.93 329.388 1193.76 328.817C1193.58 328.236 1192.75 328.25 1192.6 328.835L1192.55 329.021C1192.39 329.63 1191.52 329.62 1191.38 329.002L1191.19 328.222C1191.08 327.748 1190.4 327.757 1190.31 328.236L1190.27 328.394C1190.18 328.858 1189.51 328.845 1189.44 328.375C1189.37 327.943 1188.78 327.883 1188.62 328.287L1188.4 328.868C1188.22 329.365 1187.49 329.277 1187.41 328.752C1187.34 328.194 1186.55 328.143 1186.4 328.687L1186.32 329.021C1186.18 329.551 1185.43 329.583 1185.25 329.068L1185.17 328.845C1185.01 328.399 1184.37 328.426 1184.24 328.882C1184.11 329.369 1183.41 329.356 1183.3 328.863L1183.16 328.245C1183.05 327.781 1182.42 327.72 1182.22 328.157L1182.05 328.533C1181.91 328.849 1181.44 328.803 1181.37 328.464C1181.29 328.083 1180.74 328.092 1180.67 328.473L1180.54 329.1C1180.46 329.523 1179.84 329.504 1179.79 329.077C1179.73 328.649 1179.12 328.631 1179.04 329.054L1178.99 329.286C1178.9 329.737 1178.26 329.737 1178.16 329.286L1178.12 329.054C1178.02 328.584 1177.35 328.594 1177.27 329.063C1177.18 329.551 1176.47 329.514 1176.41 329.021C1176.36 328.552 1175.69 328.487 1175.57 328.947C1175.45 329.342 1174.91 329.379 1174.75 329.002L1174.73 328.961C1174.58 328.603 1174.06 328.598 1173.91 328.956L1173.56 329.741C1173.37 330.178 1172.77 330.229 1172.5 329.829L1171.7 328.635C1171.52 328.361 1171.11 328.385 1170.96 328.682C1170.78 329.054 1170.22 328.975 1170.15 328.566L1170.13 328.487C1170.04 328.008 1169.37 327.976 1169.24 328.45L1169.21 328.552C1169.09 328.989 1168.5 329.035 1168.31 328.626L1167.82 327.553C1167.66 327.2 1167.14 327.242 1167.04 327.613L1166.88 328.166C1166.79 328.501 1166.3 328.459 1166.27 328.11C1166.24 327.767 1165.76 327.72 1165.66 328.05L1165.57 328.347C1165.46 328.7 1164.96 328.7 1164.86 328.347L1164.78 328.083C1164.64 327.641 1164.01 327.655 1163.9 328.101L1163.85 328.31C1163.75 328.738 1163.13 328.714 1163.05 328.282C1162.98 327.874 1162.42 327.827 1162.27 328.217L1162.13 328.603C1161.96 329.077 1161.27 329.049 1161.14 328.561L1161.06 328.254C1160.94 327.818 1160.33 327.804 1160.18 328.231C1160.05 328.649 1159.45 328.649 1159.32 328.231L1159.3 328.166C1159.15 327.73 1158.53 327.73 1158.39 328.166L1158.17 328.807C1158.07 329.119 1157.66 329.193 1157.46 328.937C1157.21 328.631 1156.72 328.803 1156.72 329.198V330.368C1156.72 330.703 1156.3 330.851 1156.09 330.596C1155.85 330.313 1155.39 330.531 1155.46 330.893L1155.47 330.889Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.65 330.889L1336.49 336.928C1336.44 337.216 1336.18 337.421 1335.89 337.421H1270.54C1270.2 337.421 1269.93 337.147 1269.93 336.812V335.205C1269.93 335.065 1269.97 334.931 1270.06 334.824L1271.03 333.611C1271.11 333.518 1271.15 333.407 1271.16 333.291L1271.44 330.517C1271.44 330.461 1271.46 330.41 1271.47 330.359L1272.27 328.296C1272.45 327.813 1273.16 327.892 1273.24 328.408C1273.31 328.947 1274.07 328.998 1274.22 328.473L1274.24 328.375C1274.4 327.86 1275.13 327.874 1275.26 328.394L1275.43 329.095C1275.57 329.634 1276.34 329.616 1276.46 329.072L1276.54 328.635C1276.63 328.194 1277.25 328.18 1277.37 328.617L1277.4 328.77C1277.5 329.17 1278.08 329.156 1278.16 328.752C1278.23 328.371 1278.77 328.329 1278.9 328.696L1279.18 329.476C1279.33 329.867 1279.89 329.843 1280 329.444C1280.12 328.993 1280.77 329.04 1280.83 329.5L1280.85 329.574C1280.91 330.062 1281.6 330.094 1281.71 329.616L1282.01 328.366C1282.12 327.92 1282.74 327.887 1282.88 328.329L1283 328.649C1283.13 329.049 1283.71 328.979 1283.75 328.561C1283.79 328.148 1284.36 328.069 1284.5 328.459L1284.65 328.882C1284.81 329.309 1285.41 329.309 1285.57 328.882L1285.8 328.227C1285.96 327.795 1286.58 327.827 1286.69 328.273L1286.76 328.538C1286.86 328.965 1287.48 328.942 1287.55 328.505C1287.63 328.083 1288.22 328.041 1288.35 328.454L1288.61 329.332C1288.73 329.718 1289.29 329.695 1289.37 329.304L1289.41 329.133C1289.48 328.803 1289.94 328.77 1290.06 329.086C1290.18 329.421 1290.68 329.356 1290.71 329.002V328.947C1290.75 328.575 1291.27 328.51 1291.4 328.863L1291.52 329.179C1291.67 329.597 1292.27 329.537 1292.34 329.095L1292.4 328.752C1292.46 328.338 1293.04 328.32 1293.14 328.724L1293.15 328.775C1293.24 329.174 1293.82 329.146 1293.87 328.742L1293.9 328.51C1293.96 328.129 1294.51 328.12 1294.56 328.505C1294.62 328.868 1295.14 328.891 1295.22 328.538L1295.3 328.199C1295.41 327.785 1296 327.795 1296.09 328.213L1296.17 328.547C1296.28 329.058 1297 329.058 1297.11 328.547L1297.13 328.468C1297.25 327.957 1297.96 327.934 1298.1 328.436L1298.22 328.812C1298.38 329.383 1299.19 329.388 1299.36 328.817C1299.54 328.236 1300.37 328.25 1300.52 328.835L1300.57 329.021C1300.73 329.63 1301.6 329.62 1301.75 329.002L1301.93 328.222C1302.04 327.748 1302.72 327.757 1302.82 328.236L1302.85 328.394C1302.95 328.858 1303.61 328.845 1303.68 328.375C1303.75 327.943 1304.34 327.883 1304.5 328.287L1304.72 328.868C1304.91 329.365 1305.64 329.277 1305.71 328.752C1305.78 328.194 1306.57 328.143 1306.72 328.687L1306.8 329.021C1306.95 329.551 1307.69 329.583 1307.87 329.068L1307.95 328.845C1308.12 328.399 1308.75 328.426 1308.88 328.882C1309.01 329.369 1309.71 329.356 1309.83 328.863L1309.97 328.245C1310.08 327.781 1310.7 327.72 1310.9 328.157L1311.07 328.533C1311.21 328.849 1311.68 328.803 1311.75 328.464C1311.83 328.083 1312.38 328.092 1312.46 328.473L1312.58 329.1C1312.66 329.523 1313.28 329.504 1313.33 329.077C1313.39 328.649 1314 328.631 1314.09 329.054L1314.13 329.286C1314.23 329.737 1314.87 329.737 1314.96 329.286L1315.01 329.054C1315.1 328.584 1315.77 328.594 1315.86 329.063C1315.94 329.551 1316.65 329.514 1316.71 329.021C1316.77 328.552 1317.43 328.487 1317.56 328.947C1317.67 329.342 1318.21 329.379 1318.37 329.002L1318.39 328.961C1318.55 328.603 1319.06 328.598 1319.21 328.956L1319.56 329.741C1319.75 330.178 1320.35 330.229 1320.62 329.829L1321.42 328.635C1321.6 328.361 1322.01 328.385 1322.16 328.682C1322.35 329.054 1322.9 328.975 1322.97 328.566L1322.99 328.487C1323.08 328.008 1323.75 327.976 1323.88 328.45L1323.91 328.552C1324.03 328.989 1324.62 329.035 1324.81 328.626L1325.3 327.553C1325.46 327.2 1325.98 327.242 1326.09 327.613L1326.24 328.166C1326.33 328.501 1326.82 328.459 1326.85 328.11C1326.89 327.767 1327.36 327.72 1327.47 328.05L1327.55 328.347C1327.66 328.7 1328.16 328.7 1328.26 328.347L1328.34 328.083C1328.48 327.641 1329.11 327.655 1329.22 328.101L1329.27 328.31C1329.38 328.738 1329.99 328.714 1330.07 328.282C1330.14 327.874 1330.7 327.827 1330.85 328.217L1330.99 328.603C1331.16 329.077 1331.85 329.049 1331.98 328.561L1332.07 328.254C1332.18 327.818 1332.79 327.804 1332.94 328.231C1333.07 328.649 1333.67 328.649 1333.8 328.231L1333.83 328.166C1333.97 327.73 1334.59 327.73 1334.74 328.166L1334.95 328.807C1335.05 329.119 1335.47 329.193 1335.67 328.937C1335.92 328.631 1336.4 328.803 1336.4 329.198V330.368C1336.4 330.703 1336.82 330.851 1337.04 330.596C1337.27 330.313 1337.73 330.531 1337.66 330.893L1337.65 330.889Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.23 337.115L1270.34 331.99C1270.36 331.126 1271.07 330.439 1271.93 330.439C1272.78 330.439 1273.48 331.112 1273.51 331.963L1273.71 337.115L1273.88 331.893C1273.91 331.084 1274.58 330.439 1275.39 330.439C1276.19 330.439 1276.86 331.08 1276.89 331.888L1277.09 337.115L1277.29 331.935C1277.32 331.098 1278 330.439 1278.84 330.439C1279.67 330.439 1280.36 331.098 1280.39 331.935L1280.58 337.115L1280.83 331.753C1280.86 331.015 1281.47 330.434 1282.21 330.434C1282.97 330.434 1283.59 331.052 1283.59 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.58 337.115L1283.7 331.99C1283.72 331.126 1284.42 330.439 1285.28 330.439C1286.13 330.439 1286.83 331.112 1286.86 331.963L1287.06 337.115L1287.23 331.893C1287.26 331.084 1287.93 330.439 1288.74 330.439C1289.55 330.439 1290.21 331.08 1290.24 331.888L1290.44 337.115L1290.64 331.935C1290.67 331.098 1291.35 330.439 1292.19 330.439C1293.03 330.439 1293.71 331.098 1293.74 331.935L1293.94 337.115L1294.18 331.753C1294.21 331.015 1294.82 330.434 1295.56 330.434C1296.32 330.434 1296.94 331.052 1296.94 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.94 337.115L1297.05 331.99C1297.07 331.126 1297.78 330.439 1298.64 330.439C1299.49 330.439 1300.19 331.112 1300.22 331.963L1300.42 337.115L1300.59 331.893C1300.62 331.084 1301.29 330.439 1302.09 330.439C1302.9 330.439 1303.57 331.08 1303.6 331.888L1303.79 337.115L1303.99 331.935C1304.03 331.098 1304.71 330.439 1305.55 330.439C1306.38 330.439 1307.07 331.098 1307.1 331.935L1307.29 337.115L1307.53 331.753C1307.57 331.015 1308.18 330.434 1308.92 330.434C1309.68 330.434 1310.3 331.052 1310.3 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.29 337.115L1310.4 331.99C1310.42 331.126 1311.13 330.439 1311.99 330.439C1312.84 330.439 1313.54 331.112 1313.57 331.963L1313.77 337.115L1313.94 331.893C1313.97 331.084 1314.64 330.439 1315.45 330.439C1316.25 330.439 1316.92 331.08 1316.95 331.888L1317.15 337.115L1317.35 331.935C1317.38 331.098 1318.06 330.439 1318.9 330.439C1319.73 330.439 1320.42 331.098 1320.45 331.935L1320.64 337.115L1320.89 331.753C1320.92 331.015 1321.53 330.434 1322.27 330.434C1323.03 330.434 1323.65 331.052 1323.65 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.65 337.115L1323.76 331.99C1323.78 331.126 1324.49 330.439 1325.35 330.439C1326.2 330.439 1326.9 331.112 1326.93 331.963L1327.12 337.115L1327.3 331.893C1327.33 331.084 1327.99 330.439 1328.8 330.439C1329.61 330.439 1330.27 331.08 1330.31 331.888L1330.5 337.115L1330.7 331.935C1330.73 331.098 1331.42 330.439 1332.25 330.439C1333.09 330.439 1333.78 331.098 1333.81 331.935L1334 337.115L1334.24 331.753C1334.28 331.015 1334.89 330.434 1335.63 330.434C1336.38 330.434 1337.01 331.052 1337.01 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.51 337.115L1155.62 331.99C1155.64 331.126 1156.34 330.439 1157.21 330.439C1158.06 330.439 1158.76 331.112 1158.79 331.963L1158.98 337.115L1159.16 331.893C1159.19 331.084 1159.85 330.439 1160.66 330.439C1161.47 330.439 1162.13 331.08 1162.17 331.888L1162.36 337.115L1162.56 331.935C1162.59 331.098 1163.28 330.439 1164.11 330.439C1164.95 330.439 1165.64 331.098 1165.67 331.935L1165.86 337.115L1166.1 331.753C1166.14 331.015 1166.75 330.434 1167.49 330.434C1168.24 330.434 1168.87 331.052 1168.87 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 337.115L1168.98 331.99C1169 331.126 1169.7 330.439 1170.56 330.439C1171.41 330.439 1172.11 331.112 1172.15 331.963L1172.34 337.115L1172.51 331.893C1172.55 331.084 1173.21 330.439 1174.02 330.439C1174.83 330.439 1175.49 331.08 1175.52 331.888L1175.72 337.115L1175.92 331.935C1175.95 331.098 1176.63 330.439 1177.47 330.439C1178.31 330.439 1178.99 331.098 1179.02 331.935L1179.22 337.115L1179.46 331.753C1179.5 331.015 1180.1 330.434 1180.84 330.434C1181.6 330.434 1182.22 331.052 1182.22 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.22 337.115L1182.33 331.99C1182.35 331.126 1183.05 330.439 1183.91 330.439C1184.76 330.439 1185.46 331.112 1185.5 331.963L1185.69 337.115L1185.86 331.893C1185.9 331.084 1186.56 330.439 1187.37 330.439C1188.18 330.439 1188.84 331.08 1188.87 331.888L1189.07 337.115L1189.27 331.935C1189.3 331.098 1189.98 330.439 1190.82 330.439C1191.66 330.439 1192.34 331.098 1192.37 331.935L1192.57 337.115L1192.81 331.753C1192.85 331.015 1193.45 330.434 1194.19 330.434C1194.95 330.434 1195.57 331.052 1195.57 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.57 337.115L1195.68 331.99C1195.7 331.126 1196.4 330.439 1197.27 330.439C1198.12 330.439 1198.82 331.112 1198.85 331.963L1199.05 337.115L1199.22 331.893C1199.25 331.084 1199.91 330.439 1200.72 330.439C1201.53 330.439 1202.2 331.08 1202.23 331.888L1202.42 337.115L1202.62 331.935C1202.66 331.098 1203.34 330.439 1204.17 330.439C1205.01 330.439 1205.7 331.098 1205.73 331.935L1205.92 337.115L1206.16 331.753C1206.2 331.015 1206.81 330.434 1207.55 330.434C1208.3 330.434 1208.93 331.052 1208.93 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.93 337.115L1209.04 331.99C1209.06 331.126 1209.76 330.439 1210.62 330.439C1211.47 330.439 1212.17 331.112 1212.21 331.963L1212.4 337.115L1212.57 331.893C1212.61 331.084 1213.27 330.439 1214.08 330.439C1214.89 330.439 1215.55 331.08 1215.58 331.888L1215.78 337.115L1215.98 331.935C1216.01 331.098 1216.69 330.439 1217.53 330.439C1218.37 330.439 1219.05 331.098 1219.08 331.935L1219.28 337.115L1219.52 331.753C1219.56 331.015 1220.16 330.434 1220.9 330.434C1221.66 330.434 1222.28 331.052 1222.28 331.814V337.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.95 339.239H1156.42V342.881H1167.95V339.239Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.84 341.06H1194.66C1195.66 341.06 1196.48 341.873 1196.48 342.881C1196.48 343.884 1195.67 344.702 1194.66 344.702H1192.84C1191.83 344.702 1191.02 343.889 1191.02 342.881C1191.02 341.877 1191.83 341.06 1192.84 341.06Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.92 332.576C1322.96 332.729 1324.56 334.434 1324.56 336.511V337.422H1320.92V332.576Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.12 332.576C1337.09 332.729 1335.48 334.434 1335.48 336.511V337.422H1339.12V332.576Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.86 334.383C1280.86 333.38 1280.05 332.562 1279.04 332.562C1278.03 332.562 1277.22 333.375 1277.22 334.383V337.417H1280.86V334.383Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.1 334.383C1302.1 333.38 1301.29 332.562 1300.28 332.562C1299.27 332.562 1298.46 333.375 1298.46 334.383V337.417H1302.1V334.383Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.69 341.06H1216.51C1217.52 341.06 1218.33 341.873 1218.33 342.881C1218.33 343.884 1217.52 344.702 1216.51 344.702H1214.69C1213.69 344.702 1212.87 343.889 1212.87 342.881C1212.87 341.877 1213.68 341.06 1214.69 341.06Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.43 341.06H1280.25C1281.25 341.06 1282.07 341.873 1282.07 342.881C1282.07 343.884 1281.26 344.702 1280.25 344.702H1278.43C1277.42 344.702 1276.61 343.889 1276.61 342.881C1276.61 341.877 1277.42 341.06 1278.43 341.06Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.67 341.06H1301.49C1302.5 341.06 1303.32 341.873 1303.32 342.881C1303.32 343.884 1302.5 344.702 1301.49 344.702H1299.67C1298.67 344.702 1297.85 343.889 1297.85 342.881C1297.85 341.877 1298.67 341.06 1299.67 341.06Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.39 332.576C1155.43 332.729 1157.03 334.434 1157.03 336.511V337.422H1153.39V332.576Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.6 332.576C1169.56 332.729 1167.96 334.434 1167.96 336.511V337.422H1171.6V332.576Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.27 334.383C1195.27 333.38 1194.46 332.562 1193.45 332.562C1192.44 332.562 1191.63 333.375 1191.63 334.383V337.417H1195.27V334.383Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.12 334.383C1217.12 333.38 1216.31 332.562 1215.3 332.562C1214.29 332.562 1213.48 333.375 1213.48 334.383V337.417H1217.12V334.383Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.09 339.239H1324.56V342.881H1336.09V339.239Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.421 339.237L650.492 375.354V378.387L681.754 372.315L807.404 346.819L814.688 349.249L785.555 367.46L770.985 380.208C778.879 376.264 796.054 367.827 801.638 365.639C808.621 362.907 836.844 349.249 840.789 347.428C848.375 343.925 845.95 339.232 840.789 338.322C827.19 335.409 808.212 337.713 800.421 339.232V339.237Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.022 394.779H669.614L671.751 387.118C672.509 384.41 670.469 381.729 667.658 381.729H650.492V378.389L803.794 347.727C808.821 346.723 813.917 346.105 819.042 345.887C820.844 345.813 821.583 348.168 820.059 349.134L770.86 380.419C768.254 382.073 767.125 385.297 768.124 388.215L770.368 394.775H762.781V385.966C762.781 384.67 761.462 383.787 760.263 384.284L753.982 386.886V381.725L788.277 357.748C789.545 357.055 788.709 354.951 787.311 355.318C762.237 361.868 722.892 370.305 710.581 373.227C699.371 375.89 688.42 378.784 682.009 380.837C679.477 381.646 677.977 384.131 678.232 386.775L679.017 394.775L679.022 394.779Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.613 374.444V382.338",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.2 373.229V380.816",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.229 369.287V376.269",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.574 371.711V379.906",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.949 370.499V378.086",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.917 382.335L684.18 379.604",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.608 394.778V386.467C764.608 384.623 765.44 382.88 766.889 381.738C770.076 379.224 774.262 375.977 778.202 372.98C780.683 370.987 783.688 368.743 787.308 366.239C787.805 365.891 788.241 365.589 788.627 365.333C795.433 360.701 804.255 355.233 815.596 348.943C801.64 356.683 793.203 362.29 788.632 365.329H788.627C788.176 365.64 787.74 365.937 787.308 366.235C785.064 367.814 781.728 370.295 778.202 372.976C771.433 378.402 768.576 381.933 767.944 383.54V394.769H764.604L764.608 394.778Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.421 385.576L673.558 394.477H679.021C678.821 393.669 678.9 391.076 678.412 387.192C677.925 383.309 680.034 381.729 681.446 381.427L705.725 374.444L680.415 380.447C677.897 381.046 675.946 383.044 675.421 385.576Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.987 383.851L804.064 354.717L815.902 348.952",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.421 339.238L650.492 375.354V373.533L800.421 334.987C809.225 333.268 829.62 330.861 840.789 334.987C845.16 336.446 847.362 337.821 848.073 338.327C848.073 340.757 848.375 343.489 846.861 344.701C845.648 345.672 795.771 368.78 770.985 380.209C778.879 376.265 796.054 367.828 801.638 365.64C808.621 362.908 836.844 349.249 840.789 347.428C848.375 343.925 845.95 339.233 840.789 338.323C827.19 335.41 808.212 337.714 800.421 339.233V339.238Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.492 370.5V373.533L693.285 362.607C727.171 353.199 799.39 334.077 817.114 332.864C834.837 331.652 845.137 336 848.068 338.328V332.339C848.068 330.899 847.66 329.454 846.54 328.558C843.65 326.258 838.071 324.005 832.895 323.758C816.872 322.3 798.702 326.388 791.617 328.613L650.492 370.495V370.5Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.492 375.052V378.393",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.373 355.326L815.596 348.952",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.147 337.115L815.896 345.919",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.488 338.326L812.862 346.219",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.895 337.115L818.326 345.919",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.774 337.417V346.22",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.02 394.779V360.182H1519.41L1533.37 351.986L1547.94 357.752L1565.24 347.434L1568.58 394.779H1381.02H1381.02Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.66 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.3 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.58 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.22 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.86 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.51 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.15 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.79 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.43 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.08 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.72 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.36 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.65 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.29 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.93 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.57 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.21 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.85 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.49 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.14 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.78 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.42 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.06 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.71 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.35 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.99 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.63 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.27 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.92 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.56 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.2 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.84 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.48 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.12 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.77 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.41 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.05 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.69 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.34 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.98 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.62 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.26 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.91 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.55 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.18 365.036V394.778",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555.83 364.127V394.78",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.47 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.11 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.75 362.611V394.783",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.32 349.557C1374.76 349.798 1364.82 347.434 1360.68 346.216C1376.16 361.998 1378.59 365.032 1381.32 366.551C1394.07 367.764 1391.03 364.73 1407.42 364.73C1423.81 364.73 1432.91 368.981 1441.41 369.283C1449.91 369.585 1452.03 364.73 1462.35 364.73C1472.68 364.73 1478.14 371.712 1485.12 371.712C1492.1 371.712 1491.79 364.428 1501.2 364.126C1510.61 363.824 1514.86 373.534 1519.41 373.534C1528.22 373.534 1523.66 363.517 1532.46 363.215C1541.27 362.913 1540.96 374.746 1546.73 374.746C1552.49 374.746 1552.19 363.517 1559.47 362.607C1566.76 361.696 1566.46 388.103 1568.58 394.472C1574.35 377.78 1577.08 346.216 1568.58 346.216C1560.08 346.216 1560.69 364.73 1553.41 365.032C1546.12 365.334 1550.68 349.552 1540.97 348.339C1531.26 347.127 1531.26 361.998 1523.66 362.602C1516.08 363.211 1517.59 348.339 1506.97 348.339C1496.35 348.339 1495.13 359.568 1486.94 359.568C1478.74 359.568 1476.32 348.339 1462.35 348.339C1452.95 348.339 1448.09 355.322 1439.59 355.322C1431.09 355.322 1421.47 348.511 1409.85 347.429C1396.8 346.216 1389.51 349.25 1381.32 349.552V349.557Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.65 362.913C1568.09 342.518 1569.29 375.052 1568.58 393.868C1566.45 370.193 1564.32 367.707 1563.11 365.036C1561.59 361.696 1559.47 362.606 1557.65 362.913Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.32 376.572H1384.66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.32 386.282H1384.66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 371.712H1395.28",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 381.428H1395.28",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.94 391.136H1395.28",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.22 371.712H1402.56",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.22 381.428H1402.56",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.22 391.136H1402.56",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.51 371.712H1409.85",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.51 381.428H1409.85",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.51 391.136H1409.85",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.79 371.712H1417.13",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.79 381.428H1417.13",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.79 391.136H1417.13",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.08 371.712H1424.42",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.08 381.428H1424.42",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.08 391.136H1424.42",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.36 371.712H1431.7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.36 381.428H1431.7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.36 391.136H1431.7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.65 371.712H1438.99",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.65 381.428H1438.99",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.65 391.136H1438.99",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.93 371.712H1446.27",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.93 381.428H1446.27",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.93 391.136H1446.27",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.21 371.712H1453.55",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.21 381.428H1453.55",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.21 391.136H1453.55",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.49 371.712H1460.83",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.49 381.428H1460.83",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.49 391.136H1460.83",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.78 371.712H1468.12",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.78 381.428H1468.12",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.78 391.136H1468.12",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.06 371.712H1475.4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.06 381.428H1475.4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.06 391.136H1475.4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.35 371.712H1482.69",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.35 381.428H1482.69",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.35 391.136H1482.69",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.63 371.712H1489.97",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.63 381.428H1489.97",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.63 391.136H1489.97",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.92 371.712H1497.26",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.92 381.428H1497.26",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.92 391.136H1497.26",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.2 371.712H1504.54",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.2 381.428H1504.54",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.2 391.136H1504.54",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.48 371.712H1511.82",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.48 381.428H1511.82",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.48 391.136H1511.82",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.34 371.712H1533.68",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.34 381.428H1533.68",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.34 391.136H1533.68",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.62 371.712H1540.96",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.62 381.428H1540.96",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.62 391.136H1540.96",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.18 371.712H1555.52",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.18 381.428H1555.52",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.18 391.136H1555.52",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.77 381.428H1519.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.77 391.136H1519.11",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.05 381.428H1526.39",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.05 391.136H1526.39",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.96 371.712H1388.3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.96 381.428H1388.3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.96 391.136H1388.3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.6 376.572H1391.94",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.6 386.282H1391.94",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.89 376.572H1399.23",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.89 386.282H1399.23",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.17 376.572H1406.51",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.17 386.282H1406.51",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.45 376.572H1413.79",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.45 386.282H1413.79",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.74 376.572H1421.08",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.74 386.282H1421.08",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.02 376.572H1428.36",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.02 386.282H1428.36",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.3 376.572H1435.64",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.3 386.282H1435.64",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.59 376.572H1442.93",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.59 386.282H1442.93",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.87 376.572H1450.21",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.87 386.282H1450.21",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.16 376.572H1457.5",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.16 386.282H1457.5",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.44 376.572H1464.78",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.44 386.282H1464.78",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.72 376.572H1472.06",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.72 386.282H1472.06",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.01 376.572H1479.35",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.01 386.282H1479.35",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.29 376.572H1486.63",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.29 386.282H1486.63",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.58 376.572H1493.92",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.58 386.282H1493.92",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.86 376.572H1501.2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.86 386.282H1501.2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.15 376.572H1508.49",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.15 386.282H1508.49",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.43 376.572H1515.77",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.43 386.282H1515.77",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.71 376.572H1523.05",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.71 386.282H1523.05",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527 376.572H1530.34",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527 386.282H1530.34",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.28 376.572H1537.62",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.28 386.282H1537.62",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.56 376.572H1544.9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.56 386.282H1544.9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.85 376.572H1552.19",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.85 386.282H1552.19",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.13 376.572H1559.47",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.13 386.282H1559.47",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.42 376.572H1566.15",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.42 386.282H1566.76",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.74 362.913C1537.48 360.837 1531.25 360.182 1527.6 365.036C1533.68 360.785 1536.68 363.889 1538.53 365.947C1541.26 368.981 1541.26 375.252 1547.34 374.444C1541.87 369.891 1543.39 366.249 1539.75 362.913H1539.74Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.96 363.099C1506.62 360.804 1496.95 361.092 1492.4 367.768C1498.16 362.305 1504.66 364.419 1507.27 365.338C1512.43 367.16 1513.95 374.04 1520.02 373.232C1515.25 372.019 1514.82 366.44 1509.96 363.099Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.54 362.915C1466.65 361.8 1459.01 362.004 1449.91 367.468C1460.53 363.217 1467.02 364.727 1469.63 365.646C1474.8 367.468 1478.44 371.11 1484.81 371.412C1480.04 370.199 1476.91 364.736 1470.54 362.915Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.65 362.304C1412.27 361.695 1403.76 361.416 1389.51 366.555C1404.99 363.521 1413.57 364.761 1417.74 365.035C1425.93 365.574 1431.44 368.998 1441.41 369.286C1433.96 368.143 1428.72 363.265 1418.65 362.304Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.93 370.5H892.077V394.778H1069.93V370.5Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.16 302.819L1075.08 334.684L1086.61 335.595L1081.15 302.819H1081.16Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.16 302.819L1079.03 335.595H1086.62L1081.16 302.819Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.12 335.595C1078.12 334.591 1078.93 333.773 1079.94 333.773C1080.95 333.773 1081.76 334.586 1081.76 335.595V345.611H1078.12V335.595Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.08 335.293C1075.08 334.456 1075.76 333.773 1076.6 333.773C1077.44 333.773 1078.12 334.452 1078.12 335.293V345.611H1075.09V335.293H1075.08Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.77 336.203C1081.77 334.861 1082.85 333.773 1084.2 333.773C1085.54 333.773 1086.63 334.861 1086.63 336.203V345.611H1081.77V336.203H1081.77Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.94 344.399C1079.94 342.22 1081.71 340.455 1083.89 340.455C1086.07 340.455 1087.83 342.22 1087.83 344.399V351.075H1079.94V344.399H1079.94Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.87 344.099C1073.87 342.422 1075.23 341.065 1076.91 341.065C1078.58 341.065 1079.94 342.426 1079.94 344.099V354.115H1073.87V344.099H1073.87Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.77 345.466C1081.77 344.374 1082.65 343.491 1083.74 343.491H1084.04C1085.13 343.491 1086.02 344.374 1086.02 345.466C1086.02 346.557 1085.13 347.44 1084.04 347.44H1083.74C1082.65 347.44 1081.77 346.557 1081.77 345.466Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.69 345.918C1075.69 345.249 1076.24 344.705 1076.9 344.705C1077.57 344.705 1078.12 345.249 1078.12 345.918V346.828C1078.12 347.497 1077.57 348.041 1076.9 348.041C1076.24 348.041 1075.69 347.497 1075.69 346.828V345.918Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.6 359.881L1086.01 348.043L1106.95 359.881H1076.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.01 348.043L1067.8 357.149L1068.41 357.758V363.221L1076.6 360.188L1086.01 348.048V348.043Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.65 395.387V359.879H1076.9L1068.41 363.219V395.391H1106.65V395.387Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.41 370.804H893.592V395.083H1068.41V370.804Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.592 360.485V370.803H1068.41V357.451H891.199L893.522 360.294L893.587 360.378V360.485H893.592Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.661 268.828H976.449C975.946 268.828 975.538 269.235 975.538 269.738V358.965C975.538 359.468 975.946 359.876 976.449 359.876H977.661C978.164 359.876 978.572 359.468 978.572 358.965V269.738C978.572 269.235 978.164 268.828 977.661 268.828Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.946 268.828H983.734C983.231 268.828 982.823 269.235 982.823 269.738V358.965C982.823 359.468 983.231 359.876 983.734 359.876H984.946C985.449 359.876 985.857 359.468 985.857 358.965V269.738C985.857 269.235 985.449 268.828 984.946 268.828Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.304 379.305H894.807V395.086H903.304V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.304 379.305H894.807V382.338H903.304V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.628 372.624H894.807V376.874H896.628V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.272 372.624H897.842V376.874H900.272V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.304 372.624H901.482V376.874H903.304V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.265 379.305H908.768V395.086H917.265V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.589 372.624H908.768V376.874H910.589V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.232 372.624H911.803V376.874H914.232V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.266 372.624H915.445V376.874H917.266V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.975 379.305H935.478V395.086H943.975V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.299 372.624H935.478V376.874H937.299V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.942 372.624H938.513V376.874H940.942V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.974 372.624H942.153V376.874H943.974V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.935 379.305H949.438V395.086H957.935V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.259 372.624H949.438V376.874H951.259V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.901 372.624H952.472V376.874H954.901V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.935 372.624H956.114V376.874H957.935V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.896 379.305H963.398V395.086H971.896V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.22 372.624H963.398V376.874H965.22V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.861 372.624H966.432V376.874H968.861V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.895 372.624H970.074V376.874H971.895V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.208 379.305H990.711V395.086H999.208V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.532 372.624H990.711V376.874H992.532V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.179 372.624H993.749V376.874H996.179V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.208 372.624H997.387V376.874H999.208V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.17 379.305H1004.67V395.086H1013.17V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.49 372.624H1004.67V376.874H1006.49V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.14 372.624H1007.71V376.874H1010.14V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.17 372.624H1011.35V376.874H1013.17V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.2 379.305H1058.7V395.086H1067.2V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.52 372.624H1058.7V376.874H1060.52V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.16 372.624H1061.73V376.874H1064.16V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.8 384.159H1081.16V395.086H1084.8V384.159Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.69 384.762H1073.87V391.438H1075.69V384.762Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.05 384.762H1070.23V391.438H1072.05V384.762Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.87 381.729H1075.69V374.528L1073.87 374.984V381.729Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.23 381.728H1072.05V375.136L1070.23 375.591V381.728Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.87 365.275V369.855L1075.69 369.628V364.819L1073.87 365.275Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.23 365.88V370.461L1072.05 370.233V365.425L1070.23 365.88Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.01 384.762H1099.37V391.438H1103.01V384.762Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.2 372.624H1065.37V376.874H1067.2V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.23 379.305H1044.74V395.086H1053.23V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.56 372.624H1044.74V376.874H1046.56V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.2 372.624H1047.77V376.874H1050.2V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.24 372.624H1051.42V376.874H1053.24V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.13 379.305H1018.63V395.086H1027.13V379.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.46 372.624H1018.63V376.874H1020.46V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.1 372.624H1021.67V376.874H1024.1V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.13 372.624H1025.31V376.874H1027.13V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.48 368.376H1054.45V395.085H1057.48V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.42 368.376H1014.38V395.085H1017.42V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.46 368.376H1000.42V395.085H1003.46V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.18 368.376H959.146V395.085H962.18V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.222 368.376H945.188V395.085H948.222V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.552 368.376H904.519V395.085H907.552V368.376Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.088 371.107C919.088 366.917 922.489 363.521 926.675 363.521C930.86 363.521 934.261 366.917 934.261 371.107V395.084H919.088V371.107Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.35 371.107C1028.35 366.917 1031.75 363.521 1035.93 363.521C1040.12 363.521 1043.52 366.917 1043.52 371.107V395.084H1028.35V371.107Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.91 358.058C1076.91 357.389 1077.45 356.846 1078.12 356.846C1078.78 356.846 1079.33 357.389 1079.33 358.058V395.387H1076.9V358.058H1076.91Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.97 365.341C1099.97 364.672 1100.52 364.128 1101.19 364.128C1101.85 364.128 1102.4 364.672 1102.4 365.341V369.285H1099.97V365.341H1099.97Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.76 365.341C1081.76 364.672 1082.31 364.128 1082.98 364.128C1083.64 364.128 1084.19 364.672 1084.19 365.341V369.285H1081.76V365.341H1081.76Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.16 375.051C1081.16 374.048 1081.97 373.23 1082.98 373.23C1083.99 373.23 1084.8 374.043 1084.8 375.051V380.817H1081.16V375.051Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.37 375.051C1099.37 374.048 1100.18 373.23 1101.19 373.23C1102.2 373.23 1103.01 374.043 1103.01 375.051V380.817H1099.37V375.051Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.719 368.07C973.719 363.879 977.12 360.483 981.305 360.483C985.491 360.483 988.892 363.879 988.892 368.07V395.081H973.719V368.07Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.591 395.086V367.467L886.306 365.948H858.385V395.082H893.591V395.086Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.904 365.947L879.328 352.288L886.613 365.947H859.904Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.311 365.645L879.635 352.595L891.166 357.757L893.595 360.488V367.773L886.311 365.65V365.645Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.245 390.228H866.887V380.518C866.887 379.514 866.074 378.697 865.066 378.697C864.058 378.697 863.245 379.51 863.245 380.518V390.228Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.849 374.445H866.278V371.412C866.278 370.743 865.73 370.199 865.066 370.199C864.401 370.199 863.853 370.743 863.853 371.412V374.445H863.849Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.629 374.445H882.059V371.412C882.059 370.743 881.51 370.199 880.846 370.199C880.182 370.199 879.634 370.743 879.634 371.412V374.445H879.629Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.026 390.228H882.669V380.518C882.669 379.514 881.856 378.697 880.847 378.697C879.839 378.697 879.026 379.51 879.026 380.518V390.228Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.312 365.644C869.312 363.466 871.078 361.7 873.257 361.7C875.435 361.7 877.201 363.466 877.201 365.644V395.085H869.308V365.644H869.312Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.385 363.217C858.385 362.381 859.063 361.698 859.904 361.698C860.745 361.698 861.423 362.376 861.423 363.217V395.082H858.389V363.217H858.385Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.49 362.913C884.49 362.244 885.038 361.7 885.703 361.7C886.367 361.7 886.915 362.244 886.915 362.913V395.085H884.485V362.913H884.49Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.742 374.445H874.172V371.412C874.172 370.743 873.624 370.199 872.959 370.199C872.295 370.199 871.747 370.743 871.747 371.412V374.445H871.742Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.134 390.228H875.385V380.82C875.385 379.645 874.432 378.697 873.262 378.697C872.091 378.697 871.138 379.649 871.138 380.82V390.228H871.134Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.3 371.712C920.3 368.191 923.152 365.338 926.674 365.338C930.195 365.338 933.048 368.191 933.048 371.712V395.081H920.3V371.712Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.121 395.086H930.618V383.556C930.618 381.209 928.718 379.305 926.367 379.305C924.016 379.305 922.116 381.205 922.116 383.556V395.086H922.121Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.942 372.624H922.121V376.874H923.942V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.584 372.624H925.154V376.874H927.584V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.617 372.624H928.796V376.874H930.617V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.56 371.712C1029.56 368.191 1032.41 365.338 1035.93 365.338C1039.46 365.338 1042.31 368.191 1042.31 371.712V395.081H1029.56V371.712Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.93 368.677C974.93 365.156 977.782 362.303 981.304 362.303C984.825 362.303 987.678 365.156 987.678 368.677V395.084H974.93V368.677Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.751 395.086H985.248V383.556C985.248 381.209 983.348 379.305 980.997 379.305C978.646 379.305 976.746 381.205 976.746 383.556V395.086H976.751Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.572 372.624H976.751V376.874H978.572V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.216 372.624H979.786V376.874H982.216V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.249 372.624H983.428V376.874H985.249V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.38 395.086H1039.88V383.556C1039.88 381.209 1037.98 379.305 1035.63 379.305C1033.28 379.305 1031.38 381.205 1031.38 383.556V395.086H1031.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.38 395.085H1039.88V385.979C1039.88 383.633 1037.98 381.729 1035.63 381.729C1033.28 381.729 1031.38 383.629 1031.38 385.979V395.085H1031.38Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.751 395.085H985.248V385.979C985.248 383.633 983.348 381.729 980.997 381.729C978.646 381.729 976.746 383.629 976.746 385.979V395.085H976.751Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.121 395.085H930.618V385.979C930.618 383.633 928.718 381.729 926.367 381.729C924.016 381.729 922.116 383.629 922.116 385.979V395.085H922.121Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.2 372.624H1031.38V376.874H1033.2V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.85 372.624H1034.42V376.874H1036.85V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.88 372.624H1038.06V376.874H1039.88V372.624Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.62 360.79C1086.62 357.603 1089.2 355.024 1092.39 355.024C1095.57 355.024 1098.15 357.607 1098.15 360.79V395.387H1086.62V360.79Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.12 384.762H1090.26V391.438H1095.12V384.762Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.04 365.341C1089.04 364.672 1089.59 364.128 1090.26 364.128C1090.92 364.128 1091.47 364.672 1091.47 365.341V369.285H1089.04V365.341H1089.04Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.29 365.341C1093.29 364.672 1093.84 364.128 1094.51 364.128C1095.17 364.128 1095.72 364.672 1095.72 365.341V369.285H1093.29V365.341H1093.29Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.26 375.353C1090.26 374.178 1091.21 373.23 1092.38 373.23C1093.56 373.23 1094.51 374.182 1094.51 375.353V380.817H1090.26V375.353H1090.26Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.265 379.305H908.768V382.338H917.265V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.975 379.305H935.478V382.338H943.975V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.935 379.305H949.438V382.338H957.935V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.896 379.305H963.398V382.338H971.896V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.208 379.305H990.711V382.338H999.208V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.17 379.305H1004.67V382.338H1013.17V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.13 379.305H1018.63V382.338H1027.13V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.23 379.305H1044.74V382.338H1053.23V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.2 379.305H1058.7V382.338H1067.2V379.305Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.83 358.058C1104.83 357.389 1105.37 356.846 1106.04 356.846C1106.7 356.846 1107.25 357.389 1107.25 358.058V395.387H1104.82V358.058H1104.83Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.468 360.483H130.6V395.081H240.468V360.483Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.821 360.483H298.132V395.081H409.821V360.483Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.598 370.199H93.5713V395.087H130.598V370.199Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.632 368.377C133.632 366.7 134.993 365.343 136.665 365.343C138.338 365.343 139.699 366.704 139.699 368.377V373.232H133.627V368.377H133.632Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.919 368.377C140.919 366.7 142.28 365.343 143.952 365.343C145.625 365.343 146.986 366.704 146.986 368.377V373.232H140.914V368.377H140.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.201 368.377C148.201 366.7 149.562 365.343 151.235 365.343C152.907 365.343 154.268 366.704 154.268 368.377V373.232H148.196V368.377H148.201Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.486 368.377C155.486 366.7 156.847 365.343 158.52 365.343C160.192 365.343 161.553 366.704 161.553 368.377V373.232H155.481V368.377H155.486Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 368.377C162.766 366.7 164.128 365.343 165.8 365.343C167.473 365.343 168.834 366.704 168.834 368.377V373.232H162.762V368.377H162.766Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.052 368.377C170.052 366.7 171.413 365.343 173.085 365.343C174.758 365.343 176.119 366.704 176.119 368.377V373.232H170.047V368.377H170.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.944 368.377C177.944 366.7 179.305 365.343 180.978 365.343C182.65 365.343 184.012 366.704 184.012 368.377V373.232H177.939V368.377H177.944Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.229 368.377C185.229 366.7 186.59 365.343 188.263 365.343C189.935 365.343 191.297 366.704 191.297 368.377V373.232H185.225V368.377H185.229Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.512 368.377C192.512 366.7 193.874 365.343 195.546 365.343C197.219 365.343 198.58 366.704 198.58 368.377V373.232H192.508V368.377H192.512Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.794 368.377C199.794 366.7 201.155 365.343 202.827 365.343C204.5 365.343 205.861 366.704 205.861 368.377V373.232H199.789V368.377H199.794Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.077 368.377C207.077 366.7 208.438 365.343 210.111 365.343C211.783 365.343 213.144 366.704 213.144 368.377V373.232H207.072V368.377H207.077Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.362 368.377C214.362 366.7 215.723 365.343 217.396 365.343C219.068 365.343 220.429 366.704 220.429 368.377V373.232H214.357V368.377H214.362Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.646 368.377C221.646 366.7 223.007 365.343 224.68 365.343C226.352 365.343 227.714 366.704 227.714 368.377V373.232H221.642V368.377H221.646Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.931 368.377C228.931 366.7 230.293 365.343 231.965 365.343C233.638 365.343 234.999 366.704 234.999 368.377V373.232H228.927V368.377H228.931Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.218 368.377C236.218 366.7 237.579 365.343 239.251 365.343C240.924 365.343 242.285 366.704 242.285 368.377V373.232H236.213V368.377H236.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.734 368.377C298.734 366.7 300.095 365.343 301.768 365.343C303.44 365.343 304.802 366.704 304.802 368.377V373.232H298.729V368.377H298.734Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.019 368.377C306.019 366.7 307.381 365.343 309.053 365.343C310.725 365.343 312.087 366.704 312.087 368.377V373.232H306.015V368.377H306.019Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.304 368.377C313.304 366.7 314.666 365.343 316.338 365.343C318.011 365.343 319.372 366.704 319.372 368.377V373.232H313.3V368.377H313.304Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.237 344.7H250.78V360.482H290.237V344.7Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.588 368.377C320.588 366.7 321.949 365.343 323.621 365.343C325.294 365.343 326.655 366.704 326.655 368.377V373.232H320.583V368.377H320.588Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.873 368.377C327.873 366.7 329.234 365.343 330.907 365.343C332.579 365.343 333.94 366.704 333.94 368.377V373.232H327.868V368.377H327.873Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.156 368.377C335.156 366.7 336.517 365.343 338.19 365.343C339.862 365.343 341.223 366.704 341.223 368.377V373.232H335.151V368.377H335.156Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.046 368.377C343.046 366.7 344.407 365.343 346.079 365.343C347.752 365.343 349.113 366.704 349.113 368.377V373.232H343.041V368.377H343.046Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.331 368.377C350.331 366.7 351.692 365.343 353.365 365.343C355.037 365.343 356.398 366.704 356.398 368.377V373.232H350.326V368.377H350.331Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.616 368.377C357.616 366.7 358.977 365.343 360.65 365.343C362.322 365.343 363.683 366.704 363.683 368.377V373.232H357.611V368.377H357.616Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.899 368.377C364.899 366.7 366.26 365.343 367.933 365.343C369.605 365.343 370.967 366.704 370.967 368.377V373.232H364.895V368.377H364.899Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.18 368.377C372.18 366.7 373.542 365.343 375.214 365.343C376.887 365.343 378.248 366.704 378.248 368.377V373.232H372.176V368.377H372.18Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.464 368.377C379.464 366.7 380.825 365.343 382.497 365.343C384.17 365.343 385.531 366.704 385.531 368.377V373.232H379.459V368.377H379.464Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.749 368.377C386.749 366.7 388.11 365.343 389.782 365.343C391.455 365.343 392.816 366.704 392.816 368.377V373.232H386.744V368.377H386.749Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.034 368.377C394.034 366.7 395.395 365.343 397.068 365.343C398.74 365.343 400.101 366.704 400.101 368.377V373.232H394.029V368.377H394.034Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.317 368.377C401.317 366.7 402.678 365.343 404.351 365.343C406.023 365.343 407.385 366.704 407.385 368.377V373.232H401.312V368.377H401.317Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.998 353.504C251.998 351.66 253.494 350.164 255.338 350.164C257.183 350.164 258.679 351.66 258.679 353.504V358.666H252.003V353.504H251.998Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.887 353.504C259.887 351.66 261.383 350.164 263.227 350.164C265.071 350.164 266.567 351.66 266.567 353.504V358.666H259.891V353.504H259.887Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.562 353.504C266.562 351.66 268.057 350.164 269.902 350.164C271.746 350.164 273.242 351.66 273.242 353.504V358.666H266.566V353.504H266.562Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.455 353.504C274.455 351.66 275.951 350.164 277.795 350.164C279.64 350.164 281.136 351.66 281.136 353.504V358.666H274.46V353.504H274.455Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.132 353.504C281.132 351.66 282.628 350.164 284.472 350.164C286.317 350.164 287.812 351.66 287.812 353.504V358.666H281.136V353.504H281.132Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.701 325.277H261.707V344.701H278.701V325.277Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.176 327.097H262.925V342.27H267.176V327.097Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.636 327.097H268.385V342.27H272.636V327.097Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.491 327.097H273.849V342.27H277.491V327.097Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.176 327.097H262.925V328.309H267.176V327.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.636 327.097H268.385V328.309H272.636V327.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.903 319.211C270.405 319.211 270.813 319.62 270.813 320.122V322.551C270.813 323.053 270.405 323.462 269.903 323.462C269.401 323.462 268.992 323.053 268.992 322.551V320.122C268.992 319.62 269.401 319.211 269.903 319.211Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.707 320.122C261.707 319.62 262.116 319.211 262.618 319.211C263.119 319.211 263.528 319.62 263.528 320.122V321.334C263.528 322.403 262.738 323.29 261.707 323.439V320.122Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.886 320.122C276.886 319.62 277.295 319.211 277.796 319.211C278.298 319.211 278.707 319.62 278.707 320.122V323.439C277.676 323.29 276.886 322.407 276.886 321.334V320.122Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.491 327.097H273.849V328.309H277.491V327.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.344 342.276H258.065V344.706H282.344V342.276Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.741 355.626H261.707V358.66H264.741V355.626Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.272 357.451H150.021V360.485H154.272V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.122 357.451H188.871V360.485H193.122V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.969 357.451H227.718V360.485H231.969V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.701 357.451H308.45V360.485H312.701V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.55 357.451H347.299V360.485H351.55V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.395 357.451H386.145V360.485H390.395V357.451Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.538 354.417H152.75C153.587 354.417 154.269 355.095 154.269 355.936C154.269 356.772 153.591 357.455 152.75 357.455H151.538C150.701 357.455 150.019 356.777 150.019 355.936C150.019 355.099 150.697 354.417 151.538 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.384 354.417H191.597C192.433 354.417 193.116 355.095 193.116 355.936C193.116 356.772 192.438 357.455 191.597 357.455H190.384C189.548 357.455 188.865 356.777 188.865 355.936C188.865 355.099 189.544 354.417 190.384 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.233 354.417H230.446C231.282 354.417 231.965 355.095 231.965 355.936C231.965 356.772 231.286 357.455 230.446 357.455H229.233C228.397 357.455 227.714 356.777 227.714 355.936C227.714 355.099 228.392 354.417 229.233 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.964 354.417H311.177C312.013 354.417 312.696 355.095 312.696 355.936C312.696 356.772 312.018 357.455 311.177 357.455H309.964C309.128 357.455 308.445 356.777 308.445 355.936C308.445 355.099 309.124 354.417 309.964 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.812 354.417H350.025C350.861 354.417 351.544 355.095 351.544 355.936C351.544 356.772 350.866 357.455 350.025 357.455H348.812C347.976 357.455 347.293 356.777 347.293 355.936C347.293 355.099 347.971 354.417 348.812 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.661 354.417H388.873C389.71 354.417 390.393 355.095 390.393 355.936C390.393 356.772 389.714 357.455 388.873 357.455H387.661C386.825 357.455 386.142 356.777 386.142 355.936C386.142 355.099 386.82 354.417 387.661 354.417Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.418 355.626H268.385V358.66H271.418V355.626Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31 355.626H276.276V358.66H279.31V355.626Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.701 324.066H261.707V325.279H278.701V324.066Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.064 300.999H264.746V325.277H275.064V300.999Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.455 287.646H265.35V300.998H274.455V287.646Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.437 287.646C274.283 286.28 273.127 285.216 271.724 285.216H268.081C266.674 285.216 265.517 286.28 265.368 287.646H274.441H274.437Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.387 285.217L268.986 232.408H270.208L270.807 285.217H268.387Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.6 225.125V232.409",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.811 377.483H137.883V385.376H131.811V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.022 390.226H136.665V395.081H133.022V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705 390.226H144.56V395.081H139.705V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.593 390.226H152.448V395.081H147.593V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.486 390.226H160.341V395.081H155.486V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.373 390.226H168.228V395.081H163.373V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.658 390.226H175.513V395.081H170.658V390.226Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.658 390.226H175.513V395.081H170.658V390.226Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.764 389.012H182.193V395.084H179.764V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.441 389.012H190.084V395.084H186.441V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.329 389.012H197.363V395.084H194.329V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.614 389.012H204.648V395.084H201.614V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.508 389.012H212.542V395.084H209.508V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.792 389.012H220.434V395.084H216.792V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.077 389.012H227.719V395.084H224.077V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.356 389.012H234.999V395.084H231.356V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.037 389.012H240.467V395.084H238.037V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.345 389.012H301.774V395.084H299.345V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.021 389.012H309.663V395.084H306.021V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.912 389.012H316.946V395.084H313.912V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.193 389.012H324.227V395.084H321.193V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.085 389.012H332.119V395.084H329.085V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.761 389.012H339.403V395.084H335.761V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.046 389.012H346.688V395.084H343.046V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.939 389.012H354.582V395.084H350.939V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.828 389.012H361.258V395.084H358.828V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.598 370.199H93.5713V385.372H130.598V370.199Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9 389.012H369.151V395.084H364.9V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.396 389.012H377.039V395.084H373.396V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.682 389.012H384.933V395.084H380.682V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.569 389.012H392.82V395.084H388.569V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.463 389.012H400.714V395.084H396.463V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.748 389.012H407.999V395.084H403.748V389.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.097 377.483H145.169V385.376H139.097V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.379 377.483H152.451V385.376H146.379V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.745 377.483H114.817V385.376H108.745V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.029 377.483H122.101V385.376H116.029V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1748 377.483H100.247V385.376H94.1748V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.46 377.483H107.532V385.376H101.46V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.314 377.483H129.387V385.376H123.314V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.414 368.98H153.056V373.231H149.414V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.699 368.98H160.342V373.231H156.699V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 368.98H167.621V373.231H164.587V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.871 368.98H174.905V373.231H171.871V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.764 368.98H182.797V373.231H179.764V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.05 368.98H190.084V373.231H187.05V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.329 368.98H197.363V373.231H194.329V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.614 368.98H204.648V373.231H201.614V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.899 368.98H211.933V373.231H208.899V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.185 368.98H219.218V373.231H216.185V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 368.98H226.501V373.231H223.468V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.755 368.98H233.789V373.231H230.755V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.429 368.98H240.462V373.231H237.429V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.95 368.98H303.592V373.231H299.95V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.231 368.98H310.874V373.231H307.231V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.125 368.98H318.159V373.231H315.125V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.408 368.98H325.442V373.231H322.408V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.694 368.98H332.728V373.231H329.694V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.975 368.98H340.008V373.231H336.975V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.867 368.98H347.901V373.231H344.867V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.151 368.98H355.185V373.231H352.151V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.437 368.98H362.47V373.231H359.437V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.722 368.98H369.755V373.231H366.722V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.001 368.98H377.035V373.231H374.001V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.285 368.98H384.319V373.231H381.285V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.966 368.98H391V373.231H387.966V368.98Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.486 377.483H161.558V385.376H155.486V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.768 377.483H168.84V385.376H162.768V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05 377.483H176.122V385.376H170.05V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.945 377.483H184.017V385.376H177.945V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.229 377.483H191.301V385.376H185.229V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.512 377.483H198.584V385.376H192.512V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.793 377.483H205.865V385.376H199.793V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.078 377.483H213.15V385.376H207.078V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.361 377.483H220.433V385.376H214.361V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.646 377.483H227.719V385.376H221.646V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.932 377.483H235.004V385.376H228.932V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.216 377.483H240.467V385.376H236.216V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.132 377.483H304.204V385.376H298.132V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41 377.483H311.482V385.376H305.41V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.694 377.483H318.766V385.376H312.694V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.801 377.483H327.873V385.376H321.801V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.085 377.483H335.157V385.376H329.085V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.371 377.483H342.443V385.376H336.371V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26 377.483H350.332V385.376H344.26V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.543 377.483H357.615V385.376H351.543V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.828 377.483H364.9V385.376H358.828V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.842 370.199H409.815V394.478H446.842V370.199Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.111 377.483H372.183V385.376H366.111V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.396 377.483H379.469V385.376H373.396V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.682 377.483H386.754V385.376H380.682V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.966 377.483H394.038V385.376H387.966V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.245 377.483H401.317V385.376H395.245V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.532 377.483H408.604V385.376H402.532V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.026 377.483H417.098V385.376H411.026V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.312 377.483H424.384V385.376H418.312V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.597 377.483H431.669V385.376H425.597V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.882 377.483H438.954V385.376H432.882V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.167 377.483H446.239V385.376H440.167V377.483Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.842 370.199H409.815V394.478H446.842V370.199Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.842 370.199H409.815V373.233H446.842V370.199Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.598 370.199H93.5713V373.842H130.598V370.199Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.902 314.355C271.747 314.355 273.242 312.859 273.242 311.015C273.242 309.17 271.747 307.674 269.902 307.674C268.057 307.674 266.562 309.17 266.562 311.015C266.562 312.859 268.057 314.355 269.902 314.355Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.904 312.227C270.574 312.227 271.117 311.684 271.117 311.015C271.117 310.345 270.574 309.802 269.904 309.802C269.234 309.802 268.691 310.345 268.691 311.015C268.691 311.684 269.234 312.227 269.904 312.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.227 354.41C264.399 354.41 265.35 353.46 265.35 352.287C265.35 351.115 264.399 350.164 263.227 350.164C262.054 350.164 261.104 351.115 261.104 352.287C261.104 353.46 262.054 354.41 263.227 354.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.902 354.41C271.075 354.41 272.026 353.46 272.026 352.287C272.026 351.115 271.075 350.164 269.902 350.164C268.73 350.164 267.779 351.115 267.779 352.287C267.779 353.46 268.73 354.41 269.902 354.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.797 354.41C278.97 354.41 279.92 353.46 279.92 352.287C279.92 351.115 278.97 350.164 277.797 350.164C276.624 350.164 275.674 351.115 275.674 352.287C275.674 353.46 276.624 354.41 277.797 354.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.601 219.125L270.469 221.801L270.539 222.01H273.573L271.296 223.664L271.12 223.794L271.189 224.003L272.058 226.679L269.782 225.025L269.605 224.895L269.429 225.025L267.152 226.679L268.021 224.003L268.091 223.794L267.914 223.664L265.638 222.01H268.671L268.741 221.801L269.61 219.125H269.601Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.634 289.466H271.422V293.109H272.634V289.466Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.774 289.466H266.562V293.109H267.774V289.466Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.807 381.124H152.449V385.375H148.807V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.699 381.124H160.342V385.375H156.699V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 381.124H167.621V385.375H164.587V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.871 381.124H174.905V385.375H171.871V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.764 381.124H182.797V385.375H179.764V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.05 381.124H190.084V385.375H187.05V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.329 381.124H197.363V385.375H194.329V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.614 381.124H204.648V385.375H201.614V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.899 381.124H211.933V385.375H208.899V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.185 381.124H219.218V385.375H216.185V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 381.124H226.501V385.375H223.468V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.755 381.124H233.789V385.375H230.755V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.429 381.124H240.462V385.375H237.429V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.95 381.124H303.592V385.375H299.95V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.231 381.124H310.874V385.375H307.231V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.125 381.124H318.159V385.375H315.125V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.408 381.124H325.442V385.375H322.408V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.694 381.124H332.728V385.375H329.694V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.975 381.124H340.008V385.375H336.975V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.867 381.124H347.901V385.375H344.867V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.151 381.124H355.185V385.375H352.151V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.437 381.124H362.47V385.375H359.437V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.722 381.124H369.755V385.375H366.722V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.001 381.124H377.035V385.375H374.001V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.285 381.124H384.319V385.375H381.285V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.966 381.124H391V385.375H387.966V381.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 360.483H240.462V395.081H298.125V360.483Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39 372.018C251.39 369.672 253.29 367.767 255.641 367.767C257.991 367.767 259.891 369.667 259.891 372.018V385.37H251.394V372.018H251.39Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.958 372.018C265.958 369.672 267.858 367.767 270.209 367.767C272.56 367.767 274.46 369.667 274.46 372.018V385.37H265.963V372.018H265.958Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.132 372.018C281.132 369.672 283.032 367.767 285.383 367.767C287.734 367.767 289.634 369.667 289.634 372.018V385.37H281.136V372.018H281.132Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 385.372H240.462V395.082H298.125V385.372Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 385.372H240.462V386.585H298.125V385.372Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 387.801H240.462V389.013H298.125V387.801Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 390.226H240.462V391.439H298.125V390.226Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.125 392.656H240.462V393.868H298.125V392.656Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.816 360.483H130.6V362.913H409.816V360.483Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.818 360.483H302.379V362.913H409.818V360.483Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.072 360.483H130.6V362.913H241.072V360.483Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.393 367.159H245.321V385.37H251.393V367.159Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.959 367.159H259.887V385.37H265.959V367.159Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.131 367.159H274.455V385.37H281.131V367.159Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.305 367.159H289.629V385.37H296.305V367.159Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.595 376.265H283.562V385.371H286.595V376.265Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.026 376.265H268.992V385.371H272.026V376.265Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.853 376.265H253.819V385.371H256.853V376.265Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05 372.018C248.889 372.018 249.57 371.338 249.57 370.499C249.57 369.66 248.889 368.98 248.05 368.98C247.211 368.98 246.531 369.66 246.531 370.499C246.531 371.338 247.211 372.018 248.05 372.018Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05 376.872C248.889 376.872 249.57 376.192 249.57 375.353C249.57 374.514 248.889 373.834 248.05 373.834C247.211 373.834 246.531 374.514 246.531 375.353C246.531 376.192 247.211 376.872 248.05 376.872Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05 381.734C248.889 381.734 249.57 381.054 249.57 380.215C249.57 379.376 248.889 378.696 248.05 378.696C247.211 378.696 246.531 379.376 246.531 380.215C246.531 381.054 247.211 381.734 248.05 381.734Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.617 372.018C263.456 372.018 264.136 371.338 264.136 370.499C264.136 369.66 263.456 368.98 262.617 368.98C261.778 368.98 261.098 369.66 261.098 370.499C261.098 371.338 261.778 372.018 262.617 372.018Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.617 376.872C263.456 376.872 264.136 376.192 264.136 375.353C264.136 374.514 263.456 373.834 262.617 373.834C261.778 373.834 261.098 374.514 261.098 375.353C261.098 376.192 261.778 376.872 262.617 376.872Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.617 381.734C263.456 381.734 264.136 381.054 264.136 380.215C264.136 379.376 263.456 378.696 262.617 378.696C261.778 378.696 261.098 379.376 261.098 380.215C261.098 381.054 261.778 381.734 262.617 381.734Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.796 372.018C278.635 372.018 279.315 371.338 279.315 370.499C279.315 369.66 278.635 368.98 277.796 368.98C276.957 368.98 276.276 369.66 276.276 370.499C276.276 371.338 276.957 372.018 277.796 372.018Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.796 376.872C278.635 376.872 279.315 376.192 279.315 375.353C279.315 374.514 278.635 373.834 277.796 373.834C276.957 373.834 276.276 374.514 276.276 375.353C276.276 376.192 276.957 376.872 277.796 376.872Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.796 381.734C278.635 381.734 279.315 381.054 279.315 380.215C279.315 379.376 278.635 378.696 277.796 378.696C276.957 378.696 276.276 379.376 276.276 380.215C276.276 381.054 276.957 381.734 277.796 381.734Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.969 372.018C293.808 372.018 294.489 371.338 294.489 370.499C294.489 369.66 293.808 368.98 292.969 368.98C292.13 368.98 291.45 369.66 291.45 370.499C291.45 371.338 292.13 372.018 292.969 372.018Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.969 376.872C293.808 376.872 294.489 376.192 294.489 375.353C294.489 374.514 293.808 373.834 292.969 373.834C292.13 373.834 291.45 374.514 291.45 375.353C291.45 376.192 292.13 376.872 292.969 376.872Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.969 381.734C293.808 381.734 294.489 381.054 294.489 380.215C294.489 379.376 293.808 378.696 292.969 378.696C292.13 378.696 291.45 379.376 291.45 380.215C291.45 381.054 292.13 381.734 292.969 381.734Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.885 369.89C259.885 370.392 259.499 370.922 258.714 371.34C257.943 371.753 256.856 372.013 255.639 372.013C254.422 372.013 253.335 371.749 252.563 371.34C251.778 370.922 251.393 370.397 251.393 369.89C251.393 369.384 251.778 368.859 252.563 368.441C253.335 368.027 254.422 367.767 255.639 367.767C256.856 367.767 257.943 368.032 258.714 368.441C259.499 368.859 259.885 369.384 259.885 369.89Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.455 369.89C274.455 370.392 274.07 370.922 273.285 371.34C272.513 371.753 271.426 372.013 270.209 372.013C268.992 372.013 267.905 371.749 267.134 371.34C266.349 370.922 265.963 370.397 265.963 369.89C265.963 369.384 266.349 368.859 267.134 368.441C267.905 368.027 268.992 367.767 270.209 367.767C271.426 367.767 272.513 368.032 273.285 368.441C274.07 368.859 274.455 369.384 274.455 369.89Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.63 369.89C289.63 370.392 289.245 370.922 288.459 371.34C287.688 371.753 286.601 372.013 285.384 372.013C284.167 372.013 283.08 371.749 282.308 371.34C281.523 370.922 281.138 370.397 281.138 369.89C281.138 369.384 281.523 368.859 282.308 368.441C283.08 368.027 284.167 367.767 285.384 367.767C286.601 367.767 287.688 368.032 288.459 368.441C289.245 368.859 289.63 369.384 289.63 369.89Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.725 324.065C261.879 322.699 263.035 321.635 264.439 321.635H275.969C277.377 321.635 278.534 322.699 278.682 324.065H261.721H261.725Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63 300.998L261.29 294.322H278.517L275.176 300.998H264.626H264.63Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.774 296.145H266.562V299.787H267.774V296.145Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.205 296.145H268.992V299.787H270.205V296.145Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.634 296.145H271.422V299.787H272.634V296.145Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.065 340.756C258.065 340.255 258.474 339.846 258.976 339.846C259.478 339.846 259.887 340.255 259.887 340.756V341.969C259.887 343.037 259.097 343.925 258.065 344.073V340.756Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.527 340.756C280.527 340.255 280.936 339.846 281.438 339.846C281.94 339.846 282.348 340.255 282.348 340.756V344.073C281.317 343.925 280.527 343.042 280.527 341.969V340.756Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.36 348.952H1609.85V394.476H1723.36V348.952Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.36 380.518H1609.85V394.478H1723.36V380.518Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.75 358.058H1615.32V364.13H1617.75V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.7 352.289H1606.51V354.11H1726.7V352.289Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.75 370.804H1615.32V376.876H1617.75V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.35 383.551H1612.28V394.478H1618.35V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.92 383.551H1623.81V394.478H1632.92V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.27 383.551H1637.17V394.478H1646.27V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.63 383.551H1650.52V394.478H1659.63V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.66 385.673C1662.66 383.494 1664.43 381.729 1666.61 381.729C1668.78 381.729 1670.55 383.494 1670.55 385.673V394.477H1662.66V385.673H1662.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.69 383.551H1673.59V394.478H1682.69V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.05 383.551H1686.94V394.478H1696.05V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.01 383.551H1700.9V394.478H1710.01V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.33 383.551H1714.86V394.478H1720.33V383.551Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.35 385.373H1612.28V394.478H1618.35V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.92 385.373H1623.81V394.478H1632.92V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.27 385.373H1637.17V394.478H1646.27V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.63 385.373H1650.52V394.478H1659.63V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.66 387.496C1662.66 385.317 1664.43 383.551 1666.61 383.551C1668.78 383.551 1670.55 385.317 1670.55 387.496V394.478H1662.66V387.496H1662.66Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.69 385.373H1673.59V394.478H1682.69V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.05 385.373H1686.94V394.478H1696.05V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.01 385.373H1700.9V394.478H1710.01V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.33 385.373H1714.86V394.478H1720.33V385.373Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.06 358.058H1625.63V364.13H1628.06V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.06 370.804H1625.63V376.876H1628.06V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 358.058H1632.31V364.13H1634.74V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 370.804H1632.31V376.876H1634.74V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.42 358.058H1638.99V364.13H1641.42V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.42 370.804H1638.99V376.876H1641.42V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.49 358.058H1645.06V364.13H1647.49V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.49 370.804H1645.06V376.876H1647.49V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 358.058H1652.34V364.13H1654.77V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 370.804H1652.34V376.876H1654.77V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.84 358.058H1658.41V364.13H1660.84V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.84 370.804H1658.41V376.876H1660.84V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.13 358.058H1665.7V364.13H1668.13V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.13 370.804H1665.7V376.876H1668.13V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.41 358.058H1672.98V364.13H1675.41V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.41 370.804H1672.98V376.876H1675.41V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.09 358.058H1679.66V364.13H1682.09V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.09 370.804H1679.66V376.876H1682.09V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.16 358.058H1685.73V364.13H1688.16V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.16 370.804H1685.73V376.876H1688.16V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.44 358.058H1693.01V364.13H1695.44V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.44 370.804H1693.01V376.876H1695.44V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.12 358.058H1699.69V364.13H1702.12V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.12 370.804H1699.69V376.876H1702.12V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.18 358.058H1705.75V364.13H1708.18V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.18 370.804H1705.75V376.876H1708.18V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.9 358.058H1715.47V364.13H1717.9V358.058Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.9 370.804H1715.47V376.876H1717.9V370.804Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.18 348.952H1608.03V352.594H1725.18V348.952Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.17 350.165H1609.85V351.378H1620.17V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 350.165H1624.42V351.378H1634.74V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1649.3 350.165H1638.99V351.378H1649.3V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.87 350.165H1653.56V351.378H1663.87V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.44 350.165H1668.12V351.378H1678.44V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.01 350.165H1682.69V351.378H1693.01V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.58 350.165H1697.26V351.378H1707.58V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.15 350.165H1711.83V351.378H1722.15V350.165Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.79 346.223L1670.2 346.343L1670.29 346.831H1670.79V346.223ZM1673.28 346.223H1673.89V345.614H1673.28V346.223ZM1673.28 349.256V349.865H1673.89V349.256H1673.28ZM1661.14 349.256H1660.53V349.865H1661.14V349.256ZM1661.14 346.223V345.614H1660.53V346.223H1661.14ZM1663.63 346.223V346.831H1664.13L1664.23 346.343L1663.63 346.223ZM1670.79 346.831H1673.28V345.619H1670.79V346.831ZM1672.68 346.223V349.256H1673.89V346.223H1672.68ZM1673.28 348.648H1661.14V349.86H1673.28V348.648ZM1661.75 349.256V346.223H1660.54V349.256H1661.75ZM1661.14 346.831H1663.63V345.619H1661.14V346.831ZM1664.23 346.343C1664.45 345.238 1665.44 344.402 1666.61 344.402V343.189C1664.85 343.189 1663.38 344.439 1663.04 346.102L1664.23 346.343ZM1666.61 344.402H1667.82V343.189H1666.61V344.402ZM1667.82 344.402C1668.99 344.402 1669.97 345.238 1670.2 346.343L1671.39 346.102C1671.05 344.439 1669.58 343.189 1667.82 343.189V344.402Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1670.79 346.221H1673.28V349.255H1661.14V346.221H1663.63C1663.91 344.837 1665.14 343.792 1666.61 343.792H1667.82C1669.29 343.792 1670.51 344.832 1670.79 346.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.52 366.556H1723.36V394.477H1772.52V366.556Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.52 384.762H1723.36V394.472H1772.52V384.762Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.28 388.405H1730.03V394.477H1734.28V388.405Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.18 388.405H1737.93V394.477H1742.18V388.405Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.28 388.405H1747.03V394.477H1751.28V388.405Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.17 388.405H1754.92V394.477H1759.17V388.405Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.67 388.405H1763.42V394.477H1767.67V388.405Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.28 372.624H1730.03V381.729H1734.28V372.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.18 372.624H1737.93V381.729H1742.18V372.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.28 372.624H1747.03V381.729H1751.28V372.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.17 372.624H1754.92V381.729H1759.17V372.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.6 381.125H1733.07V384.767H1761.6V381.125Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.67 372.624H1763.42V381.729H1767.67V372.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.94 354.454L1724.32 366.556H1771.58L1747.95 354.454H1747.94Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.54 368.377L1720.02 366.858L1748.24 351.987L1775.55 366.858L1774.34 368.377L1748.24 354.417L1721.53 368.377H1721.54Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1733.97 387.294H1735.2V389.315H1729.12V387.294H1730.35C1730.45 386.384 1731.22 385.678 1732.16 385.678C1733.09 385.678 1733.87 386.384 1733.96 387.294H1733.97Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.97 387.295L1733.37 387.36L1733.43 387.899H1733.97V387.291V387.295ZM1735.2 387.295H1735.8V386.687H1735.2V387.295ZM1735.2 389.316V389.925H1735.8V389.316H1735.2ZM1729.12 389.316H1728.52V389.925H1729.12V389.316ZM1729.12 387.295V386.687H1728.52V387.295H1729.12ZM1730.35 387.295V387.904H1730.89L1730.95 387.365L1730.35 387.3V387.295ZM1733.97 387.904H1735.2V386.691H1733.97V387.904ZM1734.59 387.295V389.316H1735.8V387.295H1734.59ZM1735.2 388.712H1729.12V389.925H1735.2V388.712ZM1729.73 389.316V387.295H1728.52V389.316H1729.73ZM1729.12 387.904H1730.35V386.691H1729.12V387.904ZM1730.95 387.36C1731.02 386.752 1731.54 386.283 1732.16 386.283V385.07C1730.91 385.07 1729.89 386.013 1729.75 387.23L1730.95 387.365V387.36ZM1732.16 386.283C1732.79 386.283 1733.31 386.756 1733.37 387.36L1734.58 387.226C1734.44 386.013 1733.41 385.065 1732.16 385.065V386.278V386.283Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1741.86 387.294H1743.09V389.315H1737.02V387.294H1738.24C1738.34 386.384 1739.12 385.678 1740.05 385.678C1740.98 385.678 1741.76 386.384 1741.86 387.294H1741.86Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.86 387.295L1741.26 387.36L1741.32 387.899H1741.86V387.291V387.295ZM1743.09 387.295H1743.7V386.687H1743.09V387.295ZM1743.09 389.316V389.925H1743.7V389.316H1743.09ZM1737.02 389.316H1736.41V389.925H1737.02V389.316ZM1737.02 387.295V386.687H1736.41V387.295H1737.02ZM1738.24 387.295V387.904H1738.78L1738.84 387.365L1738.24 387.3V387.295ZM1741.86 387.904H1743.09V386.691H1741.86V387.904ZM1742.48 387.295V389.316H1743.69V387.295H1742.48ZM1743.09 388.712H1737.02V389.925H1743.09V388.712ZM1737.63 389.316V387.295H1736.41V389.316H1737.63ZM1737.02 387.904H1738.24V386.691H1737.02V387.904ZM1738.84 387.36C1738.91 386.752 1739.42 386.283 1740.05 386.283V385.07C1738.8 385.07 1737.77 386.013 1737.63 387.23L1738.84 387.365V387.36ZM1740.05 386.283C1740.68 386.283 1741.19 386.756 1741.26 387.36L1742.47 387.226C1742.33 386.013 1741.3 385.065 1740.05 385.065V386.278V386.283Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1750.96 387.294H1752.19V389.315H1746.12V387.294H1747.34C1747.44 386.384 1748.22 385.678 1749.15 385.678C1750.08 385.678 1750.86 386.384 1750.96 387.294H1750.96Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.96 387.295L1750.36 387.36L1750.42 387.899H1750.96V387.291V387.295ZM1752.19 387.295H1752.8V386.687H1752.19V387.295ZM1752.19 389.316V389.925H1752.8V389.316H1752.19ZM1746.12 389.316H1745.51V389.925H1746.12V389.316ZM1746.12 387.295V386.687H1745.51V387.295H1746.12ZM1747.35 387.295V387.904H1747.89L1747.95 387.365L1747.35 387.3V387.295ZM1750.96 387.904H1752.19V386.691H1750.96V387.904ZM1751.59 387.295V389.316H1752.8V387.295H1751.59ZM1752.19 388.712H1746.12V389.925H1752.19V388.712ZM1746.73 389.316V387.295H1745.51V389.316H1746.73ZM1746.12 387.904H1747.35V386.691H1746.12V387.904ZM1747.95 387.36C1748.01 386.752 1748.53 386.283 1749.16 386.283V385.07C1747.91 385.07 1746.88 386.013 1746.74 387.23L1747.95 387.365V387.36ZM1749.16 386.283C1749.78 386.283 1750.3 386.756 1750.36 387.36L1751.57 387.226C1751.43 386.013 1750.41 385.065 1749.16 385.065V386.278V386.283Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1758.86 387.294H1760.08V389.315H1754.01V387.294H1755.24C1755.34 386.384 1756.11 385.678 1757.05 385.678C1757.98 385.678 1758.76 386.384 1758.85 387.294H1758.86Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.86 387.295L1758.26 387.36L1758.32 387.899H1758.86V387.291V387.295ZM1760.08 387.295H1760.69V386.687H1760.08V387.295ZM1760.08 389.316V389.925H1760.69V389.316H1760.08ZM1754.01 389.316H1753.4V389.925H1754.01V389.316ZM1754.01 387.295V386.687H1753.4V387.295H1754.01ZM1755.24 387.295V387.904H1755.78L1755.84 387.365L1755.24 387.3V387.295ZM1758.86 387.904H1760.08V386.691H1758.86V387.904ZM1759.48 387.295V389.316H1760.69V387.295H1759.48ZM1760.08 388.712H1754.01V389.925H1760.08V388.712ZM1754.62 389.316V387.295H1753.41V389.316H1754.62ZM1754.01 387.904H1755.24V386.691H1754.01V387.904ZM1755.84 387.36C1755.91 386.752 1756.42 386.283 1757.05 386.283V385.07C1755.8 385.07 1754.77 386.013 1754.63 387.23L1755.84 387.365V387.36ZM1757.05 386.283C1757.68 386.283 1758.19 386.756 1758.26 387.36L1759.47 387.226C1759.33 386.013 1758.3 385.065 1757.05 385.065V386.278V386.283Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1767.35 387.294H1768.58V389.315H1762.51V387.294H1763.74C1763.83 386.384 1764.61 385.678 1765.54 385.678C1766.48 385.678 1767.25 386.384 1767.35 387.294H1767.35Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.35 387.295L1766.75 387.36L1766.81 387.899H1767.35V387.291V387.295ZM1768.58 387.295H1769.19V386.687H1768.58V387.295ZM1768.58 389.316V389.925H1769.19V389.316H1768.58ZM1762.51 389.316H1761.9V389.925H1762.51V389.316ZM1762.51 387.295V386.687H1761.9V387.295H1762.51ZM1763.73 387.295V387.904H1764.27L1764.33 387.365L1763.73 387.3V387.295ZM1767.35 387.904H1768.58V386.691H1767.35V387.904ZM1767.97 387.295V389.316H1769.18V387.295H1767.97ZM1768.58 388.712H1762.51V389.925H1768.58V388.712ZM1763.11 389.316V387.295H1761.9V389.316H1763.11ZM1762.51 387.904H1763.74V386.691H1762.51V387.904ZM1764.34 387.36C1764.4 386.752 1764.92 386.283 1765.54 386.283V385.07C1764.29 385.07 1763.27 386.013 1763.13 387.23L1764.34 387.365V387.36ZM1765.54 386.283C1766.17 386.283 1766.69 386.756 1766.75 387.36L1767.96 387.226C1767.82 386.013 1766.79 385.065 1765.54 385.065V386.278V386.283Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.89 369.891C1734.89 369.947 1734.86 370.035 1734.75 370.142C1734.63 370.253 1734.45 370.365 1734.2 370.467C1733.69 370.672 1732.97 370.802 1732.16 370.802C1731.35 370.802 1730.63 370.672 1730.13 370.467C1729.87 370.365 1729.69 370.253 1729.57 370.142C1729.46 370.03 1729.43 369.947 1729.43 369.891C1729.43 369.835 1729.46 369.747 1729.57 369.64C1729.69 369.529 1729.87 369.417 1730.13 369.315C1730.63 369.111 1731.35 368.98 1732.16 368.98C1732.97 368.98 1733.69 369.111 1734.2 369.315C1734.45 369.417 1734.63 369.529 1734.75 369.64C1734.87 369.752 1734.89 369.835 1734.89 369.891Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.78 369.891C1742.78 369.947 1742.75 370.035 1742.64 370.142C1742.52 370.253 1742.34 370.365 1742.09 370.467C1741.58 370.672 1740.86 370.802 1740.05 370.802C1739.24 370.802 1738.52 370.672 1738.02 370.467C1737.76 370.365 1737.58 370.253 1737.46 370.142C1737.35 370.03 1737.32 369.947 1737.32 369.891C1737.32 369.835 1737.35 369.747 1737.46 369.64C1737.58 369.529 1737.76 369.417 1738.02 369.315C1738.52 369.111 1739.24 368.98 1740.05 368.98C1740.86 368.98 1741.58 369.111 1742.09 369.315C1742.34 369.417 1742.52 369.529 1742.64 369.64C1742.75 369.752 1742.78 369.835 1742.78 369.891Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.89 369.891C1751.89 369.947 1751.86 370.035 1751.74 370.142C1751.63 370.253 1751.45 370.365 1751.19 370.467C1750.69 370.672 1749.96 370.802 1749.16 370.802C1748.35 370.802 1747.63 370.672 1747.12 370.467C1746.87 370.365 1746.68 370.253 1746.57 370.142C1746.45 370.03 1746.42 369.947 1746.42 369.891C1746.42 369.835 1746.46 369.747 1746.57 369.64C1746.68 369.529 1746.87 369.417 1747.12 369.315C1747.62 369.111 1748.35 368.98 1749.16 368.98C1749.96 368.98 1750.69 369.111 1751.19 369.315C1751.45 369.417 1751.63 369.529 1751.74 369.64C1751.86 369.752 1751.89 369.835 1751.89 369.891Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.78 369.891C1759.78 369.947 1759.75 370.035 1759.64 370.142C1759.52 370.253 1759.34 370.365 1759.08 370.467C1758.58 370.672 1757.86 370.802 1757.05 370.802C1756.24 370.802 1755.52 370.672 1755.01 370.467C1754.76 370.365 1754.58 370.253 1754.46 370.142C1754.34 370.03 1754.32 369.947 1754.32 369.891C1754.32 369.835 1754.35 369.747 1754.46 369.64C1754.58 369.529 1754.76 369.417 1755.01 369.315C1755.52 369.111 1756.24 368.98 1757.05 368.98C1757.86 368.98 1758.58 369.111 1759.08 369.315C1759.34 369.417 1759.52 369.529 1759.64 369.64C1759.75 369.752 1759.78 369.835 1759.78 369.891Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.28 369.891C1768.28 369.947 1768.25 370.035 1768.13 370.142C1768.02 370.253 1767.84 370.365 1767.58 370.467C1767.08 370.672 1766.36 370.802 1765.55 370.802C1764.74 370.802 1764.02 370.672 1763.51 370.467C1763.26 370.365 1763.08 370.253 1762.96 370.142C1762.84 370.03 1762.82 369.947 1762.82 369.891C1762.82 369.835 1762.85 369.747 1762.96 369.64C1763.08 369.529 1763.26 369.417 1763.51 369.315C1764.01 369.111 1764.74 368.98 1765.55 368.98C1766.36 368.98 1767.08 369.111 1767.58 369.315C1767.84 369.417 1768.02 369.529 1768.13 369.64C1768.25 369.752 1768.28 369.835 1768.28 369.891Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.24 358.36L1740.05 362.305H1755.83L1748.24 358.36Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886.04 303.428H1867.22V394.476H1886.04V303.428Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.53 308.283H1886.04V394.476H1894.53V308.283Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.18 303.428H1872.08V394.476H1881.18V303.428Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.35 303.428H1894.54V394.476H1913.35V303.428Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1908.49 303.428H1899.39V394.476H1908.49V303.428Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1908.5 303.428H1904.25V394.476H1908.5V303.428Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.18 303.428H1876.93V394.476H1881.18V303.428Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.26 288.705H1874.96V303.576H1875.26V288.705Z",
    stroke: "#615E66",
    strokeWidth: 0.23229
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1878.9 298.42H1878.6V303.582H1878.9V298.42Z",
    stroke: "#615E66",
    strokeWidth: 0.23229
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.2 364.735C464.223 364.735 467.484 367.997 467.484 372.02V381.126C467.484 385.149 464.223 388.41 460.2 388.41C456.176 388.41 452.915 385.149 452.915 381.126V372.02C452.915 367.997 456.176 364.735 460.2 364.735Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.109 366.858C464.463 366.858 467.181 369.576 467.181 372.93V381.428C467.181 384.782 464.463 387.5 461.109 387.5C457.755 387.5 455.037 384.782 455.037 381.428V372.93C455.037 369.576 457.755 366.858 461.109 366.858Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.894 372.93V395.387",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.447 374.752L460.196 379.003",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.949 379.606L460.2 383.857",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.95 374.752L460.201 379.003",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.189 364.735C498.212 364.735 501.473 367.997 501.473 372.02C501.473 376.043 498.212 379.305 494.189 379.305C490.166 379.305 486.904 376.043 486.904 372.02C486.904 367.997 490.166 364.735 494.189 364.735Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.187 367.469H494.796C497.983 367.469 500.561 370.052 500.561 373.234C500.561 376.421 497.978 379 494.796 379H494.187C491 379 488.422 376.417 488.422 373.234C488.422 370.047 491.005 367.469 494.187 367.469Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.886 372.93V395.387",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.133 373.534L493.882 377.785",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.942 373.534L494.193 377.785",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.91 383.598C469.91 381.005 470.444 378.446 471.476 376.072L472.512 373.693C474.523 369.075 481.074 369.075 483.085 373.693L484.121 376.072C485.157 378.446 485.687 381.005 485.687 383.598C485.687 384.244 485.162 384.768 484.516 384.768H471.076C470.43 384.768 469.905 384.244 469.905 383.598H469.91Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.032 383.299C472.032 381.186 472.474 379.095 473.333 377.162L473.825 376.057C475.707 371.82 481.719 371.82 483.6 376.057L484.093 377.162C484.948 379.095 485.394 381.186 485.394 383.299C485.394 383.941 484.873 384.466 484.227 384.466H473.203C472.562 384.466 472.037 383.945 472.037 383.299H472.032Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.803 380.216V395.087",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.747 378.998L477.803 382.64",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.765 380.82L477.798 384.161",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.901 395.045C434.081 392.504 434.48 387.969 437.705 385.962L443.052 382.636C443.879 382.125 444.929 382.143 445.728 382.692L450.471 385.93C453.542 388.03 453.951 392.401 451.321 395.031C451.289 395.063 451.242 395.082 451.196 395.082H437.003C436.966 395.082 436.924 395.068 436.896 395.04L436.901 395.045Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.896 395.04C436.924 395.068 436.966 395.082 437.003 395.082H451.196C451.242 395.082 451.289 395.063 451.321 395.031C453.951 392.401 453.542 388.03 450.471 385.93L445.728 382.692C444.929 382.143 443.879 382.125 443.052 382.636L437.705 385.962C434.48 387.969 434.081 392.504 436.901 395.045L436.896 395.04ZM436.896 395.04L436.692 395.268",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.329 394.654C435.48 392.438 436.074 389.093 438.569 387.644L444.558 384.174C445.217 383.793 446.035 383.802 446.69 384.197L450.792 386.701C453.71 388.48 453.914 392.638 451.192 394.701C451.127 394.752 451.048 394.775 450.964 394.775H437.598C437.491 394.775 437.389 394.729 437.324 394.645L437.329 394.654Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.503 389.926V394.781",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.453 388.713L443.509 392.356",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.469 390.534L443.502 393.875",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.719 395.388H504.376C505.937 395.388 507.438 394.798 508.576 393.734L509.398 392.967C509.668 392.716 509.863 392.401 509.97 392.047L510.044 391.787C510.616 389.859 508.279 388.405 506.801 389.776V388.744C506.801 386.621 504.135 385.669 502.792 387.318C503.433 384.754 500.488 382.807 498.383 384.405L497.784 384.86L497.621 384.354C497.054 382.593 495.14 381.65 493.403 382.277C491.665 382.905 490.792 384.842 491.47 386.556L491.772 387.318C489.189 387.318 487.749 390.296 489.352 392.322L490.564 393.855C491.331 394.821 492.497 395.388 493.728 395.388H493.719Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.222 395.086L493.58 389.32",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.01 392.656L498.133 388.103",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.384 395.389L505.417 391.445",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.082 390.534L504.205 392.657",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.26 395.086L494.188 385.069",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.793 386.264C636.869 384.081 637.283 380.801 635.81 378.171L627.457 363.217C626.644 361.762 624.558 361.762 623.745 363.217L615.146 378.613C613.808 381.01 614.096 383.993 615.88 386.088C617.129 387.561 618.964 388.406 620.897 388.406H629.803C631.689 388.406 633.492 387.63 634.793 386.264Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.291 386.571C636.294 384.703 636.688 381.674 635.225 379.356L628.261 368.304C627.309 366.794 625.102 366.794 624.149 368.304L616.196 380.931C615.299 382.353 615.49 384.202 616.651 385.419C618.3 387.138 620.577 388.109 622.955 388.109H630.389C631.834 388.109 633.227 387.561 634.282 386.576L634.291 386.571Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.604 372.93V395.388",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.05 374.752L625.301 379.003",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.155 379.607L625.904 383.858",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.548 374.752L625.297 379.003",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.601 395.047C651.421 392.506 651.021 387.971 647.797 385.964L642.45 382.638C641.623 382.127 640.573 382.145 639.774 382.694L635.03 385.932C631.959 388.032 631.55 392.403 634.18 395.033C634.212 395.065 634.259 395.084 634.305 395.084H648.498C648.535 395.084 648.577 395.07 648.605 395.042L648.601 395.047Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.605 395.042C648.577 395.07 648.535 395.084 648.498 395.084H634.305C634.259 395.084 634.212 395.065 634.18 395.033C631.55 392.403 631.959 388.032 635.03 385.932L639.774 382.694C640.573 382.145 641.623 382.127 642.45 382.638L647.797 385.964C651.021 387.971 651.421 392.506 648.601 395.047L648.605 395.042ZM648.605 395.042L648.81 395.27",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.387 394.654C651.236 392.438 650.641 389.093 648.146 387.644L642.158 384.174C641.498 383.793 640.681 383.802 640.026 384.197L635.923 386.701C633.006 388.48 632.801 392.638 635.524 394.701C635.589 394.752 635.668 394.775 635.751 394.775H649.117C649.224 394.775 649.326 394.729 649.392 394.645L649.387 394.654Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.993 389.926V394.781",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.049 388.713L641.993 392.355",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.027 390.533L641.993 393.873",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 394.478H51.0801V413.293H2041.1V394.478Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 394.564H50.7793V412.991H2041.1V394.564Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.61 404.492C1181.44 406.216 1179.99 407.526 1178.26 407.526H1177.82C1176.04 407.526 1174.51 406.248 1174.2 404.492C1173.92 406.239 1172.4 407.526 1170.62 407.526C1168.84 407.526 1167.29 406.244 1166.98 404.492C1166.67 406.248 1165.14 407.526 1163.35 407.526H1163.12C1161.33 407.526 1159.81 406.248 1159.5 404.492L1159.39 405.008C1159.07 406.481 1157.77 407.531 1156.27 407.531H1156.11C1154.43 407.531 1153.08 406.169 1153.08 404.497",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.6 399.03C1822.43 400.08 1821.52 400.851 1820.45 400.851H1817.62C1816.49 400.851 1815.5 400.108 1815.19 399.03C1814.9 400.103 1813.94 400.851 1812.83 400.851H1810.41C1809.28 400.851 1808.29 400.108 1807.97 399.03C1807.65 400.112 1806.65 400.851 1805.52 400.851H1802.92C1801.79 400.851 1800.8 400.108 1800.48 399.03C1800.09 400.122 1799.06 400.851 1797.91 400.851H1795.89C1794.88 400.851 1794.07 400.038 1794.07 399.03",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.05 404.492C1773.87 406.216 1772.42 407.526 1770.7 407.526H1770.25C1768.47 407.526 1766.95 406.248 1766.64 404.492C1766.36 406.239 1764.83 407.526 1763.05 407.526C1761.27 407.526 1759.73 406.244 1759.42 404.492C1759.1 406.248 1757.57 407.526 1755.79 407.526H1755.55C1753.77 407.526 1752.24 406.248 1751.93 404.492L1751.82 405.008C1751.5 406.481 1750.2 407.531 1748.7 407.531H1748.54C1746.87 407.531 1745.51 406.169 1745.51 404.497",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 351.377H1843.55V394.476H1890.28V351.377Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 351.377H1843.55V356.84H1890.28V351.377Z",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 351.377H1843.55V353.198H1890.28V351.377Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848 344.529L1843.78 351.382H1890.05L1885.83 344.529C1885.67 344.26 1885.37 344.097 1885.06 344.097H1848.78C1848.47 344.097 1848.17 344.26 1848.01 344.529H1848Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 381.125H1843.55V394.477H1890.28V381.125Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.05 384.762H1847.8V390.226H1852.05V384.762Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.94 384.762H1855.68V390.226H1859.94V384.762Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.93 384.762H1872.68V390.226H1876.93V384.762Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.43 384.762H1881.18V390.226H1885.43V384.762Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.82 368.98H1881.79V378.69H1884.82V368.98Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.82 359.272H1881.79V364.127H1884.82V359.272Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.33 368.98H1873.9V378.69H1876.33V368.98Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.33 359.272H1873.9V364.127H1876.33V359.272Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.83 368.98H1865.4V378.69H1867.83V368.98Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.83 359.272H1865.4V364.127H1867.83V359.272Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.33 368.98H1856.9V378.69H1859.33V368.98Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.33 359.272H1856.9V364.127H1859.33V359.272Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.44 368.98H1849.01V378.69H1851.44V368.98Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.44 359.272H1849.01V364.127H1851.44V359.272Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1869.04 384.762H1864.79V394.472H1869.04V384.762Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.58 356.84H1843.55V381.119H1846.58V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.68 356.84H1852.65V381.119H1855.68V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.18 356.84H1861.15V381.119H1864.18V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.68 356.84H1869.65V381.119H1872.68V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.57 356.84H1877.54V381.119H1880.57V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 356.84H1887.25V381.119H1890.28V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.58 356.84H1843.55V358.053H1846.58V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.68 356.84H1852.65V358.053H1855.68V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.18 356.84H1861.15V358.053H1864.18V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.68 356.84H1869.65V358.053H1872.68V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.57 356.84H1877.54V358.053H1880.57V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.28 356.84H1887.25V358.053H1890.28V356.84Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.69 368.98C1817.67 368.98 1814.41 372.242 1814.41 376.265V385.371C1814.41 389.394 1817.67 392.655 1821.69 392.655C1825.72 392.655 1828.98 389.394 1828.98 385.371V376.265C1828.98 372.242 1825.72 368.98 1821.69 368.98Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.78 371.108C1817.43 371.108 1814.71 373.826 1814.71 377.18V385.677C1814.71 389.031 1817.43 391.749 1820.78 391.749C1824.14 391.749 1826.85 389.031 1826.85 385.677V377.18C1826.85 373.826 1824.14 371.108 1820.78 371.108Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822 377.176V394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817.45 378.998L1821.7 383.249",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.94 383.853L1821.69 388.104",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.94 378.998L1821.69 383.249",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.7 364.127C1783.68 364.127 1780.42 367.388 1780.42 371.412C1780.42 375.435 1783.68 378.696 1787.7 378.696C1791.72 378.696 1794.99 375.435 1794.99 371.412C1794.99 367.388 1791.72 364.127 1787.7 364.127Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.7 366.857H1787.09C1783.91 366.857 1781.33 369.44 1781.33 372.623C1781.33 375.81 1783.91 378.388 1787.09 378.388H1787.7C1790.89 378.388 1793.47 375.805 1793.47 372.623C1793.47 369.436 1790.89 366.857 1787.7 366.857Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788 372.321V394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.75 372.93L1788 377.181",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.95 372.93L1787.7 377.181",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.98 382.986C1811.98 380.394 1811.45 377.834 1810.42 375.46L1809.38 373.082C1807.37 368.464 1800.81 368.464 1798.81 373.082L1797.77 375.46C1796.74 377.834 1796.2 380.394 1796.2 382.986C1796.2 383.632 1796.72 384.157 1797.37 384.157H1810.82C1811.47 384.157 1811.99 383.632 1811.99 382.986H1811.98Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.86 382.689C1809.86 380.575 1809.42 378.485 1808.56 376.552L1808.07 375.446C1806.19 371.209 1800.17 371.209 1798.29 375.446L1797.8 376.552C1796.95 378.485 1796.5 380.575 1796.5 382.689C1796.5 383.33 1797.02 383.855 1797.67 383.855H1808.69C1809.33 383.855 1809.86 383.335 1809.86 382.689H1809.86Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804.09 379.603V394.474",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.14 378.394L1804.09 382.036",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.13 380.213L1804.09 383.554",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.99 394.435C1847.81 391.894 1847.41 387.359 1844.19 385.352L1838.84 382.026C1838.02 381.515 1836.97 381.534 1836.17 382.082L1831.42 385.32C1828.35 387.42 1827.94 391.792 1830.57 394.421C1830.61 394.454 1830.65 394.472 1830.7 394.472H1844.89C1844.93 394.472 1844.96 394.458 1844.99 394.43V394.435Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.99 394.43C1844.96 394.458 1844.93 394.472 1844.89 394.472H1830.7C1830.65 394.472 1830.61 394.454 1830.57 394.421C1827.94 391.792 1828.35 387.42 1831.42 385.32L1836.17 382.082C1836.97 381.534 1838.02 381.515 1838.84 382.026L1844.19 385.352C1847.41 387.359 1847.81 391.894 1844.99 394.435V394.43ZM1844.99 394.43L1845.19 394.658",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.56 394.045C1846.41 391.829 1845.81 388.484 1843.32 387.034L1837.33 383.564C1836.67 383.183 1835.85 383.192 1835.2 383.587L1831.1 386.091C1828.18 387.87 1827.97 392.028 1830.7 394.091C1830.76 394.142 1830.84 394.165 1830.92 394.165H1844.28C1844.4 394.165 1844.49 394.119 1844.56 394.035V394.045Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.38 389.315V394.17",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.44 388.102L1838.38 391.744",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.42 389.924L1838.39 393.265",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.18 394.778H1777.52C1775.96 394.778 1774.46 394.188 1773.32 393.125L1772.5 392.358C1772.23 392.107 1772.03 391.791 1771.93 391.438L1771.85 391.178C1771.28 389.25 1773.62 387.796 1775.09 389.166V388.135C1775.09 386.012 1777.77 385.059 1779.11 386.709C1778.46 384.144 1781.41 382.198 1783.52 383.796L1784.12 384.251L1784.28 383.745C1784.85 381.984 1786.76 381.041 1788.5 381.668C1790.24 382.295 1791.11 384.232 1790.43 385.947L1790.13 386.709C1792.71 386.709 1794.15 389.687 1792.55 391.712L1791.34 393.245C1790.57 394.212 1789.41 394.778 1788.18 394.778Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.66 394.477L1788.31 388.711",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.88 392.047L1783.76 387.494",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.51 394.779L1776.47 390.835",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.81 389.924L1777.69 392.047",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.63 394.476L1787.7 384.46",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M890.374 418.352C886.407 417.027 883.387 418.904 882.379 420.005C882.007 420.187 881.217 420.391 880.999 419.731C883.201 417.25 887.615 416.424 890.37 418.352H890.374Z",
    fill: "url(#paint5_linear_6001_44765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.542 404.725V406.69L413.765 406.463C413.208 405.348 412.069 404.646 410.824 404.646H393.621C393.579 404.646 393.542 404.683 393.542 404.725Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.274 428.052H374.917C374.917 429.055 374.104 429.873 373.096 429.873H371.274V428.052Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.65 382.945H1594.92L1635.53 402.369H1574.65V382.945Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.82 382.945H1574.65V402.369H1589.82V382.945Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.96 387.801H1579.5V402.37H1584.96V387.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.03 381.626L1584.24 376.595H1584.17L1582.87 379.368L1581.52 376.567L1579.68 381.622H1579.2V382.026H1581.81V381.622H1581.29L1581.81 380.042L1582.87 382.03L1583.89 380.042L1584.4 381.622H1583.89V382.026H1586.48V381.622H1586.03L1586.03 381.626Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.92 403.624C1025.92 401.031 1026.45 398.471 1027.48 396.097L1028.52 393.719C1030.53 389.101 1037.09 389.101 1039.09 393.719L1040.13 396.097C1041.16 398.471 1041.69 401.031 1041.69 403.624C1041.69 404.269 1041.17 404.794 1040.52 404.794H1027.08C1026.43 404.794 1025.91 404.269 1025.91 403.624H1025.92Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.05 403.326C1028.05 401.212 1028.49 399.122 1029.35 397.189L1029.84 396.083C1031.72 391.847 1037.73 391.847 1039.61 396.083L1040.11 397.189C1040.96 399.122 1041.41 401.212 1041.41 403.326C1041.41 403.967 1040.89 404.492 1040.24 404.492H1029.22C1028.57 404.492 1028.05 403.972 1028.05 403.326H1028.05Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.81 400.242V405.097",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.76 399.03L1033.81 402.672",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.78 400.851L1033.81 404.191",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.626 404.753C982.801 402.212 983.205 397.677 986.425 395.67L991.772 392.344C992.599 391.833 993.649 391.851 994.448 392.4L999.196 395.638C1002.27 397.738 1002.68 402.109 1000.05 404.739C1000.01 404.771 999.967 404.79 999.921 404.79H985.728C985.691 404.79 985.654 404.776 985.626 404.748V404.753Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.626 404.748C985.654 404.776 985.691 404.79 985.728 404.79H999.921C999.967 404.79 1000.01 404.771 1000.05 404.739C1002.68 402.109 1002.27 397.738 999.196 395.638L994.448 392.4C993.649 391.851 992.599 391.833 991.772 392.344L986.425 395.67C983.205 397.677 982.801 402.212 985.626 404.753V404.748ZM985.626 404.748L985.421 404.976",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.053 404.364C984.208 402.148 984.803 398.803 987.298 397.353L993.282 393.883C993.941 393.502 994.764 393.511 995.414 393.906L999.516 396.41C1002.43 398.19 1002.64 402.348 999.916 404.41C999.855 404.461 999.776 404.485 999.693 404.485H986.332C986.22 404.485 986.127 404.438 986.053 404.355V404.364Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.23 399.639V404.494",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.175 398.42L992.23 402.062",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.197 400.242L992.231 403.583",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.44 405.097H1053.1C1054.66 405.097 1056.16 404.507 1057.3 403.443L1058.12 402.677C1058.39 402.426 1058.59 402.11 1058.69 401.757L1058.77 401.497C1059.34 399.569 1057 398.115 1055.53 399.485V398.454C1055.53 396.331 1052.85 395.378 1051.51 397.028C1052.15 394.463 1049.21 392.516 1047.1 394.115L1046.5 394.57L1046.34 394.063C1045.77 392.303 1043.86 391.36 1042.12 391.987C1040.38 392.614 1039.51 394.551 1040.19 396.266L1040.49 397.028C1037.91 397.028 1036.47 400.005 1038.07 402.031L1039.28 403.564C1040.05 404.53 1041.21 405.097 1042.44 405.097Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.95 404.795L1042.31 399.03",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.74 402.365L1046.86 397.812",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.11 405.096L1054.14 401.151",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.81 400.242L1052.93 402.365",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.99 404.796L1042.91 394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.839 403.624C168.839 401.031 169.373 398.471 170.404 396.097L171.44 393.719C173.452 389.101 180.002 389.101 182.014 393.719L183.05 396.097C184.086 398.471 184.616 401.031 184.616 403.624C184.616 404.269 184.091 404.794 183.445 404.794H170.005C169.359 404.794 168.834 404.269 168.834 403.624H168.839Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.96 403.327C170.96 401.213 171.401 399.123 172.261 397.19L172.753 396.084C174.635 391.847 180.646 391.847 182.528 396.084L183.02 397.19C183.875 399.123 184.321 401.213 184.321 403.327C184.321 403.968 183.801 404.493 183.155 404.493H172.131C171.49 404.493 170.965 403.973 170.965 403.327H170.96Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.727 400.242V405.097",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.677 399.03L176.732 402.672",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.693 400.852L176.727 404.192",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.545 404.753C125.725 402.212 126.125 397.677 129.349 395.67L134.696 392.344C135.523 391.833 136.573 391.851 137.372 392.4L142.116 395.638C145.187 397.738 145.595 402.109 142.966 404.739C142.933 404.771 142.887 404.79 142.84 404.79H128.648C128.61 404.79 128.569 404.776 128.541 404.748L128.545 404.753Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.541 404.748C128.569 404.776 128.61 404.79 128.648 404.79H142.84C142.887 404.79 142.933 404.771 142.966 404.739C145.595 402.109 145.187 397.738 142.116 395.638L137.372 392.4C136.573 391.851 135.523 391.833 134.696 392.344L129.349 395.67C126.125 397.677 125.725 402.212 128.545 404.753L128.541 404.748ZM128.541 404.748L128.336 404.976",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.973 404.364C127.124 402.148 127.719 398.803 130.214 397.353L136.202 393.883C136.862 393.502 137.68 393.511 138.335 393.906L142.437 396.41C145.354 398.19 145.559 402.348 142.836 404.41C142.771 404.461 142.692 404.485 142.609 404.485H129.243C129.136 404.485 129.034 404.438 128.969 404.355L128.973 404.364Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.151 399.637V404.492",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.096 398.421L135.151 402.064",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.113 400.242L135.147 403.583",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.363 405.098H196.021C197.582 405.098 199.082 404.508 200.221 403.444L201.043 402.677C201.312 402.426 201.507 402.11 201.614 401.757L201.689 401.497C202.26 399.569 199.923 398.115 198.446 399.486V398.454C198.446 396.331 195.779 395.379 194.437 397.028C195.078 394.464 192.132 392.517 190.028 394.115L189.428 394.57L189.266 394.064C188.699 392.303 186.785 391.36 185.047 391.987C183.31 392.614 182.436 394.552 183.115 396.266L183.417 397.028C180.834 397.028 179.393 400.006 180.996 402.032L182.209 403.565C182.975 404.531 184.141 405.098 185.373 405.098H185.363Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.871 404.795L185.229 399.03",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.653 402.363L189.776 397.811",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.027 405.096L197.061 401.151",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.726 400.242L195.849 402.365",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.905 404.795L185.833 394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.84 401.198C1643.84 398.606 1643.31 396.046 1642.27 393.672L1641.24 391.294C1639.23 386.676 1632.67 386.676 1630.67 391.294L1629.63 393.672C1628.6 396.046 1628.06 398.606 1628.06 401.198C1628.06 401.844 1628.58 402.369 1629.23 402.369H1642.67C1643.32 402.369 1643.85 401.844 1643.85 401.198H1643.84Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.72 400.901C1641.72 398.787 1641.28 396.696 1640.42 394.763L1639.92 393.658C1638.04 389.421 1632.03 389.421 1630.15 393.658L1629.66 394.763C1628.8 396.696 1628.36 398.787 1628.36 400.901C1628.36 401.542 1628.88 402.067 1629.52 402.067H1640.55C1641.19 402.067 1641.71 401.546 1641.71 400.901H1641.72Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.95 397.817V402.672",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.01 396.6L1635.95 400.242",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.98 398.421L1635.95 401.762",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.13 402.328C1686.96 399.786 1686.56 395.252 1683.34 393.245L1677.99 389.919C1677.16 389.408 1676.11 389.426 1675.31 389.974L1670.56 393.213C1667.49 395.312 1667.08 399.684 1669.71 402.314C1669.75 402.346 1669.79 402.365 1669.84 402.365H1684.03C1684.07 402.365 1684.11 402.351 1684.13 402.323V402.328Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.13 402.323C1684.11 402.351 1684.07 402.365 1684.03 402.365H1669.84C1669.79 402.365 1669.75 402.346 1669.71 402.314C1667.08 399.684 1667.49 395.312 1670.56 393.213L1675.31 389.974C1676.11 389.426 1677.16 389.408 1677.99 389.919L1683.34 393.245C1686.56 395.252 1686.96 399.786 1684.13 402.328V402.323ZM1684.13 402.323L1684.34 402.551",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.71 401.934C1685.56 399.718 1684.96 396.373 1682.47 394.923L1676.48 391.453C1675.82 391.072 1675 391.081 1674.35 391.476L1670.25 393.98C1667.33 395.759 1667.12 399.917 1669.85 401.98C1669.91 402.031 1669.99 402.054 1670.07 402.054H1683.43C1683.54 402.054 1683.64 402.008 1683.71 401.924V401.934Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.53 397.208V402.063",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.59 395.996L1677.53 399.638",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.57 397.817L1677.53 401.157",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.32 402.672H1616.66C1615.1 402.672 1613.6 402.082 1612.46 401.018L1611.65 400.251C1611.37 400.001 1611.18 399.685 1611.07 399.332L1611 399.071C1610.42 397.143 1612.76 395.689 1614.24 397.06V396.028C1614.24 393.905 1616.91 392.953 1618.25 394.602C1617.61 392.038 1620.55 390.091 1622.67 391.689L1623.27 392.145L1623.42 391.638C1623.99 389.877 1625.9 388.934 1627.65 389.562C1629.38 390.189 1630.26 392.126 1629.57 393.84L1629.27 394.602C1631.85 394.602 1633.3 397.58 1631.69 399.606L1630.48 401.139C1629.72 402.105 1628.56 402.672 1627.32 402.672Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.81 402.365L1627.46 396.6",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.03 399.94L1622.9 395.387",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.65 402.673L1615.62 398.729",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.96 397.817L1616.83 399.94",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.77 402.367L1626.85 392.351",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4301 392.507C98.4301 392.086 98.089 391.745 97.6682 391.745C97.2474 391.745 96.9062 392.086 96.9062 392.507V404.684C96.9062 405.104 97.2474 405.446 97.6682 405.446C98.089 405.446 98.4301 405.104 98.4301 404.684V392.507Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.311 392.757H98.4297V397.831H124.311V392.757Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.311 396.311H98.4297V396.817H124.311V396.311Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.311 394.282H98.4297V394.789H124.311V394.282Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.788 392.507C122.788 392.084 123.127 391.745 123.55 391.745C123.973 391.745 124.312 392.084 124.312 392.507V404.688C124.312 405.106 123.973 405.45 123.55 405.45C123.127 405.45 122.788 405.111 122.788 404.688V392.507Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.493 401.133C102.493 400.712 102.151 400.371 101.731 400.371C101.31 400.371 100.969 400.712 100.969 401.133V405.7C100.969 406.121 101.31 406.462 101.731 406.462C102.151 406.462 102.493 406.121 102.493 405.7V401.133Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.867 401.133C127.867 400.712 127.525 400.371 127.105 400.371C126.684 400.371 126.343 400.712 126.343 401.133V405.7C126.343 406.121 126.684 406.462 127.105 406.462C127.525 406.462 127.867 406.121 127.867 405.7V401.133Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.432 400.372L96.9082 399.104H124.314L127.868 400.372V401.896H100.969L98.432 400.372Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.868 400.371H100.969V401.895H127.868V400.371Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9082 399.104L100.969 400.372V402.402L96.9082 400.627V399.104Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.323 391.745C952.742 391.745 953.085 392.084 953.085 392.507V404.688C953.085 405.106 952.746 405.45 952.323 405.45C951.905 405.45 951.562 405.111 951.562 404.688V392.507C951.562 392.089 951.901 391.745 952.323 391.745Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.968 392.757H953.086V397.831H978.968V392.757Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.968 396.311H953.086V396.817H978.968V396.311Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.968 394.282H953.086V394.789H978.968V394.282Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.442 392.507C977.442 392.084 977.782 391.745 978.2 391.745C978.618 391.745 978.966 392.084 978.966 392.507V404.688C978.966 405.106 978.627 405.45 978.2 405.45C977.772 405.45 977.442 405.111 977.442 404.688V392.507Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.383 400.371C956.801 400.371 957.145 400.71 957.145 401.133V405.7C957.145 406.118 956.806 406.462 956.383 406.462C955.965 406.462 955.621 406.123 955.621 405.7V401.133C955.621 400.715 955.96 400.371 956.383 400.371Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.754 400.371C982.172 400.371 982.516 400.71 982.516 401.133V405.7C982.516 406.118 982.177 406.462 981.754 406.462C981.336 406.462 980.992 406.123 980.992 405.7V401.133C980.992 400.715 981.331 400.371 981.754 400.371Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.085 400.372L951.562 399.104H978.967L982.516 400.372V401.896H955.622L953.085 400.372Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.52 400.371H955.621V401.895H982.52V400.371Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.562 399.104L955.622 400.372V402.402L951.562 400.627V399.104Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.07 396.354C1545.36 396.354 1545.6 396.592 1545.6 396.889V405.435C1545.6 405.728 1545.37 405.97 1545.07 405.97C1544.78 405.97 1544.54 405.732 1544.54 405.435V396.889C1544.54 396.596 1544.77 396.354 1545.07 396.354Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.76 397.064H1545.6V400.624H1563.76V397.064Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.76 399.558H1545.6V399.913H1563.76V399.558Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.76 398.134H1545.6V398.49H1563.76V398.134Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.69 396.889C1562.69 396.592 1562.93 396.354 1563.22 396.354C1563.52 396.354 1563.76 396.592 1563.76 396.889V405.435C1563.76 405.728 1563.52 405.97 1563.22 405.97C1562.92 405.97 1562.69 405.732 1562.69 405.435V396.889Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.92 402.407C1548.21 402.407 1548.45 402.645 1548.45 402.941V406.145C1548.45 406.439 1548.21 406.68 1547.92 406.68C1547.62 406.68 1547.38 406.442 1547.38 406.145V402.941C1547.38 402.648 1547.62 402.407 1547.92 402.407Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.72 402.407C1566.01 402.407 1566.25 402.645 1566.25 402.941V406.145C1566.25 406.439 1566.01 406.68 1565.72 406.68C1565.42 406.68 1565.18 406.442 1565.18 406.145V402.941C1565.18 402.648 1565.42 402.407 1565.72 402.407Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.61 402.407L1544.54 401.518H1563.76L1566.25 402.407V403.476H1547.38L1545.61 402.407Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.26 402.407H1547.38V403.476H1566.26V402.407Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.54 401.518L1547.38 402.407V403.832L1544.54 402.587V401.518Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.89 393.74C1082.6 393.74 1082.35 393.978 1082.35 394.275V402.821C1082.35 403.114 1082.59 403.355 1082.89 403.355C1083.18 403.355 1083.42 403.117 1083.42 402.821V394.275C1083.42 393.981 1083.19 393.74 1082.89 393.74Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.2 394.45H1082.36V398.009H1064.2V394.45Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.2 396.943H1082.36V397.299H1064.2V396.943Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.2 395.52H1082.36V395.875H1064.2V395.52Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.27 394.275C1065.27 393.978 1065.03 393.74 1064.73 393.74C1064.44 393.74 1064.2 393.978 1064.2 394.275V402.821C1064.2 403.114 1064.43 403.355 1064.73 403.355C1065.03 403.355 1065.27 403.117 1065.27 402.821V394.275Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.04 399.792C1079.75 399.792 1079.51 400.03 1079.51 400.327V403.531C1079.51 403.824 1079.74 404.066 1080.04 404.066C1080.33 404.066 1080.58 403.828 1080.58 403.531V400.327C1080.58 400.034 1080.34 399.792 1080.04 399.792Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.24 399.792C1061.95 399.792 1061.71 400.03 1061.71 400.327V403.531C1061.71 403.824 1061.94 404.066 1062.24 404.066C1062.53 404.066 1062.78 403.828 1062.78 403.531V400.327C1062.78 400.034 1062.54 399.792 1062.24 399.792Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.35 399.793L1083.42 398.903H1064.2L1061.71 399.793V400.862H1080.57L1082.35 399.793Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.7 399.792H1080.58V400.862H1061.7V399.792Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.42 398.903L1080.57 399.793V401.217L1083.42 399.972V398.903Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.81 389.398C410.06 389.398 410.265 389.601 410.265 389.853V397.123C410.265 397.373 410.062 397.578 409.81 397.578C409.561 397.578 409.355 397.376 409.355 397.123V389.853C409.355 389.604 409.558 389.398 409.81 389.398Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.713 390.002H410.266V393.03H425.713V390.002Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.713 392.124H410.266V392.426H425.713V392.124Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.713 390.913H410.266V391.215H425.713V390.913Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.803 389.853C424.803 389.601 425.005 389.398 425.255 389.398C425.504 389.398 425.712 389.601 425.712 389.853V397.123C425.712 397.373 425.51 397.578 425.255 397.578C425 397.578 424.803 397.376 424.803 397.123V389.853Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.233 394.547C412.483 394.547 412.688 394.749 412.688 395.002V397.727C412.688 397.977 412.485 398.182 412.233 398.182C411.983 398.182 411.778 397.98 411.778 397.727V395.002C411.778 394.752 411.981 394.547 412.233 394.547Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.377 394.547C427.626 394.547 427.831 394.749 427.831 395.002V397.727C427.831 397.977 427.629 398.182 427.377 398.182C427.127 398.182 426.922 397.98 426.922 397.727V395.002C426.922 394.752 427.124 394.547 427.377 394.547Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.266 394.548L409.356 393.791H425.713L427.831 394.548V395.457H411.78L410.266 394.548Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.833 394.547H411.778V395.456H427.833V394.547Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.356 393.791L411.78 394.548V395.76L409.356 394.7V393.791Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.681 211.534H597.606L603.308 209.161C605.204 208.37 607.357 208.441 609.196 209.361C610.165 208.391 613.108 206.752 617.164 207.914C611.947 209.075 609.68 212.261 609.196 213.708C607.314 212.297 605.026 211.534 602.674 211.534H602.681Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.537 166.867H456.462L462.164 164.494C464.067 163.702 466.212 163.774 468.051 164.693C469.02 163.731 471.964 162.084 476.019 163.246C470.802 164.408 468.536 167.594 468.051 169.041C466.169 167.63 463.881 166.867 461.529 166.867H461.537Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.07 220.477H1650.15L1644.45 218.104C1642.54 217.313 1640.4 217.384 1638.56 218.303C1637.59 217.341 1634.65 215.695 1630.59 216.857C1635.81 218.018 1638.07 221.204 1638.56 222.651C1640.44 221.24 1642.73 220.477 1645.08 220.477H1645.07Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 449.409H50.7793V456.633H2041.1V449.409Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.1 455.986H50.7793V460.938H2041.1V455.986Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.162 399.031C690.986 400.081 690.075 400.852 689.011 400.852H686.182C685.053 400.852 684.064 400.109 683.748 399.031C683.464 400.104 682.498 400.852 681.388 400.852H678.967C677.838 400.852 676.849 400.109 676.533 399.031C676.212 400.113 675.213 400.852 674.084 400.852H671.478C670.349 400.852 669.36 400.109 669.044 399.031C668.654 400.123 667.618 400.852 666.465 400.852H664.449C663.441 400.852 662.628 400.039 662.628 399.031",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.598 404.494C642.427 406.217 640.977 407.527 639.244 407.527H638.803C637.019 407.527 635.495 406.25 635.188 404.494C634.914 406.24 633.377 407.527 631.606 407.527C629.827 407.527 628.275 406.245 627.969 404.494C627.653 406.25 626.124 407.527 624.34 407.527H624.104C622.32 407.527 620.796 406.25 620.489 404.494L620.378 405.009C620.062 406.482 618.765 407.532 617.26 407.532H617.107C615.43 407.532 614.073 406.171 614.073 404.498",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.388 399.031C346.211 400.081 345.305 400.852 344.237 400.852H341.407C340.283 400.852 339.294 400.109 338.973 399.031C338.69 400.104 337.719 400.852 336.613 400.852H334.188C333.064 400.852 332.074 400.109 331.754 399.031C331.428 400.113 330.434 400.852 329.305 400.852H326.699C325.575 400.852 324.585 400.109 324.265 399.031C323.874 400.123 322.843 400.852 321.681 400.852H319.67C318.666 400.852 317.849 400.039 317.849 399.031",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.825 404.494C297.653 406.217 296.204 407.527 294.471 407.527H294.029C292.245 407.527 290.722 406.25 290.415 404.494C290.141 406.24 288.603 407.527 286.833 407.527C285.054 407.527 283.502 406.245 283.195 404.494C282.879 406.25 281.351 407.527 279.567 407.527H279.33C277.546 407.527 276.022 406.25 275.716 404.494L275.604 405.009C275.288 406.482 273.992 407.532 272.487 407.532H272.334C270.656 407.532 269.3 406.171 269.3 404.498",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.978 399.031C865.801 400.081 864.891 400.852 863.827 400.852H860.998C859.869 400.852 858.879 400.109 858.563 399.031C858.28 400.104 857.313 400.852 856.203 400.852H853.783C852.654 400.852 851.664 400.109 851.348 399.031C851.028 400.113 850.029 400.852 848.9 400.852H846.294C845.165 400.852 844.175 400.109 843.859 399.031C843.469 400.123 842.433 400.852 841.281 400.852H839.265C838.256 400.852 837.443 400.039 837.443 399.031",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.413 404.494C817.241 406.217 815.792 407.527 814.064 407.527H813.622C811.838 407.527 810.315 406.25 810.003 404.494C809.725 406.24 808.196 407.527 806.421 407.527C804.642 407.527 803.095 406.245 802.784 404.494C802.468 406.25 800.939 407.527 799.155 407.527H798.918C797.134 407.527 795.611 406.25 795.299 404.494L795.188 405.009C794.872 406.482 793.571 407.532 792.066 407.532H791.913C790.235 407.532 788.879 406.171 788.879 404.498",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.18 399.031C1230 400.081 1229.09 400.852 1228.03 400.852H1225.2C1224.07 400.852 1223.08 400.109 1222.76 399.031C1222.48 400.104 1221.51 400.852 1220.4 400.852H1217.98C1216.85 400.852 1215.86 400.109 1215.55 399.031C1215.23 400.113 1214.23 400.852 1213.1 400.852H1210.49C1209.36 400.852 1208.37 400.109 1208.06 399.031C1207.67 400.123 1206.63 400.852 1205.48 400.852H1203.46C1202.46 400.852 1201.64 400.039 1201.64 399.031",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487.5 401.532C1487.33 402.582 1486.42 403.353 1485.35 403.353H1482.52C1481.39 403.353 1480.4 402.61 1480.09 401.532C1479.8 402.605 1478.84 403.353 1477.73 403.353H1475.31C1474.18 403.353 1473.19 402.61 1472.87 401.532C1472.55 402.615 1471.55 403.353 1470.42 403.353H1467.82C1466.69 403.353 1465.7 402.61 1465.38 401.532C1464.99 402.624 1463.96 403.353 1462.81 403.353H1460.79C1459.78 403.353 1458.97 402.54 1458.97 401.532",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.14 404.494C1365.97 406.217 1364.52 407.527 1362.8 407.527H1362.35C1360.57 407.527 1359.05 406.25 1358.73 404.494C1358.46 406.24 1356.93 407.527 1355.15 407.527C1353.37 407.527 1351.83 406.245 1351.52 404.494C1351.2 406.25 1349.67 407.527 1347.89 407.527H1347.65C1345.87 407.527 1344.34 406.25 1344.03 404.494L1343.92 405.009C1343.6 406.482 1342.3 407.532 1340.8 407.532H1340.64C1338.97 407.532 1337.61 406.171 1337.61 404.498",
    stroke: "#615E66",
    strokeWidth: 0.464579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.437 359.88C814.46 359.88 817.722 363.142 817.722 367.165V376.271C817.722 380.294 814.46 383.555 810.437 383.555C806.414 383.555 803.152 380.294 803.152 376.271V367.165C803.152 363.142 806.414 359.88 810.437 359.88Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.346 362.003C814.701 362.003 817.419 364.721 817.419 368.075V376.573C817.419 379.927 814.701 382.645 811.346 382.645C807.992 382.645 805.274 379.927 805.274 376.573V368.075C805.274 364.721 807.992 362.003 811.346 362.003Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.13 368.07V394.779",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.682 369.892L810.129 374.956",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.186 374.752L810.13 378.696",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.186 369.892L810.13 373.836",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.286 370.804C836.309 370.804 839.57 374.065 839.57 378.088C839.57 382.112 836.309 385.373 832.286 385.373C828.262 385.373 825.001 382.112 825.001 378.088C825.001 374.065 828.262 370.804 832.286 370.804Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.286 373.535H832.895C836.082 373.535 838.66 376.118 838.66 379.301C838.66 382.488 836.077 385.066 832.895 385.066H832.286C829.099 385.066 826.521 382.483 826.521 379.301C826.521 376.114 829.104 373.535 832.286 373.535Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.984 379V394.479",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.229 379.606L831.979 383.857",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.039 379.606L832.29 383.857",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.835 394.479C790.835 394.479 790.729 394.349 790.678 394.284C788.661 391.678 789.265 387.784 792.187 385.963L797.535 382.637C798.362 382.126 799.412 382.144 800.211 382.693L804.959 385.931C807.732 387.826 808.332 391.575 806.487 394.224C806.427 394.307 806.301 394.479 806.301 394.479H790.84H790.835Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.797 394.12C789.976 391.932 790.561 388.633 793.023 387.202L798.928 383.778C799.583 383.402 800.391 383.411 801.028 383.802L805.074 386.273C807.955 388.029 808.159 392.132 805.469 394.166C805.409 394.213 805.33 394.241 805.246 394.241H792.066C791.959 394.241 791.862 394.194 791.792 394.115L791.797 394.12Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.99 389.925V394.478",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.935 388.711L797.99 392.354",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.957 390.534L797.991 393.874",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.13 394.478C831.13 394.478 831.803 394.018 832.105 393.735L832.923 392.968C833.197 392.717 833.392 392.402 833.494 392.048L833.573 391.788C834.145 389.86 831.808 388.406 830.331 389.777V388.745C830.331 386.622 827.659 385.67 826.317 387.319C826.958 384.755 824.017 382.808 821.903 384.406L821.304 384.861L821.146 384.355C820.574 382.594 818.665 381.651 816.923 382.278C815.185 382.906 814.312 384.843 814.995 386.557L815.297 387.319C812.718 387.319 811.274 390.297 812.876 392.323L814.084 393.856C814.265 394.088 814.697 394.478 814.697 394.478H831.13Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.368 394.478L817.111 389.316",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.088 392.448L821.666 388.104",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.613 394.479L828.95 391.445",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.608 390.534L827.931 392.764",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.421 394.48L817.721 385.073",
    stroke: "#615E66",
    strokeWidth: 0.464579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 427.049H1919V457.586H0V427.049Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.66 436.766L10.6811 436.588",
    stroke: "white",
    strokeWidth: 0.984558,
    strokeDasharray: "4.92 4.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 457.073H1919V464.95H0V457.073Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 419.167H1919V427.043H0V419.167Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 411.832H1919V423.999H0.00012207V411.832Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918 424H1521.2L1653.47 420.45H1810.9L1918 424Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.69 424H1181.59L1294.54 420.45H1451.97L1645.68 424H1645.69Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.29 424H529.625L718.661 420.45H1086.78L1241.29 424Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.15 614.956V461.36L-25.0323 461.36V614.956L1904.15 614.956Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923 614.819H-25.5498V597.9H1923V614.819Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227 491L308.45 495L593.45 598H1262.45L1227 491Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.45 495H-36.5498L-37.5498 518H236.874C237.918 518 238.956 518.163 239.95 518.484L306.13 539.871L444.45 598H593.45L308.45 495Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.45 598L306.13 539.871H-26.1948L-25.5498 598H444.45Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.45 598L1546.45 597.5L1918.45 598L1923 526.501L1454.45 525.169C1415.68 525.058 1377.47 515.934 1342.84 498.517L1328.17 491.139C1323.44 488.761 1325.16 481.629 1330.45 481.672L1933 486.5V469.5L1233.75 467.619C1221.03 467.585 1216.22 484.243 1227 491V491L1262.45 598H1417.45Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.71 523.879C1551.71 523.879 1556.05 520.805 1556.18 517.605C1556.3 514.404 1550.36 517.605 1550.36 517.605C1550.36 517.605 1551.35 516.23 1549.99 515.874C1548.64 515.524 1545.66 517.796 1545.66 517.796C1545.66 517.796 1545.58 511.777 1540.05 511.221C1534.53 510.666 1532.96 513.953 1532.96 513.953C1532.96 513.953 1531.89 511.522 1529.83 511.476C1527.77 511.435 1528.09 513.27 1528.09 513.27C1528.09 513.27 1525.45 510.283 1519.02 510.88C1512.59 511.476 1511.52 516.129 1511.52 516.129C1511.52 516.129 1509.48 514.627 1507.56 514.946C1505.65 515.264 1506.88 518.497 1506.88 518.497C1506.88 518.497 1503.42 514.335 1501.07 514.304C1498.72 514.272 1500.33 517.855 1500.33 517.855C1500.33 517.855 1497.8 513.407 1490 512.573C1482.21 511.74 1484.99 517.336 1484.99 517.336C1484.99 517.336 1481.84 515.647 1479.99 516.125C1478.14 516.603 1481.66 519.936 1481.66 519.936C1481.66 519.936 1477.14 518.237 1474.3 518.943C1471.45 519.649 1477.47 523.874 1477.47 523.874H1551.7L1551.71 523.879Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.12 598.175C1339.12 598.175 1343.47 595.101 1343.59 591.9C1343.72 588.7 1337.78 591.9 1337.78 591.9C1337.78 591.9 1338.77 590.525 1337.41 590.17C1336.05 589.82 1333.08 592.092 1333.08 592.092C1333.08 592.092 1333 586.072 1327.47 585.517C1321.94 584.961 1320.38 588.249 1320.38 588.249C1320.38 588.249 1319.3 585.817 1317.24 585.772C1315.18 585.731 1315.51 587.566 1315.51 587.566C1315.51 587.566 1312.87 584.579 1306.44 585.175C1300.01 585.772 1298.93 590.425 1298.93 590.425C1298.93 590.425 1296.89 588.923 1294.98 589.241C1293.06 589.56 1294.3 592.793 1294.3 592.793C1294.3 592.793 1290.83 588.631 1288.48 588.599C1286.13 588.568 1287.74 592.151 1287.74 592.151C1287.74 592.151 1285.21 587.702 1277.42 586.869C1269.62 586.036 1272.41 591.632 1272.41 591.632C1272.41 591.632 1269.25 589.943 1267.4 590.421C1265.55 590.899 1269.07 594.232 1269.07 594.232C1269.07 594.232 1264.56 592.533 1261.71 593.239C1258.87 593.945 1264.88 598.17 1264.88 598.17H1339.11L1339.12 598.175Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.057 518.654C233.057 518.654 236.14 516.474 236.227 514.204C236.315 511.934 232.105 514.204 232.105 514.204C232.105 514.204 232.805 513.229 231.842 512.977C230.88 512.729 228.77 514.34 228.77 514.34C228.77 514.34 228.713 510.071 224.791 509.677C220.874 509.283 219.763 511.614 219.763 511.614C219.763 511.614 219.001 509.89 217.539 509.858C216.078 509.829 216.309 511.13 216.309 511.13C216.309 511.13 214.436 509.012 209.876 509.435C205.316 509.858 204.554 513.158 204.554 513.158C204.554 513.158 203.108 512.092 201.749 512.318C200.39 512.544 201.265 514.837 201.265 514.837C201.265 514.837 198.81 511.886 197.143 511.863C195.475 511.841 196.618 514.382 196.618 514.382C196.618 514.382 194.822 511.227 189.294 510.636C183.766 510.045 185.743 514.014 185.743 514.014C185.743 514.014 183.504 512.816 182.192 513.155C180.879 513.494 183.375 515.858 183.375 515.858C183.375 515.858 180.174 514.653 178.157 515.154C176.139 515.654 180.406 518.651 180.406 518.651H233.052L233.057 518.654Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.354609
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.747 588.68C418.747 588.68 410.156 591.085 413.346 598.661H472.951C473.623 597.642 474.108 596.466 474.252 595.126C471.416 589.749 466.4 590.297 466.4 590.297C466.4 590.297 468.841 587.985 467.557 587.653C466.274 587.322 464.084 588.493 464.084 588.493C464.084 588.493 466.017 584.612 460.612 585.19C455.206 585.768 453.45 588.853 453.45 588.853C453.45 588.853 454.567 586.368 452.936 586.39C451.305 586.412 448.905 589.299 448.905 589.299C448.905 589.299 449.76 587.057 448.432 586.836C447.103 586.614 445.689 587.657 445.689 587.657C445.689 587.657 444.944 584.429 440.484 584.016C436.025 583.602 434.193 585.673 434.193 585.673C434.193 585.673 434.42 584.401 432.99 584.429C431.561 584.461 430.816 586.147 430.816 586.147C430.816 586.147 429.729 583.867 425.899 584.252C422.063 584.638 422.008 588.812 422.008 588.812C422.008 588.812 419.944 587.237 419.003 587.48C418.062 587.726 418.747 588.68 418.747 588.68Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_44765",
    x1: 173.95,
    y1: -0.000041539,
    x2: 1896.09,
    y2: 1016.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6001_44765",
    x1: 77.6025,
    y1: 674.699,
    x2: 239.912,
    y2: 1450.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6001_44765",
    x1: 960.922,
    y1: 612.326,
    x2: 960.922,
    y2: 634.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6001_44765",
    x1: 3586.67,
    y1: 476.611,
    x2: 3586.67,
    y2: 211.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6001_44765",
    x1: 3586.67,
    y1: 476.611,
    x2: 3586.67,
    y2: 211.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6001_44765",
    x1: 880.962,
    y1: 419.09,
    x2: 892.809,
    y2: 417.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6001_44765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 634,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlan);
export default __webpack_public_path__ + "static/media/BackPlan.4e74ded9a54f3dce06e9.svg";
export { ForwardRef as ReactComponent };